var transitionDuration = 300;
var canCheckout = false;
if (localStorage.getItem("charleys_override_can_checkout")) {
  canCheckout = true;
  localStorage.removeItem("charleys_override_can_checkout");
}
var checkoutFrame = {};
var userHasSearched = false;

var $contentContainer = jQuery(".wf-ordering-container");
var templateRoot = "/wp-content/themes/Charleys/parts/block/templates/";

var phonesMasks = [
  { mask: "(###) ###-####" },
  { mask: "(###) ###-##############" },
];
var dateMasks = [{ mask: "##/##" }];
function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
// Document Ready Actions
jQuery(document).ready(function ($) {

  //single use button util 
  $('button[showsingleuseproducts]').click(function () {
    change_view("menu");
    localStorage.setItem('readOnlyCategoryMenuItemCarryOver', 'CHOOSE FROM THE FOLLOWING:');
  });
  // console.log('doc loaded', $("[data-add-another-menu-item]"));

  $("a[data-header-account-link]").click(function (e) {
    e.preventDefault();
    if ($("#shopping-cart-view").is(":visible")) {
      $("#shopping-cart-view").foundation("close");
      $(".reveal-overlay").removeClass('differnt-popup-overlay');
    }
    if ($("#product-detail-view").is(":visible")) {
      $("#product-detail-view").foundation("close");
      $(".reveal-overlay").removeClass('differnt-popup-overlay');
    }
    var accountNavDropdown = $(this).attr("data-toggle");
    if (isUserLoggedIn(true)) {
      // console.log("user is logged in");
      $("#" + accountNavDropdown).removeClass("hide");
      $('.signInButton').addClass("hide");
      $('.accountButton').removeClass("hide");
      // console.log(accountNavDropdown);
      // $('#'+accountNavDropdown).foundation('toggle');
    } else {
      // console.log("user is NOT logged in");
      // accountNavDropdown.addClass('hide');
      $("#" + accountNavDropdown).addClass("hide");
      $('.signInButton').removeClass("hide");
      $('.accountButton').addClass("hide");

      window.location.href = $(this).attr("href");
    }
  });
  if (isUserLoggedIn(true)) {
    // console.log('#1');
    $('.accountButton').removeClass("hide");
    $('.signInButton').addClass("hide");
  } else {
    // console.log('#2');
    $('.accountButton').addClass("hide");
    $('.signInButton').removeClass("hide");
  }

  if ($(".wf-ordering").length) {
    $("[data-header-order-link]").addClass("hide");
    $("[data-header-ecomm-link]").removeClass("hide");

    // if the page is visited with a store id in tow, set the store to the customer's store as their entry point was likely from an "order now" link
    if (
      urlParam("storeid") &&
      (urlParam("storeid") !==
        localStorage.getItem("charleys_visitor_nearest_location_id") ||
        urlParam("storeid") !==
        localStorage.getItem("charleys_customer_store_location_id"))
    ) {
      charleys_show_overloading();
      // console.log('-- Set Store --'); 

      setAsStore(urlParam("storeid"));

      setTimeout(function () {
        var hash = $(location).attr("hash");
        history.replaceState &&
          history.replaceState(
            null,
            "",
            location.pathname +
            location.search
              .replace(/[\?&]storeid=[^&]+/, "")
              .replace(/^&/, "?") +
            hash
          );
        // console.log('-- RELOAD --');
        location.reload();
      }, 750);
    }

    charleys_get_route();
    updateBasketDisplay();

    // De-sticky to the top navigation
    if ($("header.header").length) {
      $("header.header").foundation("_destroy");
    }

    // Guest Checkout User Info
    $("#guest-first-name").val(
      localStorage.getItem("charleys_customer_guest_first_name")
    );
    $("#guest-last-name").val(
      localStorage.getItem("charleys_customer_guest_last_name")
    );
    $("#guest-email-address").val(
      localStorage.getItem("charleys_customer_guest_email_address")
    );
    $("#guest-phone-number").val(
      localStorage.getItem("charleys_customer_guest_phone_number")
    );

    $("#guest-signin-prompt").submit(function (e) {
      e.preventDefault();
    });

    $("#guest-signin-prompt").bind("formvalid.zf.abide", function (e, target) {
      e.preventDefault();
      localStorage.setItem(
        "charleys_customer_guest_first_name",
        $("#guest-first-name").val()
      );
      localStorage.setItem(
        "charleys_customer_guest_last_name",
        $("#guest-last-name").val()
      );
      localStorage.setItem(
        "charleys_customer_guest_email_address",
        $("#guest-email-address").val()
      );
      localStorage.setItem(
        "charleys_customer_guest_phone_number",
        $("#guest-phone-number").val()
      );

      $("#guest-signin-prompt").foundation("close");
      change_view("checkout");
    });

    $('#continue-as-guest').click(function (e) {
      e.preventDefault();
    });

    $(".cart-favorite-button").click(function () {
      $(".cart-favorite-order").foundation("open");
    });

    $(".cart-confirm-favorite-button").click(function () {
      $.ajax({
        type: "POST",
        url: ajax_url,
        data: {
          action: "olo_set_fave",
          authtoken: localStorage.getItem("charleys_auth_token"),
          basketid: localStorage.getItem("charleys_customer_basket_id"),
          description: $("[data-cart-favorite-order-description]").val(),
        },
        success: function (response) {
          fave_result = JSON.parse(response);

          if (fave_result.code == 200) {
            alert(fave_result.message);
            $(".cart-favorite-order").foundation("open");
          } else if (fave_result.faves[0].id) {
            $("[data-fave-id]").text(fave_result.faves[0].id);

            $(".cart-favorite-button").addClass("location-favorite-active");
          }
        },
      });
    });

    // Remove reveal modal
    $(".cart-favorite-order").each(function () {
      if (typeof $(this).attr("aria-hidden") !== "undefined") {
        $(this).parent().remove();
      }
    });

    // Recreate reveal modals
    var $favorite_reveal = new Foundation.Reveal($("#cart-favorite-order"), {});

    // $("input#guest-phone-number").keyup(function() {
    //   $(this).val($(this).val().replace(/^(\d{3})(\d{3})(\d+)$/, "($1)$2-$3"));
    // });
    $("input#guest-phone-number").inputmask({
      mask: phonesMasks,
      greedy: false,
      definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
    });

    // Reload upsell items on cart open
    $("#shopping-cart-view").on("open.zf.reveal", function () {
      if ($("#cart-upsell-items-list").length) {
        $("#cart-upsell-items-list").slick("refresh");
      }
      $(".reveal-overlay").addClass('differnt-popup-overlay');
    });
  }

  //when [data-add-another-menu-item] button is clicked, load wf-ordering-menu template into view
  $("[data-add-another-menu-item]").click(function () {
    change_view("menu");
  });
  $("ul.menu li.specific-menu").click(function () {
    // console.log('ahh');
    change_view("menu");
  });

  //when .edit-button clicked, load .wf-ordering-start-order template
  $("[data-edit-location-button]").click(function () {
    // change_view("start-order");
    $("#shopping-cart-view").foundation("close");
    $("#checkout-edit-store-location").foundation("open");
    $(".reveal-overlay").removeClass('differnt-popup-overlay');
  });

  // Change store location form action
  $("#change-store-location").click(function () {
    change_view("start-order");
  });

  // Change order type
  $("#change-order-type").click(function () {
    change_view("start-order");
  });
});

jQuery(window).on("hashchange", function (e) {
  if (jQuery(".wf-ordering").length) {
    // console.log("hashchange");
    charleys_get_route();
    // updateBasketDisplay();
    window.scrollTo(0, 0);
  }
});

// Changes the current view
function change_view(hash) {
  // console.log("change view: ", hash);
  var $ = jQuery;



  if (window.location.href.indexOf("/order") > -1) {
    history.pushState(null, null, "#" + hash);
    $(window).trigger("hashchange");
  } else {
    window.location.href = "/order/#" + hash;
  }
  if ((hash == "checkout") && (hash != "order")) {
    $('body.page-id-18022').addClass('checkout-page');
  } else {
    $('body.page-id-18022').removeClass('checkout-page');
  }
  if (hash) {
    // console.log('sdghasdg');
    $('.homepage-order-status.order-tracker').addClass('hide');
  } else {
    const currentPath = window.location.pathname;

    // console.log('asdghasdg', currentPath);
    $('.homepage-order-status.order-tracker').removeClass('hide');
  }
} // change_view

// Routes view dependent on the url hash
function charleys_get_route() {
  // console.log("routing");
  var route = "";
  var $ = jQuery;

  if (window.location.hash) {
    route = window.location.hash.substr(1);
  }
  route = route.split("_")[0];

  charleys_show_topnav();
  charleys_show_topnav_location();

  // Empty of all elements inside
  $contentContainer.empty();

  switch (route) {
    case "menu":
    case "menu-product-view":
      view_menu();
      break; // end view-menu
    case "menu-cart":
      view_menu(true);
      break;
    case "checkout":
      view_checkout();
      break;

    case "order-status":
    case "order-complete":
      view_order_complete();
      break;

    case "signup":
      view_signup();
      break; // end signup

    case "login":
      view_login();
      break; // end login

    case "forgotpass":
      // console.log("forgotpass");
      view_forgotpassword();
      break;

    case "signout":
      view_signout();
      break; // end signout

    case "account":
      if (isUserLoggedIn()) {
        view_account();
      } else {
        change_view("login");
      }
      break; // end my-account

    case "account-manage":
      if (isUserLoggedIn()) {
        view_account_manage();
      } else {
        change_view("login");
      }
      break; // end my-account

    case "account-recent":
      if (isUserLoggedIn()) {
        view_account_recent();
      } else {
        change_view("login");
      }
      break;

    case "account-favorite":
      if (isUserLoggedIn()) {
        view_account_favorite();
      } else {
        change_view("login");
      }
      break;

    case "account-rewards":
      if (isUserLoggedIn()) {
        view_account_rewards();
      } else {
        change_view("login");
      }
      break;

    // case "location-detail":
    //   view_location_detail();
    //   break;

    case "":
    case "home":
    case "find-store":
    case "start-order":
    default: // Ref: wp-content/themes/Charleys/assets/scripts/js/block/wf-ordering-view-start-order.js
      view_start_order();
      break;
    // view_home();
    // break; // end '', 'home', default
  } // end Switch (template routing & actions)
}

// check if auth token is still valid
function isUserLoggedIn(softCheck = false) {
  var $ = jQuery;

  // console.log("check user statuss");

  // Just look for the stored auth token, no need to query OLO to validate
  if (softCheck) {
    return Boolean(localStorage.getItem("charleys_auth_token"));
  }

  if (localStorage.getItem("charleys_auth_token")) {
    var isLoggedIn = false;

    return $.ajax({
      type: 'POST',
      url: ajax_url,
      async: false,
      data: {
        action: 'olo_user_authtoken_status',
        authtoken: localStorage.getItem('charleys_auth_token')
      },
      success: function (response) {
        isLoggedIn = (response === "true");
        if (!isLoggedIn) {
          signout();
        }
        return isLoggedIn;
      }
    });

    return isLoggedIn;

  } else {
    // console.log('#3');
    $('.accountButton').addClass("hide");
    $('.signInButton').removeClass("hide");
    return false;
  }

}

// View: Location Detail
// function view_location_detail() {
//   var $ = jQuery;
//
//   charleys_hide_topnav_location();
//   charleys_show_loading();
//
//   $contentContainer
//     .load(templateRoot + "wf-ordering-location-detail.html", function () {
//       $('input[name="location-detail-order-type"]').change(function () {
//         if (
//           $('input[name="location-detail-order-type"]:checked').val() !==
//           "dispatch"
//         ) {
//           $("[data-search-pickup]").removeClass("hide");
//           $("[data-search-deliver]").addClass("hide");
//           $("#location-detail-order-location-search-building").val("");
//         } else {
//           $("[data-search-pickup]").addClass("hide");
//           $("[data-search-deliver]").removeClass("hide");
//         }
//       });
//
//       // Hide/show schedule elements
//       $('input[name="location-detail-order-schedule"]').change(function () {
//         if (
//           $('input[name="location-detail-order-schedule"]:checked').val() ==
//           "advance"
//         ) {
//           $("#location-detail-schedule-time").removeClass("hide");
//         } else {
//           $("#location-detail-schedule-time").addClass("hide");
//         }
//         // console.log($('input[name="order-schedule"]:checked').val());
//       });
//
//       var todaysDate = new Date();
//       var tomorrowsDate = new Date().addDays(1);
//       var scheduleDates = getDates(todaysDate, new Date().addDays(45));
//       var daysOfWeek = [
//         "Sunday",
//         "Monday",
//         "Tuesday",
//         "Wednesday",
//         "Thursday",
//         "Friday",
//         "Saturday",
//       ];
//
//       for (var i = 0; i < scheduleDates.length; i++) {
//         var dayValue =
//           scheduleDates[i].getFullYear() +
//           "-" +
//           zeroPad(scheduleDates[i].getMonth() + 1, 2) +
//           "-" +
//           zeroPad(scheduleDates[i].getDate(), 2);
//         var dayLabel =
//           daysOfWeek[scheduleDates[i].getDay()] +
//           " " +
//           (scheduleDates[i].getMonth() + 1) +
//           "/" +
//           scheduleDates[i].getDate();
//
//         if (scheduleDates[i].getTime() === todaysDate.getTime()) {
//           dayLabel = "Today";
//         }
//         if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
//           dayLabel = "Tomorrow";
//         }
//
//         $("[data-order-location-detail-time-wanted-day]").append(
//           '<option value="' + dayValue + '">' + dayLabel + "</option>"
//         );
//       }
//
//       var timeSelection = createQuarterHourIntervals();
//
//       for (var ii = 0; ii < timeSelection.length; ii++) {
//         $("[data-order-location-detail-time-wanted-time]").append(
//           '<option value="' +
//             convert12to24Hour(timeSelection[ii]) +
//             '">' +
//             timeSelection[ii] +
//             "</option>"
//         );
//       }
//
//       $("select#location-detail-time-wanted-day").change(function () {
//         if (
//           $(
//             'select#location-detail-time-wanted-day option[value="' +
//               $(this).val() +
//               '"]'
//           ).text() == "Today"
//         ) {
//           var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
//           console.log(currentTime);
//           $("select#location-detail-time-wanted-time-slot option").each(
//             function () {
//               if ($(this).val() < currentTime) {
//                 $(this).addClass("hide");
//               }
//               $("select#location-detail-time-wanted-time-slot").val(
//                 currentTime
//               );
//             }
//           );
//         } else {
//           $("select#location-detail-time-wanted-time-slot option").each(
//             function () {
//               $(this).removeClass("hide");
//             }
//           );
//         }
//       });
//
//       $("select#location-detail-time-wanted-day").trigger("change");
//
//       // Autocomplete for location search
//       if ($("#location-detail-order-location-search-delivery").length) {
//         const inputD = $("#location-detail-order-location-search-delivery")[0];
//         const options = {
//           // componentRestrictions: { country: "us" },
//           fields: ["address_components", "geometry"],
//           strictBounds: false,
//           // types: ['(regions)'],
//         };
//
//         const autocompleteD = new google.maps.places.Autocomplete(
//           inputD,
//           options
//         );
//         autocompleteD.addListener("place_changed", function () {
//           const place = autocompleteD.getPlace();
//           if (place.geometry) {
//             // ttmap.systemZoomChange = true;
//             // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
//             olo_get_nearby_locations(
//               place.geometry.location.lat(),
//               place.geometry.location.lng(),
//               "",
//               "location-detail"
//             );
//             // console.log(place);
//
//             var components = {};
//             $.each(place.address_components, function (k, v1) {
//               $.each(v1.types, function (k2, v2) {
//                 components[v2] = v1.long_name;
//               });
//             });
//
//             if (components.street_number && components.route) {
//               $("#location-detail-order-location-search-streetaddress").val(
//                 components.street_number + " " + components.route
//               );
//             }
//             $("#location-detail-order-location-search-city").val(
//               components.locality
//             );
//             $("#location-detail-order-location-search-zipcode").val(
//               components.postal_code
//             );
//
//             // console.log($('#order-location-search-streetaddress').val());
//             // console.log($('#order-location-search-city').val());
//             // console.log($('#order-location-search-zipcode').val());
//           }
//         });
//
//         $("#location-detail-order-location-search-form").submit(function (e) {
//           e.preventDefault();
//
//           console.log("search locations");
//
//           $("#location-detail-order-location-search").blur();
//
//           var address = $("#location-detail-order-location-search").val();
//           var geocoder = new google.maps.Geocoder();
//
//           if (address.length) {
//             geocoder.geocode(
//               {
//                 address: address,
//               },
//               function (results, status) {
//                 console.log("GEOCODER STATUS ", status, results);
//                 if (status == google.maps.GeocoderStatus.OK) {
//                   // console.log(results);
//
//                   var components = {};
//                   $.each(results[0].address_components, function (k, v1) {
//                     $.each(v1.types, function (k2, v2) {
//                       components[v2] = v1.long_name;
//                     });
//                   });
//
//                   // console.log('address components', components);
//
//                   if (components.street_number && components.route) {
//                     $(
//                       "#location-detail-order-location-search-streetaddress"
//                     ).val(components.street_number + " " + components.route);
//                   }
//                   $("#location-detail-order-location-search-city").val(
//                     components.locality
//                   );
//                   $("#location-detail-order-location-search-zipcode").val(
//                     components.postal_code
//                   );
//
//                   olo_get_nearby_locations(
//                     results[0].geometry.location.lat(),
//                     results[0].geometry.location.lng(),
//                     "",
//                     "location-detail"
//                   );
//                 } else {
//                   $("#location-detail-order-location-search").val("");
//                   charleys_hide_loading();
//                 }
//               }
//             );
//           } else {
//             charleys_hide_loading();
//           }
//         });
//         // initMap();
//       }
//
//       $("#location-detail-select-order-type-button").click(function () {
//         //$('#' + view_context + '-select-order-type').foundation('close');
//
//         var validAddress = true;
//         var isDelivery = Boolean(
//           $('input[name="location-detail-order-type"]:checked').val() ==
//             "dispatch"
//         );
//         console.log("location id");
//         console.log($(this).closest(".location-item").attr("data-location-id"));
//         var vendorid = $(this)
//           .closest(".location-item")
//           .attr("data-location-id");
//         var supportsbaskettransfers =
//           $(this)
//             .closest(".location-item")
//             .attr("data-supportsbaskettransfers") == "true";
//
//         // Delivery requires a full address, thus fails validation if no street address is present
//         if (
//           isDelivery &&
//           !$("#location-detail-order-location-search-streetaddress").val()
//             .length
//         ) {
//           validAddress = false;
//         }
//
//         console.log("validAddress", validAddress);
//
//         $("#location-detail-order-location-search").removeClass("form-alert");
//         $("#location-detail-order-location-search-error").addClass("hide");
//
//         if (validAddress) {
//           charleys_show_loading();
//           setAddressComponents("location-detail");
//           selectLocation(
//             vendorid,
//             supportsbaskettransfers,
//             false,
//             "location-detail"
//           );
//         } else {
//           $("#location-detail-order-location-search").addClass("form-alert");
//           $("#location-detail-order-location-search-error").removeClass("hide");
//         }
//       });
//
//       $(".location-favorite").click(function (e) {
//         e.stopPropagation();
//         if (!$(this).hasClass("location-favorite-active")) {
//
//           olo_delete_fave_location(
//             $(".location-favorite-active")
//               .closest(".location-item")
//               .data("location-id")
//           );
//
//           // $(".location-favorite-active").find(".fa-star").addClass("fa-star-o");
//
//           // $(".location-favorite-active")
//           //   .find(".fa-star")
//           //   .removeClass("fa-star");
//
//           $(".location-favorite-active").removeClass(
//             "location-favorite-active"
//           );
//
//           olo_set_fave_location(
//             $(this).closest(".location-item").data("location-id")
//           );
//
//           $(this).addClass('current-location');
//
//           // $(this).find(".fa-star-o").addClass("fa-star");
//           // $(this).find(".fa-star-o").removeClass("fa-star-o");
//           $(this).addClass("location-favorite-active");
//         }
//       });
//
//       const params = new Proxy(new URLSearchParams(window.location.search), {
//         get: (searchParams, prop) => searchParams.get(prop),
//       });
//       var vendorid = params.vendorid;
//
//       $.ajax({
//         type: "POST",
//         url: ajax_url,
//         data: {
//           action: "olo_get_restaurant",
//           restaurant_id: vendorid,
//         },
//         success: function (response) {
//           var result = JSON.parse(response);
//           console.log("result");
//           console.log(result);
//           if (result.id) {
//             var vendorid = result.id;
//
//             $("[data-location-id]").attr("data-location-id", result.id);
//             $("[data-location-name]").text(result.name);
//             $("[data-location-address]").text(result.streetaddress);
//             $("[data-location-city-zip]").text(
//               result.city + ", " + result.state + " " + result.zip
//             );
//             $("[data-location-phone]").text(result.telephone);
//
//             if (!result.canpickup) {
//               $("label[for='pickup']").hide();
//               if ($("#pickup").prop("checked")) {
//                 $("#pickup").prop("checked", false);
//                 $("#curbside").prop("checked", true);
//               }
//             }
//
//             if (!result.supportscurbside) {
//               $("label[for='curbside']").hide();
//               if ($("#curbside").prop("checked")) {
//                 $("#curbside").prop("checked", false);
//                 $("#dispatch").prop("checked", true);
//               }
//             }
//
//             if (!result.supportsdinein) {
//               $("label[for='dinein']").hide();
//               if ($("#dinein").prop("checked")) {
//                 $("#dinein").prop("checked", false);
//                 $("#dispatch").prop("checked", true);
//               }
//             }
//
//             if (!result.supportsdispatch) {
//               $("label[for='dispatch']").hide();
//             }
//
//             result.calendar.forEach(function (hourscalendar) {
//               var hourstype;
//
//               switch (hourscalendar.type) {
//                 case "business":
//                   hourstype = "dinein";
//                   break;
//                 case "curbsidepickup":
//                   hourstype = "curbside";
//                   break;
//                 case "dispatch":
//                   hourstype = "delivery";
//                   break;
//               }
//
//               hourscalendar.ranges.forEach(function (range) {
//                 var weekday = range.weekday.toLowerCase();
//
//                 // format the stupid nonstandard olo dates
//                 var startDateRaw = range.start;
//                 var endDateRaw = range.end;
//
//                 var jsStartDate = new Date(
//                   startDateRaw.substring(0, 4),
//                   startDateRaw.substring(4, 6),
//                   startDateRaw.substring(6, 8),
//                   startDateRaw.substring(9, 11),
//                   startDateRaw.substring(12, 14),
//                   0,
//                   0
//                 );
//                 var jsEndDate = new Date(
//                   endDateRaw.substring(0, 4),
//                   endDateRaw.substring(4, 6),
//                   endDateRaw.substring(6, 8),
//                   endDateRaw.substring(9, 11),
//                   endDateRaw.substring(12, 14),
//                   0,
//                   0
//                 );
//
//                 var startTimeFormatted = jsStartDate.toLocaleString("en-US", {
//                   hour: "numeric",
//                   minute: "numeric",
//                   hour12: true,
//                 });
//                 var endTimeFormatted = jsEndDate.toLocaleString("en-US", {
//                   hour: "numeric",
//                   minute: "numeric",
//                   hour12: true,
//                 });
//
//                 $("#hours-" + hourstype)
//                   .find("[data-hours-" + weekday + "]")
//                   .text(startTimeFormatted + " - " + endTimeFormatted);
//               });
//
//               // set fave button status
//               $.ajax({
//                 type: "POST",
//                 url: ajax_url,
//                 data: {
//                   action: "olo_get_fave_locations",
//                   authtoken: localStorage.getItem("charleys_auth_token"),
//                 },
//                 success: function (response) {
//                   result = JSON.parse(response);
//
//                   var is_fave = false;
//                   if ("favelocations" in result) {
//                     result.favelocations.every(function (fave) {
//                       if (fave.vendorid == vendorid) {
//                         is_fave = true;
//                       }
//                       return !is_fave;
//                     });
//                   }
//
//                   if (is_fave) {
//                     $(".location-favorite").addClass(
//                       "location-favorite-active"
//                     );
//                     $(".location-favorite")
//                       .find(".fa-star-o")
//                       .addClass("fa-star");
//                     $(".location-favorite")
//                       .find(".fa-star-o")
//                       .removeClass("fa-star-o");
//                   }
//                 },
//               });
//             });
//           }
//
//           charleys_hide_loading();
//         },
//       });
//
//       $(".order-button").click(function () {
//         if (
//           $("#location-detail-select-order-type-embedded").hasClass(
//             "location-order-type-container-hidden"
//           )
//         ) {
//           $("#location-detail-select-order-type-embedded").removeClass(
//             "location-order-type-container-hidden"
//           );
//         } else {
//           $("#location-detail-select-order-type-embedded").addClass(
//             "location-order-type-container-hidden"
//           );
//         }
//       });
//
//       $(".hours-tab-title").click(function () {
//         $(".hours-tab-title").removeClass("active");
//         $(this).addClass("active");
//
//         $(".hours-tab-content").addClass("hide");
//         var contentid = $(this).attr("id").replace("tab-", "");
//         $("#" + contentid).removeClass("hide");
//       });
//     })
//     .hide()
//     .fadeIn(transitionDuration);
// } // view_location_detail()

function populate_user_restaurants(view_context) {
  var $ = jQuery;

  // console.log("populate user restaurants", view_context);

  var restaurants = [];
  var location_count = 0;
  var locations_processed = 0;

  // if user navigated from location page, display the location selected there
  if (
    localStorage.getItem("charleys_location_page_location_id") &&
    !localStorage.getItem("charleys_location_page_location_id").includes("wp_")
  ) {
    location_count++;
    // set selected
    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_restaurant",
        restaurant_id: localStorage.getItem(
          "charleys_location_page_location_id"
        ),
        get_calendar: true,
      },
      success: function (response, view_context) {
        var result = JSON.parse(response);
        // console.log("populate_user_restaurants 1", result);
        if (result.id) {
          restaurants.push(result);
          locations_processed++;
        }

        if (locations_processed >= location_count) {
          set_location_selections(restaurants, view_context);
        }
      },
    });
  }

  // If there's already a selected location, display it
  if (
    localStorage.getItem("charleys_customer_store_location_id") &&
    !localStorage.getItem("charleys_customer_store_location_id").includes("wp_")
  ) {
    location_count++;

    // Function to fetch restaurant info by ID
    function fetchRestaurantInfo(restaurantId) {
      return $.ajax({
        type: "POST",
        url: ajax_url,
        data: {
          action: "olo_get_restaurant",
          restaurant_id: restaurantId,
          get_calendar: true,
        }
      }).then(response => {
        var result = JSON.parse(response);
        // console.log("Restaurant info for ID", restaurantId, result);
        return result;
      }).catch(() => {
        console.error("Failed to fetch restaurant info for ID", restaurantId);
        return null;
      });
    }

    // Function to process all restaurants
    function processRestaurants(restaurantIds) {
      var restaurants = [];
      var locations_processed = 0;
      var location_count = restaurantIds.length; // Number of locations to process

      // Fetch info for each restaurant
      var fetchPromises = restaurantIds.map(restaurantId => fetchRestaurantInfo(restaurantId));

      // Wait for all AJAX calls to complete
      $.when.apply($, fetchPromises).then(function () {
        var results = Array.prototype.slice.call(arguments);

        results.forEach(result => {
          if (result && result.id) {
            // Make sure this restaurant isn't already in the list
            var exists = restaurants.some(restaurant => result.id == restaurant.id);

            if (!exists) {
              restaurants.push(result);
            }
            locations_processed++;
          }
        });

        // Check if all locations have been processed
        if (locations_processed >= location_count) {
          set_location_selections(restaurants);
        }
      });
    }

    // Get the customer store location ID and ensure it is processed first
    var customerStoreId = localStorage.getItem("charleys_customer_store_location_id");

    if (customerStoreId) {
      fetchRestaurantInfo(customerStoreId).then(result => {
        var restaurantIds = [
          customerStoreId,
          localStorage.getItem("nearByStore1"),
          localStorage.getItem("nearByStore2"),
          localStorage.getItem("nearByStore3")
        ].filter(Boolean); // Remove null or empty values

        processRestaurants(restaurantIds);
      });
    }
  }


  // If the user has favorite location(s), display them
  if (localStorage.getItem("charleys_auth_token")) {
    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_fave_locations",
        authtoken: localStorage.getItem("charleys_auth_token"),
      },
      success: function (response) {
        result = JSON.parse(response);

        // console.log(Boolean(result.favelocations));

        if (result.favelocations && result.favelocations.length) {
          location_count = location_count + result.favelocations.length;

          result.favelocations.forEach(function (fave) {
            $.ajax({
              type: "POST",
              url: ajax_url,
              data: {
                action: "olo_get_restaurant",
                restaurant_id: fave.vendorid,
                get_calendar: true,
              },
              success: function (response) {
                var result = JSON.parse(response);
                // console.log(
                //   "populate_user_restaurants 3 fav locations",
                //   result
                // );
                if (result.id) {
                  // make sure this restaurant isn't already in the list
                  var exists = false;
                  restaurants.forEach(function (restaurant) {
                    if (result.id == restaurant.id) {
                      exists = true;
                    }
                  });

                  if (!exists) {
                    restaurants.push(result);
                  }

                  locations_processed++;
                }

                if (locations_processed >= location_count) {
                  set_location_selections(restaurants, view_context);
                  charleys_hide_loading();
                }
              },
            });
          });
        } else {
          if (locations_processed >= location_count) {
            set_location_selections(restaurants, view_context);
            charleys_hide_loading();
          }
        }
      },
    });
  } else {
    if (locations_processed >= location_count) {
      set_location_selections(restaurants, view_context);
      charleys_hide_loading();
    }
  }
  //add functionality for map overlay
  function hideOverlay() {
    const overlay = document.querySelector('.location-map-overlay');
    // console.log("Overlay element:", overlay);

    if (overlay) {
      // console.log("Overlay found, setting timeout");
      setTimeout(() => {
        overlay.classList.add('hide');
        // console.log("Class 'hide' added to overlay");
      }, 5000);
    } else {
      // console.log("Overlay not found");
    }
  }
















  // Hide overlay after 5 seconds
  hideOverlay();

  // Add event listener for the close button
  const closeButton = document.getElementById('closeMapOverlay');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      const overlay = document.querySelector('.location-map-overlay');
      if (overlay) {
        overlay.classList.add('hide');
        // console.log("Class 'hide' added to overlay via button click");
      }
    });
  }

  // Add event listener for the search field
  const startOrderInput = document.getElementById('start-order-order-location-search');
  if (startOrderInput) {
    startOrderInput.addEventListener('click', function () {
      const overlay = document.querySelector('.location-map-overlay');
      if (overlay) {
        overlay.classList.add('hide');
        // console.log("Class 'hide' added to overlay via input click");
      }
    });
  }

} // populate_user_restaurants(view_context)

// Move payment method to active state for checkout
function usePayment(billingAccountId) {
  var $ = jQuery;

  // console.log("use payment");

  $("[data-billing-schemes-active]").append(
    $("#billing-account-" + billingAccountId)
  );

  configPaymentOptions();
}

// Remove payment method from active state for checkout
function removePayment(billingAccountId) {
  var $ = jQuery;

  // console.log("remove payment");

  $("[data-billing-accounts-saved]").append(
    $("#billing-account-" + billingAccountId)
  );

  configPaymentOptions();
}

// Configure payment options
function configPaymentOptions() {
  var $ = jQuery;

  var activeCount = $(
    "[data-billing-schemes-active] .active-payment:not(.hide)"
  ).length;

  if (activeCount > 0) {
    $("[data-billing-accounts-saved] .active-payment:not(.hide)").each(
      function () {
        $(this).find("[data-split]").removeClass("hide");
        $(this).find("[data-use]").addClass("hide");
      }
    );
    $("[data-no-payments]").addClass("hide");
  } else {
    $("[data-billing-accounts-saved] .active-payment:not(.hide)").each(
      function () {
        $(this).find("[data-split]").addClass("hide");
        $(this).find("[data-use]").removeClass("hide");
      }
    );
    $("[data-no-payments]").removeClass("hide");
  }

  if ($("[data-billing-accounts-saved] .active-payment:not(.hide)").length) {
    $("#stored-payments").removeClass("hide");
  } else {
    $("#stored-payments").addClass("hide");
  }
  setPaymentSplit();
}

// View: Signup
function view_signup() {
  var $ = jQuery;
  $contentContainer
    .load(templateRoot + "wf-ordering-signup.html", function () {
      activateSignUp($contentContainer.find("#punchh-signup-form"));
    })
    .hide()
    .fadeIn(transitionDuration);
}

// View: Login
function view_login() {
  var $ = jQuery;
  $contentContainer
    .load(templateRoot + "wf-ordering-login.html", function () {
      activateSignIn($contentContainer.find("#punchh-login-form"));
    })
    .hide()
    .fadeIn(transitionDuration);
}

// Function to create signup form
function activateSignUp($formItem) {
  var $ = jQuery;

  // charleys_hide_topnav();
  charleys_show_loading();

  $("input#punchh_phone").inputmask({
    mask: phonesMasks,
    greedy: false,
    definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
  });

  var signUpFormAbide = new Foundation.Abide($formItem, {});

  $("#basketGuid").val(localStorage.getItem("charleys_customer_basket_id"));

  $.when(olo_get_all_restaurants()).done(function (restaurants_json) {
    var $locationDropdown = $("#punchh_location");
    var restaurants = JSON.parse(restaurants_json);

    $.each(restaurants.restaurants, function (key, restaurant) {
      $locationDropdown.append(
        '<option value="' +
        restaurant.id +
        '">' +
        restaurant.name.replace("Charleys ", "") +
        "</option>"
      );
    });

    charleys_hide_loading();
  });

  $formItem.on("submit", function (e) {
    e.preventDefault();
  });
  $formItem.on("formvalid.zf.abide", function (e, target) {
    // alert('valid');
    charleys_show_loading();

    var signup_channel = 'MobileEmail';

    if (typeof punchh_signup_channel !== 'undefined' && punchh_signup_channel.length > 0) {
      signup_channel = punchh_signup_channel;
    }

    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "punchh_signup_user",
        signup_data: {
          first_name: $formItem.find('input[name="first_name"]').val(),
          last_name: $formItem.find('input[name="last_name"]').val(),
          email: $formItem.find('input[name="email"]').val(),
          phone: $formItem
            .find('input[name="phone"]')
            .val()
            .replace(/[^\d.-]/g, ""),
          password: $formItem.find('input[name="password"]').val(),
          password_confirmation: $formItem
            .find('input[name="password_confirm"]')
            .val(),
          "signup_channel": signup_channel,
          // "favourite_location_ids" : $contentContainer.find('select[name="location"]').val()
        },
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        var result = JSON.parse(response);

        // Check for errors
        if (result.data.errors !== undefined) {
          // errors found
          charleys_set_form_errors(result.data.errors, $formItem);
          charleys_hide_loading();
        } else {
          // success
          if (typeof result.data.access_token !== "undefined") {
            // Login User
            punchh_olo_sso(result.data.access_token, result.data.user_id, true);
            $("#login-rewards-prompt-view").foundation("close");
            $("#thanks-prompt-view").foundation("open");
          } else {
            // Throw generic error
          }
        }
      },
    });
  });
}

//function to create login form
function activateSignIn($formItem) {
  var $ = jQuery;

  var loginFormAbide = new Foundation.Abide($formItem, {});

  // console.log($formItem.length);

  $("#basketGuid").val(localStorage.getItem("charleys_customer_basket_id"));

  $formItem.on("submit", function (e) {
    e.preventDefault();
  });
  $formItem.on("formvalid.zf.abide", function (e, target) {
    // alert('valid');
    // console.log("data");
    charleys_show_loading();
    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "punchh_login_user",
        login_data: {
          email: $("#punchh-login-form").find('input[name="email"]').val(),
          password: $("#punchh-login-form")
            .find('input[name="password"]')
            .val(),
        },
        recaptcha: $("#g-recaptcha-response").val(),
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        var result = JSON.parse(response);

        // Check for errors
        if (
          result.data == null ||
          "errors" in result.data ||
          "error" in result.data
        ) {
          // errors found
          var formerrors = {};
          if (result.data !== null && result.data.errors !== null) {
            formerrors = result.data.errors;
          }
          if (result.data !== null && result.data.error !== null) {
            formerrors = {
              base: result.data.error,
            };
          }
          charleys_set_form_errors(formerrors, $("#punchh-login-form"));
          charleys_hide_loading();
        } else {
          // success
          if (typeof result.data.access_token !== "undefined") {
            // Login User
            punchh_olo_sso(result.data.access_token, result.data.user_id);
            // charleys_hide_loading();
            $("#login-rewards-prompt-view").foundation("close");
          } else {
            // Throw generic error
          }
        }
      },
    });
  });
}
// View: Forgot Password
function view_forgotpassword() {
  var $ = jQuery;
  $contentContainer
    .load(templateRoot + "wf-ordering-forgotpassword.html", function () {
      activateForgotPassword(
        $contentContainer.find("#punchh-forgotpassword-form")
      );
    })
    .hide()
    .fadeIn(transitionDuration);
}

// Function to create forgot password form
function activateForgotPassword($formItem) {
  var $ = jQuery;

  var forgotPasswordFormAbide = new Foundation.Abide($formItem, {});

  $formItem.on("submit", function (e) {
    e.preventDefault();
  });
  $formItem.on("formvalid.zf.abide", function (e, target) {
    // alert('valid');
    charleys_show_loading();
    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "punchh_forgotpassword_user",
        email: $formItem.find('input[name="email"]').val(),
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        // var result = JSON.parse(response);

        $("[data-abide-success]").show();
        $("[data-abide-error]").hide();

        charleys_hide_loading();
      },
    });
  });
}
// View: Signout
function view_signout() {
  signout();
  change_view("login");
}

function signout() {
  var $ = jQuery;

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_delete_user_authtoken",
      authtoken: localStorage.getItem("charleys_auth_token"),
    },
    success: function (response) { },
  });

  // Remove Access Elements
  localStorage.removeItem("charleys_access_token");
  localStorage.removeItem("charleys_user_id");
  localStorage.removeItem("charleys_auth_token");
  localStorage.removeItem("charleys_customer_membership_id");
  clearBasketSession();
  $('.accountButton').addClass("hide");
  $('.signInButton').removeClass("hide");
}

// View: Home
function view_home() {
  var $ = jQuery;

  charleys_show_topnav();
  charleys_hide_topnav_location();

  // TODO: include modifier costs in prices of order items

  $contentContainer
    .load(templateRoot + "wf-ordering-home.html", function () {
      charleys_show_loading();

      // Remove reveal modal
      $(
        "#account-select-order-type, #home-select-order-type",
        "#menu-select-order-type",
        "#location-detail-select-order-type"
      ).each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      // Recreate reveal modals
      var $select_order_type_reveal = new Foundation.Reveal(
        $("#home-select-order-type"),
        {}
      );

      // Remove reveal modal
      $(".home-add-favorite-order").each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      $(".home-delete-favorite-order").each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      // Recreate reveal modals
      var $add_favorite_reveal = new Foundation.Reveal(
        $("#home-add-favorite-order"),
        {}
      );
      var $delete_favorite_reveal = new Foundation.Reveal(
        $("#home-delete-favorite-order"),
        {}
      );

      $("#home-select-order-type-button").click(function () {
        if ($(".data-order-type-recent-id").text() !== "") {
          startRecentOrder($(".data-order-type-recent-id").text(), "home");
        }

        if ($(".data-order-type-fave-id").text() !== "") {
          startFavoriteOrder($(".data-order-type-fave-id").text(), "home");
        }

        if ($('.data-order-type-location-id:first').text() !== "") {
          startReferralOrder($('.data-order-type-location-id:first').text(), $('.data-order-type-location-sbt:first').text(), 'home');
        }
      });

      // Hide/show schedule elements
      $('input[name="home-order-schedule"]').change(function () {
        if ($('input[name="home-order-schedule"]:checked').val() == "advance") {
          $("#home-schedule-time").removeClass("hide");
        } else {
          $("#home-schedule-time").addClass("hide");
        }
        // console.log($('input[name="order-schedule"]:checked').val());
      });

      var todaysDate = new Date();
      var tomorrowsDate = new Date().addDays(1);
      var scheduleDates = getDates(todaysDate, new Date().addDays(45));
      var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      for (var i = 0; i < scheduleDates.length; i++) {
        var dayValue =
          scheduleDates[i].getFullYear() +
          "-" +
          zeroPad(scheduleDates[i].getMonth() + 1, 2) +
          "-" +
          zeroPad(scheduleDates[i].getDate(), 2);
        var dayLabel =
          daysOfWeek[scheduleDates[i].getDay()] +
          " " +
          (scheduleDates[i].getMonth() + 1) +
          "/" +
          scheduleDates[i].getDate();

        if (scheduleDates[i].getTime() === todaysDate.getTime()) {
          dayLabel = "Today";
        }
        if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
          dayLabel = "Tomorrow";
        }

        $("[data-home-order-time-wanted-day]").append(
          '<option value="' + dayValue + '">' + dayLabel + "</option>"
        );
      }

      var timeSelection = createQuarterHourIntervals();

      for (var ii = 0; ii < timeSelection.length; ii++) {
        $("[data-home-order-time-wanted-time]").append(
          '<option value="' +
          convert12to24Hour(timeSelection[ii]) +
          '">' +
          timeSelection[ii] +
          "</option>"
        );
      }

      $("select#home-time-wanted-day").change(function () {
        if (
          $(
            'select#home-time-wanted-day option[value="' + $(this).val() + '"]'
          ).text() == "Today"
        ) {
          var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
          // console.log(currentTime);
          $("select#home-time-wanted-time-slot option").each(function () {
            if ($(this).val() < currentTime) {
              $(this).addClass("hide");
            }
            $("select#home-time-wanted-time-slot").val(currentTime);
          });
        } else {
          $("select#home-time-wanted-time-slot option").each(function () {
            $(this).removeClass("hide");
          });
        }
      });

      $("select#home-time-wanted-day").trigger("change");

      var totalLoadBeforeComplete = 2; // Will not remove loading overlay until all async elements have loaded

      // Set Hero Section

      var $sliderContainer = $("#order-hero-section");
      $.each(heroSliderData, function (key, slider) {
        var $sliderItem = $("[data-hero-item-template].hide").clone();

        $sliderItem.css({
          "background-image": "url(" + slider.background_image_url + ")",
        });
        $sliderItem
          .find("[data-overlay-text]")
          .html(decodeURIComponent(slider.overlay_text));

        $sliderItem.removeClass("hide");
        $sliderContainer.append($sliderItem);
      });

      $("[data-hero-item-template].hide").remove();

      if ($("#order-hero-section").length) {
        $("#order-hero-section").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          autoplay: false,
          // autoplaySpeed: 4000,
        });
      }

      // Retrieve Recent Orders
      if (isUserLoggedIn()) {
        $.ajax({
          type: "POST",
          url: ajax_url,
          data: {
            action: "olo_get_recent_orders",
            authtoken: localStorage.getItem("charleys_auth_token"),
          },
          success: function (response) {
            var results = JSON.parse(response);

            if (results.orders !== undefined && results.orders.length > 0) {
              totalLoadBeforeComplete++;

              // cache menu for each restaurant
              var menu_results_cache = {};

              var order_locations = [];
              results.orders.forEach(function (order) {
                if (
                  !order_locations.length ||
                  !order_locations.includes(order.vendorid)
                ) {
                  order_locations.push(order.vendorid);
                }
              });

              var menus_cached = 0;
              order_locations.forEach(function (order_location) {
                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "get_olo_get_menu",
                    restaurant_id: order_location,
                  },
                  success: function (response) {
                    menu_results_cache[order_location] = JSON.parse(response);
                    menus_cached++;

                    if (menus_cached == order_locations.length) {
                      results.orders.forEach(function (order) {
                        if (
                          (order.status == "Completed" ||
                            order.status == "In Progress" ||
                            order.status == "Scheduled") &&
                          order.products.length > 0
                        ) {
                          var $recent_order = $(
                            "[data-recent-order-template].hide"
                          ).clone();
                          $recent_order
                            .find("[data-recent-order-title]")
                            .text(order.name);
                          $recent_order
                            .find("[data-recent-order-id]")
                            .text(order.id);
                          $recent_order.find(".recent-order-id").text(order.id);
                          $recent_order
                            .find("[data-recent-order-vendor-id]")
                            .text(order.vendorid);
                          $recent_order
                            .find("[data-recent-order-vendor-name]")
                            .text(order.vendorname);

                          var formatted_date =
                            order.timeplaced.substring(0, 4) +
                            "-" +
                            order.timeplaced.substring(4, 6) +
                            "-" +
                            order.timeplaced.substring(6, 8) +
                            order.timeplaced.substring(8);
                          $recent_order
                            .find("[data-recent-order-date]")
                            .text(formatted_date);
                          $recent_order
                            .find("[data-recent-order-status]")
                            .text(order.status);

                          var status_processed = order.status
                            .toLowerCase()
                            .replace(/ /g, "_");
                          $recent_order
                            .find("[data-status='" + status_processed + "']")
                            .removeClass("hide");

                          // get metadata about favorite menu items from associated restaurant menu
                          var menu_results = menu_results_cache[order.vendorid];

                          order.products.forEach(function (product) {
                            var matched = false;
                            var product_calories;
                            var product_price;
                            var product_image_filename;

                            menu_results.categories.every(function (category) {
                              category.products.every(function (cat_product) {
                                if (product.name == cat_product.name) {
                                  product_calories = cat_product.basecalories;
                                  // product_price = cat_product.cost;
                                  product_image_path = menu_results.imagepath;
                                  product_image_filename =
                                    cat_product.imagefilename;
                                  matched = true;
                                }
                                return !matched;
                              });
                              return !matched;
                            });

                            var $recent_item = $recent_order
                              .find("[data-recent-order-item-template]")
                              .clone();

                            if (product_image_filename != null) {
                              $recent_item
                                .find("img")
                                .attr(
                                  "src",
                                  product_image_path + product_image_filename
                                );
                            } else {
                              $recent_item
                                .find("img")
                                .attr(
                                  "src",
                                  "/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg"
                                );
                            }

                            $recent_item
                              .find("[data-recent-order-item-name]")
                              .text(product.name);
                            if (product_calories != null) {
                              $recent_item
                                .find("[data-recent-order-item-calories]")
                                .text(product_calories + " Calories | ");
                            }
                            // $recent_item.find('[data-recent-order-item-price]').text(product_price);

                            var choiceArray = [];
                            product.choices.forEach(function (choice) {
                              choiceArray.push(choice.name);
                            });

                            $recent_item.removeClass("hide");
                            $recent_item
                              .find("[data-recent-order-item-choices]")
                              .text(choiceArray.join(", "));
                            $recent_item.removeAttr(
                              "data-recent-order-item-template"
                            );
                            $recent_order
                              .find(".recent-order-items")
                              .append($recent_item);
                          });

                          $recent_order.removeClass("hide");
                          $("[data-recent-orders-list]").append($recent_order);

                          $("[data-recent-orders-list]").removeClass("hide");
                          $("[data-recent-orders-loading]").addClass("hide");

                          $(".recent-order-place-button").click(function () {
                            $(".data-order-type-fave-id").text("");
                            $(".data-order-type-recent-id").text(
                              $(this)
                                .closest(".recent-order")
                                .find("[data-recent-order-id]")
                                .text()
                            );
                            window.scrollTo(0, 0);
                            $("#home-select-order-type").foundation("open");
                          });
                        }
                      });

                      $(".home-favorite-button").click(function () {
                        if ($(this).hasClass("location-favorite-active")) {
                          $(
                            ".home-delete-favorite-order-favorite-order-id"
                          ).text(
                            $(this).parent().find(".favorite-order-id").text()
                          );
                          $("#home-delete-favorite-order").foundation("open");
                        } else {
                          $(".home-add-favorite-order-recent-order-id").text(
                            $(this).parent().find(".recent-order-id").text()
                          );
                          $("#home-add-favorite-order").foundation("open");
                        }
                      });

                      $(".home-confirm-add-favorite-button").click(function () {
                        $.ajax({
                          type: "POST",
                          url: ajax_url,
                          data: {
                            action: "olo_create_basket_from_order",
                            authtoken: localStorage.getItem(
                              "charleys_auth_token"
                            ),
                            orderid: $(
                              ".home-add-favorite-order-recent-order-id"
                            ).text(),
                          },
                          success: function (response) {
                            result = JSON.parse(response);
                            // console.log(response);
                            // console.log(result);

                            $.ajax({
                              type: "POST",
                              url: ajax_url,
                              data: {
                                action: "olo_set_fave",
                                authtoken: localStorage.getItem(
                                  "charleys_auth_token"
                                ),
                                basketid: result.id,
                                description: $(
                                  "[data-favorite-order-description]"
                                ).val(),
                              },
                              success: function (response) {
                                fave_result = JSON.parse(response);

                                if (fave_result.code == 200) {
                                  alert(fave_result.message);
                                  $(".home-add-favorite-order").foundation(
                                    "open"
                                  );
                                } else if (fave_result.faves[0].id) {
                                  window.location.reload();
                                }
                              },
                            });
                          },
                        });
                      });

                      $(".home-confirm-delete-favorite-button").click(
                        function () {
                          $.ajax({
                            type: "POST",
                            url: ajax_url,
                            data: {
                              action: "olo_delete_fave",
                              authtoken: localStorage.getItem(
                                "charleys_auth_token"
                              ),
                              faveid: $(
                                ".home-delete-favorite-order-favorite-order-id"
                              ).text(),
                            },
                            success: function (response) {
                              window.location.reload();
                            },
                          });
                        }
                      );

                      totalLoadBeforeComplete--;
                      if (totalLoadBeforeComplete == 0) {
                        charleys_hide_loading();
                      }
                    }
                  },
                  complete: function () {
                    totalLoadBeforeComplete--;
                    if (totalLoadBeforeComplete == 0) {
                      charleys_hide_loading();
                    }
                  },
                });
              });
            } else {
              $("[data-recent-orders-loading]").addClass("hide");
              $("[data-recent-orders-not-found]").removeClass("hide");
            }
          },
          complete: function () {
            totalLoadBeforeComplete--;
            if (totalLoadBeforeComplete == 0) {
              charleys_hide_loading();
            }
          },
        });
      }

      // Retrieve favorite orders
      // console.log("Retrieve favorite orders");
      if (isUserLoggedIn()) {
        $.ajax({
          type: "POST",
          url: ajax_url,
          data: {
            action: "olo_get_faves",
            authtoken: localStorage.getItem("charleys_auth_token"),
          },
          success: function (response) {
            var results = JSON.parse(response);

            if (results.faves !== undefined && results.faves.length > 0) {
              totalLoadBeforeComplete++;

              // cache menu for each restaurant
              var menu_results_cache = {};

              var order_locations = [];
              results.faves.forEach(function (fave) {
                // if (!order_locations.contains(fave.vendorid)) {
                if (
                  !order_locations.length ||
                  !order_locations.includes(fave.vendorid)
                ) {
                  order_locations.push(fave.vendorid);
                }
              });

              var menus_cached = 0;
              order_locations.forEach(function (order_location) {
                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "get_olo_get_menu",
                    restaurant_id: order_location,
                  },
                  success: function (response) {
                    menu_results_cache[order_location] = JSON.parse(response);
                    menus_cached++;

                    if (menus_cached == order_locations.length) {
                      results.faves.forEach(function (fave) {
                        var $fave_order = $(
                          "[data-favorite-order-template].hide"
                        ).clone();
                        $fave_order
                          .find("[data-favorite-order-title]")
                          .text(fave.name);
                        $fave_order
                          .find("[data-favorite-order-id]")
                          .text(fave.id);
                        $fave_order.find(".favorite-order-id").text(fave.id);
                        $fave_order
                          .find("[data-favorite-order-vendor-id]")
                          .text(fave.vendorid);
                        $fave_order
                          .find("[data-favorite-order-vendor-name]")
                          .text(fave.vendorname);

                        var menu_results = menu_results_cache[fave.vendorid];

                        fave.products.forEach(function (product) {
                          var matched = false;
                          var product_calories;
                          var product_price;
                          var product_image_filename;

                          menu_results.categories.every(function (category) {
                            category.products.every(function (cat_product) {
                              if (product.productid == cat_product.id) {
                                product_calories = cat_product.basecalories;
                                // product_price = cat_product.cost;
                                product_image_path = menu_results.imagepath;
                                product_image_filename =
                                  cat_product.imagefilename;
                                matched = true;
                              }
                              return !matched;
                            });
                            return !matched;
                          });

                          var $fave_item = $fave_order
                            .find("[data-favorite-order-item-template]")
                            .clone();

                          if (product_image_filename != null) {
                            $fave_item
                              .find("img")
                              .attr(
                                "src",
                                product_image_path + product_image_filename
                              );
                          } else {
                            $fave_item
                              .find("img")
                              .attr(
                                "src",
                                "/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg"
                              );
                          }

                          $fave_item
                            .find("[data-favorite-order-item-name]")
                            .text(product.name);
                          if (product_calories != null) {
                            $fave_item
                              .find("[data-favorite-order-item-calories]")
                              .text(product_calories + " Calories | ");
                          }
                          // $fave_item.find('[data-favorite-order-item-price]').text(product_price);

                          var choiceArray = [];
                          product.choices.forEach(function (choice) {
                            choiceArray.push(choice.name);
                          });

                          $fave_item.removeClass("hide");
                          $fave_item
                            .find("[data-favorite-order-item-choices]")
                            .text(choiceArray.join(", "));
                          $fave_item.removeAttr(
                            "data-favorite-order-item-template"
                          );
                          $fave_order
                            .find(".favorite-order-items")
                            .append($fave_item);
                        });

                        $fave_order.removeClass("hide");
                        $("[data-favorite-orders-list]").append($fave_order);

                        $(".account-favorite-button").click(function () {
                          $(".data-delete-fave-id").text(
                            $(this).parent().find(".favorite-order-id").text()
                          );
                          $(".account-delete-favorite-order").foundation(
                            "open"
                          );
                        });

                        $(".account-delete-favorite-button").click(function () {
                          $.ajax({
                            type: "POST",
                            url: ajax_url,
                            data: {
                              action: "olo_delete_fave",
                              authtoken: localStorage.getItem(
                                "charleys_auth_token"
                              ),
                              faveid: $("[data-delete-fave-id]").text(),
                            },
                            success: function (response) {
                              window.location.reload();
                            },
                          });
                        });

                        $("[data-favorite-orders-loading]").addClass("hide");
                        $("[data-favorite-orders-list]").removeClass("hide");

                        $(".fave-order-place-button").click(function () {
                          $(".data-order-type-recent-id").text("");
                          $(".data-order-type-fave-id").text(
                            $(this)
                              .closest(".favorite-order")
                              .find("[data-favorite-order-id]")
                              .text()
                          );
                          window.scrollTo(0, 0);
                          $("#home-select-order-type").foundation("open");
                        });
                      });

                      $(".home-favorite-button").click(function () {
                        if ($(this).hasClass("location-favorite-active")) {
                          $(
                            ".home-delete-favorite-order-favorite-order-id"
                          ).text(
                            $(this).parent().find(".favorite-order-id").text()
                          );
                          $("#home-delete-favorite-order").foundation("open");
                        } else {
                          $(".home-add-favorite-order-recent-order-id").text(
                            $(this).parent().find(".recent-order-id").text()
                          );
                          $("#home-add-favorite-order").foundation("open");
                        }
                      });

                      $(".home-confirm-add-favorite-button").click(function () {
                        $.ajax({
                          type: "POST",
                          url: ajax_url,
                          data: {
                            action: "olo_create_basket_from_order",
                            authtoken: localStorage.getItem(
                              "charleys_auth_token"
                            ),
                            orderid: $(
                              ".home-add-favorite-order-recent-order-id"
                            ).text(),
                          },
                          success: function (response) {
                            result = JSON.parse(response);
                            // console.log(response);
                            // console.log(result);

                            $.ajax({
                              type: "POST",
                              url: ajax_url,
                              data: {
                                action: "olo_set_fave",
                                authtoken: localStorage.getItem(
                                  "charleys_auth_token"
                                ),
                                basketid: result.id,
                                description: $(
                                  "[data-favorite-order-description]"
                                ).val(),
                              },
                              success: function (response) {
                                fave_result = JSON.parse(response);

                                if (fave_result.code == 200) {
                                  alert(fave_result.message);
                                  $(".home-add-favorite-order").foundation(
                                    "open"
                                  );
                                } else if (fave_result.faves[0].id) {
                                  window.location.reload();
                                }
                              },
                            });
                          },
                        });
                      });

                      $(".home-confirm-delete-favorite-button").click(
                        function () {
                          $.ajax({
                            type: "POST",
                            url: ajax_url,
                            data: {
                              action: "olo_delete_fave",
                              authtoken: localStorage.getItem(
                                "charleys_auth_token"
                              ),
                              faveid: $(
                                ".home-delete-favorite-order-favorite-order-id"
                              ).text(),
                            },
                            success: function (response) {
                              window.location.reload();
                            },
                          });
                        }
                      );

                      totalLoadBeforeComplete--;
                      if (totalLoadBeforeComplete == 0) {
                        charleys_hide_loading();
                      }
                    }
                  },
                  complete: function () {
                    totalLoadBeforeComplete--;
                    if (totalLoadBeforeComplete == 0) {
                      charleys_hide_loading();
                    }
                  },
                });
              });
            } else {
              $("[data-favorite-orders-loading]").addClass("hide");
              $("[data-favorite-orders-not-found]").removeClass("hide");
            }
          },
          complete: function () {
            totalLoadBeforeComplete--;
            if (totalLoadBeforeComplete == 0) {
              charleys_hide_loading();
            }
          },
        });
      }
    })
    .hide()
    .fadeIn(transitionDuration);
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function eraseCookie(name) {
  let date = new Date();
  date.setTime(date.getTime() + (-1));
  let expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + "" + expires + "; path=/";
}

// Start a recent order
function startRecentOrder(order_id, view_context) {
  var $ = jQuery;

  // console.log("Start Recent: " + order_id);

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_create_basket_from_order",
      authtoken: localStorage.getItem("charleys_auth_token"),
      orderid: order_id,
    },
    success: function (response) {
      result = JSON.parse(response);
      // console.log(response);
      // console.log(result);

      if (result.id) {
        // console.log("setting basket id to new basket: " + result.id);
        localStorage.setItem("charleys_customer_basket_id", result.id);
        localStorage.setItem(
          "charleys_customer_store_location_id",
          result.vendorid
        );

        $.when(olo_get_restaurant(result.vendorid)).done(function (
          restaurant_json
        ) {
          var restaurant = JSON.parse(restaurant_json);
          localStorage.setItem(
            "charleys_customer_store_location_name",
            restaurant.name
          );
          hideFakeMenuIfAddedLocation();

        });

        var validAddress = true;
        // var isDelivery = Boolean($('input[name="order-type"]:checked').val() == 'dispatch');
        var isDelivery = Boolean(
          $('input[name="' + view_context + '-order-type"]:checked').val() ==
          "dispatch"
        );
        var vendorid = result.vendorid;
        var supportsbaskettransfers = result.supportsbaskettransfers;

        // Delivery requires a full address, thus fails validation if no street address is present
        if (
          isDelivery &&
          !$("#" + view_context + "-order-location-search-streetaddress").val()
            .length
        ) {
          validAddress = false;
        }

        // console.log("validAddress", validAddress);

        $("#" + view_context + "-order-location-search").removeClass(
          "form-alert"
        );
        $("#" + view_context + "-order-location-search-error").addClass("hide");

        if (validAddress) {
          charleys_show_loading();
          setAddressComponents(view_context);

          var showcartdialog = true;
          selectLocation(
            vendorid,
            supportsbaskettransfers,
            showcartdialog,
            view_context
          );
        } else {
          $("#" + view_context + "-order-location-search").addClass(
            "form-alert"
          );
          $("#" + view_context + "-order-location-search-error").removeClass(
            "hide"
          );
        }
      }
    },
  });
}

// Start a favorite order
function startFavoriteOrder(fave_id, view_context) {
  var $ = jQuery;

  // console.log("Start Favorite: " + fave_id);

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_create_basket_from_fave",
      authtoken: localStorage.getItem("charleys_auth_token"),
      faveid: fave_id,
    },
    success: function (response) {
      result = JSON.parse(response);
      // console.log(response);
      // console.log(result);

      if (result.id) {
        // console.log("setting basket id to new basket: " + result.id);
        localStorage.setItem("charleys_customer_basket_id", result.id);
        localStorage.setItem(
          "charleys_customer_store_location_id",
          result.vendorid
        );

        $.when(olo_get_restaurant(result.vendorid)).done(function (
          restaurant_json
        ) {
          var restaurant = JSON.parse(restaurant_json);
          localStorage.setItem(
            "charleys_customer_store_location_name",
            restaurant.name
          );
          hideFakeMenuIfAddedLocation();

        });

        var validAddress = true;
        // var isDelivery = Boolean($('input[name="order-type"]:checked').val() == 'dispatch');
        var isDelivery = Boolean(
          $('input[name="' + view_context + '-order-type"]:checked').val() ==
          "dispatch"
        );
        var vendorid = result.vendorid;
        var supportsbaskettransfers = result.supportsbaskettransfers;

        // Delivery requires a full address, thus fails validation if no street address is present
        if (
          isDelivery &&
          !$("#" + view_context + "-order-location-search-streetaddress").val()
            .length
        ) {
          validAddress = false;
        }

        // console.log("validAddress", validAddress);

        $("#" + view_context + "-order-location-search").removeClass(
          "form-alert"
        );
        $("#" + view_context + "-order-location-search-error").addClass("hide");

        if (validAddress) {
          charleys_show_loading();
          setAddressComponents(view_context);

          var showcartdialog = true;
          selectLocation(
            vendorid,
            supportsbaskettransfers,
            showcartdialog,
            view_context
          );
        } else {
          $("#" + view_context + "-order-location-search").addClass(
            "form-alert"
          );
          $("#" + view_context + "-order-location-search-error").removeClass(
            "hide"
          );
        }
      }
    },
  });
}

// Start a referral order
function startReferralOrder(location_id, supportsbaskettransfers, view_context) {
  var $ = jQuery;

  // console.log('Start Referral: ' + location_id);
  localStorage.setItem('charleys_customer_store_location_id', location_id);

  var validAddress = true;
  var isDelivery = Boolean($('select[name="' + view_context + '-order-type"]').val() == 'dispatch');
  var vendorid = location_id;

  // Delivery requires a full address, thus fails validation if no street address is present
  if (isDelivery && !$('#' + view_context + '-order-location-search-streetaddress').val().length) {
    validAddress = false;
  }

  // console.log('validAddress', validAddress);

  $('#' + view_context + '-order-location-search').removeClass('form-alert');
  $('#' + view_context + '-order-location-search-error').addClass('hide');

  if (validAddress) {
    charleys_show_loading();

    eraseCookie('charleys_google_store_slug');
    eraseCookie('charleys_google_handoff_mode');

    setAddressComponents(view_context);

    var showcartdialog = false;
    selectLocation(vendorid, supportsbaskettransfers, showcartdialog, view_context);

  } else {
    $('#' + view_context + '-order-location-search').addClass('form-alert');
    $('#' + view_context + '-order-location-search-error').removeClass('hide');
  }
}

// Set Payment Splits
function setPaymentSplit() {
  var $ = jQuery;
  var splitCount = $(
    "[data-billing-schemes-active] .active-payment:not(.hide)"
  ).length;

  // Auto set split payments evenly between
  calcSplitPayment();

  if (splitCount > 1) {
    // console.log("split payment");
    $("[data-split-totals]").removeClass("hide");
    $("[data-billing-schemes-active] .active-payment:not(.hide)").each(
      function () {
        $(this).find("[data-split-input]").removeClass("hide");
      }
    );
    // Balance inputs while editing
    $("[data-billing-schemes-active] .active-payment:not(.hide) input").on(
      "keyup",
      function () {
        // calcSplitPayment();
        balanceSplitPayment();
      }
    );
    $("[data-billing-schemes-active] .active-payment:not(.hide) input").on(
      "blur",
      function () {
        fillEmptySplitPayment();
      }
    );
  } else {
    // console.log("single payment");
    $("[data-split-totals]").addClass("hide");
    $("[data-billing-schemes-active] .active-payment:not(.hide)").each(
      function () {
        $(this).find("[data-split-input]").addClass("hide");
      }
    );

    $("[data-billing-schemes-active] .active-payment:not(.hide) input").off(
      "keyup blur"
    );
  }
}

function calcSplitPayment() {
  var $ = jQuery;

  // var totalToSplit = Number($("[data-cart-grand-total]").attr("data-cart-grand-total"));
  // var totalToSplit = Number($('[data-cart-grand-total]').attr('data-cart-grand-total').replace(',', ''));
  var totalToSplit = Number(
    $("[data-cart-grand-total]").attr("data-cart-grand-total")
  );

  var splitCount = $("[data-billing-schemes-active] .active-payment:not(.hide)").length;
  var totalSplits = 0;
  var remainingBalance = 0;

  $("[data-total-to-split]").text("$ " + formatMoney(totalToSplit));

  // for (var i = 0; i < splitCount - 1; i++) {
  //   var inputVal = Number(formatMoney((totalToSplit * 100) / splitCount / 100));
  //   $(
  //     $("[data-billing-schemes-active] .active-payment:not(.hide) input")[i]
  //   ).val(formatMoney(inputVal));
  //   totalSplits += inputVal;
  // }
  //
  // remainingBalance = totalToSplit - totalSplits;
  // $($("[data-billing-schemes-active] .active-payment:not(.hide) input")[splitCount - 1]).val(formatMoney(remainingBalance));

  // console.log("total to split", totalToSplit, formatMoney(totalToSplit));

  $($('[data-billing-schemes-active] .active-payment:not(.hide) input')[splitCount - 1]).val(formatMoney(totalToSplit));
  for (var i = 0; i < splitCount - 1; i++) {
    $($('[data-billing-schemes-active] .active-payment:not(.hide) input')[i]).val(formatMoney(0));
  }

  // $("[data-remaining-balance]").text("$ 0.00");
}

// Balance split payments
function balanceSplitPayment() {
  var $ = jQuery;

  var totalToSplit = Number(
    $("[data-cart-grand-total]").attr("data-cart-grand-total")
  );
  var splitCount =
    $("[data-billing-schemes-active] .active-payment:not(.hide)").length - 1;
  var totalSplits = 0;
  var remainingBalance = 0;

  $("[data-total-to-split]").text("$ " + formatMoney(totalToSplit));

  $("[data-billing-schemes-active] .active-payment:not(.hide) input").each(
    function () {
      totalSplits += (Number($(this).val()) * 100) / 100;
    }
  );

  remainingBalance = (totalToSplit * 100 - totalSplits * 100) / 100;

  $("[data-remaining-balance]").text("$ " + formatMoney(remainingBalance));

  if (remainingBalance > 0 || remainingBalance < 0) {
    $(".remaingin-balance-row").each(function () {
      $(this).addClass("error");
    });
  } else {
    $(".remaingin-balance-row").each(function () {
      $(this).removeClass("error");
    });
  }
} // balanceSplitPayment()

function fillEmptySplitPayment() {
  var $ = jQuery;
  var totalToSplit = Number(
    $("[data-cart-grand-total]").attr("data-cart-grand-total")
  );
  var totalSplits = 0;

  // Get collective total
  $("[data-billing-schemes-active] .active-payment:not(.hide) input").each(
    function () {
      if ($(this).val() !== "") {
        totalSplits += (Number($(this).val()) * 100) / 100;
      }
    }
  );

  $("[data-billing-schemes-active] .active-payment:not(.hide) input").each(
    function () {
      if ($(this).val() === "") {
        $(this).val(formatMoney(totalToSplit - totalSplits));
        balanceSplitPayment();
        return false;
      }
    }
  );

  balanceSplitPayment();
} // fillEmptySplitPayment()

// Set CC Fields for CC payment entry
function setCCFields() {
  var $ = jQuery;

  $(".credit-card-info-div").empty();
  $(".cvv-info-div").empty();
  $("#expiredate").val("");
  $("#postalCode").val("");

  $("#credit-card-add-card").prop("disabled", true);
  $("#credit-card-add-card").removeClass("hide");
  $("#credit-card-update-card").prop("disabled", true);
  $("#credit-card-update-card").addClass("hide");

  var cardFieldStyle =
    "width: 100%;" +
    "height: 100%;" +
    "margin: 0;" +
    "padding: 8px;" +
    "border-width: 0px;" +
    "border-radius: 0;" +
    "background-color: #fff;" +
    "font-size: 16px;" +
    "font-weight: 400;" +
    "line-height: 1.5;" +
    "color: #000;" +
    "appearance: none;";

  checkoutFrame = new Olo.CheckoutFrame({
    cardElement: "credit-card-info-div",
    cvvElement: "cvv-info-div",
  });

  var checkoutFrameInit = {
    brandAccessId: brandAccessId, // global set in wp-content/themes/Charleys/parts/block/content-wf-ordering.php
    basketGuid: localStorage.getItem("charleys_customer_basket_id"),
    styles: {
      "cardNumber": cardFieldStyle,
      "cvv": cardFieldStyle,
    },
    cardNumber: {
      placeholder: "Card Number",
    },
    cvv: {
      placeholder: "CVV",
    },
  };

  // console.log("checkoutframeinit: ", checkoutFrameInit);

  checkoutFrame.initialize(checkoutFrameInit);
} // setCCFields

function setCheckoutError(errorMessage) {
  var $ = jQuery;
  if (errorMessage == "") {
    errorMessage =
      "We were unable to process your order at this time. Plase insure the information provided below is correct.";
  }

  $(".checkout-error [data-error-message]").text(errorMessage);
  $(".checkout-error").removeClass("hide");

  $("html, body").animate({ scrollTop: 0 }, 500);
}

function clearCheckoutError() {
  var $ = jQuery;
  $(".checkout-error [data-error-message]").text("");
  $(".checkout-error").addClass("hide");
}

// function punchh_get_all_restaurants() {
//   var $ = jQuery;
//   //olo_get_all_restaurants
//   return $.ajax({
//     type: 'POST',
//     url: ajax_url,
//     data: {
//       action : 'punchh_get_all_restaurants'
//     },
//     success: function(response) {
//       // console.log(response);
//       // console.log(JSON.parse(response));
//       //
//       // var results = JSON.parse(response);
//     },
//     complete: function() {
//
//     }
//   });
// }

function olo_get_rewards_schemes() {
  var $ = jQuery;

  if (
    localStorage.getItem("charleys_auth_token") &&
    localStorage.getItem("charleys_customer_basket_id")
  ) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_rewards_schemes",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
        authtoken: localStorage.getItem("charleys_auth_token"),
      },
      success: function (response) {
        // console.log(JSON.parse(response));
        var result = JSON.parse(response);
        if ("schemes" in result) {
          if ("membership" in result.schemes[0]) {
            if (result.schemes[0].membership !== null) {
              localStorage.setItem(
                "charleys_customer_membership_id",
                result.schemes[0].membership.id
              );
              // olo_get_qualifying_rewards();
            }
          }
        }
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_get_applied_rewards() {
  var $ = jQuery;
  if (localStorage.getItem("charleys_customer_basket_id")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_applied_rewards",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
        membershipid: localStorage.getItem("charleys_customer_membership_id"),
      },
      success: function (response) {
        console.log(response);
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_get_qualifying_rewards() {
  var $ = jQuery;

  if (
    localStorage.getItem("charleys_auth_token") &&
    localStorage.getItem("charleys_customer_basket_id") &&
    localStorage.getItem("charleys_customer_membership_id")
  ) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_qualifying_rewards",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
        authtoken: localStorage.getItem("charleys_auth_token"),
        membershipid: localStorage.getItem("charleys_customer_membership_id"),
      },
      success: function (response) {
        console.log(response);
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_add_reward_to_basket(reward_reference) {
  var $ = jQuery;

  if (
    localStorage.getItem("charleys_auth_token") &&
    localStorage.getItem("charleys_customer_basket_id")
  ) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_add_reward_to_basket",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
        membershipid: localStorage.getItem("charleys_customer_membership_id"),
        references: reward_reference,
      },
      success: function (response) {
        // console.log(response);

        var result = JSON.parse(response);

        if ("code" in result) {
          setCheckoutError(result.message);
        } else {
          clearCheckoutError();
        }
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_remove_reward_to_basket(rewardid) {
  var $ = jQuery;

  if (localStorage.getItem("charleys_customer_basket_id")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_remove_reward_to_basket",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
        rewardId: rewardid,
      },
      success: function (response) {
        console.log(response);
      },
      complete: function () { },
    });
  } else {
    // No account, No Rewards
    return [JSON.stringify({})];
  }
}

function olo_get_gift_card_balance(billingSchemeId, cardnumber, pin) {
  var $ = jQuery;

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_gift_card_balance",
      basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      billingSchemeId: billingSchemeId,
      cardnumber: cardnumber,
      pin: pin,
    },
    success: function (response) {
      // console.log(JSON.parse(response));
    },
    complete: function () { },
  });
}

function olo_get_all_restaurants() {
  var $ = jQuery;
  //olo_get_all_restaurants
  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_all_restaurants",
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      //
      // var results = JSON.parse(response);
    },
    complete: function () { },
  });
}

function olo_get_user_details() {
  var $ = jQuery;
  // olo_get_user_details
  if (localStorage.getItem("charleys_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_user_details",
        authtoken: localStorage.getItem("charleys_auth_token"),
      },
      success: function (response) { },
    });
  } else {
    return false;
  }
}

function olo_get_user_contact_details() {
  var $ = jQuery;

  if (localStorage.getItem("charleys_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_user_contact_details",
        authtoken: localStorage.getItem("charleys_auth_token"),
      },
      success: function (response) { },
    });
  } else {
    return false;
  }
}

function olo_get_user_communication_details() {
  var $ = jQuery;

  if (localStorage.getItem("charleys_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_user_communication_details",
        authtoken: localStorage.getItem("charleys_auth_token"),
      },
      success: function (response) { },
    });
  } else {
    return false;
  }
}

function olo_get_billing_accounts() {
  var $ = jQuery;

  if (localStorage.getItem("charleys_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_billing_accounts",
        authtoken: localStorage.getItem("charleys_auth_token"),
      },
      success: function (response) { },
    });
  } else {
    return [JSON.stringify({})];
  }
}

// Sets billing account to default
function olo_default_billing_account(billingAccountId) {
  var $ = jQuery;

  if (localStorage.getItem("charleys_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_default_billing_account",
        authtoken: localStorage.getItem("charleys_auth_token"),
        billingAccountId: billingAccountId,
      },
      success: function (response) { },
    });
  } else {
    return [JSON.stringify({})];
  }
}

// Deletes Billing Account
function olo_delete_billing_account(billingAccountId) {
  var $ = jQuery;

  if (localStorage.getItem("charleys_auth_token")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_delete_billing_account",
        authtoken: localStorage.getItem("charleys_auth_token"),
        billingAccountId: billingAccountId,
      },
      success: function (response) { },
    });
  } else {
    return [JSON.stringify({})];
  }
}

function olo_get_billing_schemes() {
  var $ = jQuery;

  if (localStorage.getItem("charleys_customer_basket_id")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_billing_schemes",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        //
        // var results = JSON.parse(response);
      },
      complete: function () { },
    });
  } else {
    return false;
  }
}

function olo_validate_basket() {
  var $ = jQuery;

  if (localStorage.getItem("charleys_customer_basket_id")) {
    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_validate_basket",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        //
        // var results = JSON.parse(response);
        // console.log('validate basket', response);
      },
      complete: function () { },
    });
  } else {
    return false;
  }
}

function olo_get_ccsf_payment_token() {
  var $ = jQuery;
  // if(!localStorage.getItem('charleys_customer_ccsf_token')) {
  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_ccsf_payment_token",
      basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      authtoken: localStorage.getItem("charleys_auth_token"),
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      //
      // var results = JSON.parse(response);
      //
      // localStorage.setItem('charleys_customer_ccsf_token', results.accesstoken);
    },
    complete: function () { },
  });
  // } else {
  //   return [JSON.stringify({
  //     accesstoken: localStorage.getItem('charleys_customer_ccsf_token')
  //   })];
  // }
}

function addItemToBasket() {
  var $ = jQuery;

  charleys_show_loading();

  // console.log("add item");

  var productSelections = {
    chainproductid: Number(
      $("#item-add-to-cart").attr("data-menu-selection-chain-id")
    ),
    quantity: Number($("#product-item-qty").val()),
    choices: [],
    recipient: $("#item-customer-name").val(),
  };

  var $productView = $("#product-detail-view");
  var productVariant = [];

  // Get Primary Choices

  $productView.find("input[data-item-selector]:checked").each(function () {
    var choiceQty = 1;
    var choiceID = $(this).attr("id");
    var chainOptionID = $(this).attr("data-chainoptionid");

    // Only proceed if a chain option ID is present
    if (chainOptionID) {

      var choice = {
        name: $('label[for="' + choiceID + '"] strong').text(),
        chainchoiceid: chainOptionID,
        quantity: choiceQty,
      };

      if (!$(this).is("[data-item-selector-modifier]")) {
        productSelections.choices.push(choice);
      }

      var modChoices = getSelectedModifiers($(this).attr('id'));

      if (modChoices.length) {
        choice.choices = modChoices;
      }
    }
  });

  // console.log(productVariant);

  var itemPrice = Number(
    $("#item-add-to-cart")
      .find("[data-item-selection-price]")
      .text()
      .replace("$ ", "")
  );

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  var addToCartData = {
    event: "add_to_cart",
    ecommerce: {
      currency: "USD",
      value: itemPrice,
      items: [
        {
          item_id: $("#item-add-to-cart").attr("data-menu-selection-id"),
          item_name: $("#product-detail-view")
            .find("[data-product-view-title]:first")
            .text(),
          affiliation: localStorage.getItem(
            "charleys_customer_store_location_name"
          ), //$('[data-menu-selected-store]:first').text(),
          price: itemPrice,
          item_variant: productVariant.join(", "),
          quantity: Number($("#product-item-qty").val()),
        },
      ],
    },
  };
  // console.log("GA4:", addToCartData);
  window.dataLayer.push(addToCartData);

  // console.log(JSON.stringify(productSelections));
  // return;

  $.ajax({
    type: 'POST',
    url: ajax_url,
    data: {
      action: 'olo_add_to_basket',
      productSelections: JSON.stringify(productSelections),
      basketGuid: localStorage.getItem('charleys_customer_basket_id')
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      var result = JSON.parse(response);

      if ('code' in result) {
        charleys_hide_loading();
        $('[data-add-to-cart-message]').text(result.message);
        $('[data-add-to-cart-message]').removeClass('hide');
      } else {
        $('[data-add-to-cart-message]').addClass('hide');
        // Close menu selection modal
        $('#product-detail-view').foundation('close');
        // Reset the current state to the menu view
        if (window.location.hash !== '#menu-product-view') {
          history.replaceState({}, '', window.location.pathname + '#menu');
        }
        $.when(
          updateBasketDisplay(true)
        ).done(function () {
          charleys_hide_loading();
        });
      }
    },
    complete: function () {

    }
  });
}

// New recursion method
function getSelectedModifiers(choiceID) {
  var $ = jQuery.noConflict();
  var selectedModifiers = [];

  // capture product modifiers
  if ($('[data-modifier-for="' + choiceID + '"]').length) {

    // Find the modifiers for this selection
    $('[data-modifier-for="' + choiceID + '"]').each(function () {

      var modifierID = $(this).attr('data-modifier-id');

      // Get the selected options for this modifier
      $('input[data-option-for-modifier="' + modifierID + '"]:checked').each(function () {

        var subChoiceQty = 1;
        var subChoiceId = $(this).attr("id");
        var subChoice = [];
        var subChoiceChainID = $(this).attr("data-chainoptionid");

        var subChoiceName = $('label[for="' + subChoiceId + '"] strong').text()
        var subChoiceModLevel = Number($(this).attr('data-modifier-level'));

        // Adjust qty
        if ($('[data-qty-for="' + subChoiceId + '"]').length) {
          if (
            $('[data-qty-for="' + subChoiceId + '"]').is(
              'input[type="radio"]'
            )
          ) {
            subChoiceQty = Number(
              $('[data-qty-for="' + subChoiceId + '"]:checked').val()
            );
          } else {
            subChoiceQty = Number(
              $('[data-qty-for="' + subChoiceId + '"]').val()
            );
          }
        }

        var subChoice = {
          // name: subChoiceName, // Debug field (optioal)
          chainchoiceid: subChoiceChainID,
          quantity: subChoiceQty,
          // modifierLevel: subChoiceModLevel, // Debug field (optioal)
          choices: getSelectedModifiers(subChoiceId)
        };

        selectedModifiers.push(subChoice);

      });

    });
  }

  return selectedModifiers;
}

function updateItemInBasket() {
  var $ = jQuery;

  charleys_show_loading();

  // console.log("update item");

  var productSelections = {
    productid: Number(
      $("#item-add-to-cart-update").attr("data-update-product-id")
    ),
    quantity: Number($("#product-item-qty").val()),
    choices: [],
    recipient: $("#item-customer-name").val(),
  };

  var $productView = $("#product-detail-view");
  var productVariant = [];

  $productView
    .find(
      "input[data-item-selector]:checked, input[data-item-selector-modifier]:checked"
    )
    .each(function () {
      var choiceQty = 1;
      var choiceID = $(this).attr("id");
      var chainOptionID = $(this).attr("data-chainoptionid");

      if (chainOptionID) {
        if ($('[data-qty-for="' + choiceID + '"]').length) {
          if (
            $('[data-qty-for="' + choiceID + '"]').is('input[type="radio"]')
          ) {
            choiceQty = Number(
              $('[data-qty-for="' + choiceID + '"]:checked').val()
            );
          } else {
            choiceQty = Number($('[data-qty-for="' + choiceID + '"]').val());
          }
        }

        var choice = {
          choiceid: $(this).attr("id"),
          quantity: choiceQty,
        };

        productSelections.choices.push(choice);
        productVariant.push($(this).next("label").find("strong").text());
      }
    });

  // console.log(productVariant);

  var itemPrice = Number(
    $("#item-add-to-cart")
      .find("[data-item-selection-price]")
      .text()
      .replace("$ ", "")
  );

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  var addToCartData = {
    event: "add_to_cart",
    ecommerce: {
      currency: "USD",
      value: itemPrice,
      items: [
        {
          item_id: $("#item-add-to-cart").attr("data-menu-selection-id"),
          item_name: $("#product-detail-view")
            .find("[data-product-view-title]:first")
            .text(),
          affiliation: localStorage.getItem(
            "charleys_customer_store_location_name"
          ), //$('[data-menu-selected-store]:first').text(),
          price: itemPrice,
          item_variant: productVariant.join(", "),
          quantity: Number($("#product-item-qty").val()),
        },
      ],
    },
  };
  // console.log("GA4:", addToCartData);
  window.dataLayer.push(addToCartData);

  productSelections = {
    products: [productSelections],
  };

  // console.log(JSON.stringify(productSelections));

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_update_basket_product",
      productSelections: JSON.stringify(productSelections),
      basketGuid: localStorage.getItem("charleys_customer_basket_id"),
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      var result = JSON.parse(response);
    },
    complete: function () {
      // Close menu selection modal
      $("#product-detail-view").foundation("close");
      // Reset the current state to the menu view
      if (window.location.hash !== "#menu-product-view") {
        history.replaceState({}, "", "#menu");
      }
      updateBasketDisplay(true);
      charleys_hide_loading();
    },
  });
}
var $ = jQuery;

function selectAllDefaultSelectsion(element, currentInputId) { 
  console.log('triggered selectAllDefaultSelectsion function');
  var $ = jQuery;

  $matchingChildFieldset = $(element).closest('.product-option-group').find(`fieldset[data-modifier-for="${currentInputId}"]`);
  if ($matchingChildFieldset.length > 0) {
    // console.log('matchingChildFieldset found');
    $defaultInputBoxes = $matchingChildFieldset.find('span input[radiodefualtcheckedstate]');
    if ($defaultInputBoxes.length > 0) {
      // console.log('$defaultInputBoxes', $defaultInputBoxes);

      $defaultInputBoxes.each(function () { // Iterate through each element in $defaultInputBoxes
        const $defaultInputBox = $(this); // Wrap the current element in jQuery
        // const $defaultInputBoxesLabel = $defaultInputBox.siblings('label'); // scope this to only look at the single item
        // console.log('$defaultInputBox', $defaultInputBox);

        $defaultInputBox.prop('checked', true);
        $defaultInputBox.parent().addClass('selected');

        //see if clindren have default selects
        const defaultInputBoxesId = $defaultInputBox.attr('id');
        $matchingChildChildFieldset = $defaultInputBox.closest('fieldset').siblings(`fieldset[data-modifier-for="${defaultInputBoxesId}"]`);

        if ($matchingChildChildFieldset.length > 0) {
          $childDefaultInputBoxes = $matchingChildChildFieldset.find('span input[radiodefualtcheckedstate]');
          if ($childDefaultInputBoxes.length > 0) {
            // console.log('$childDefaultInputBoxes', $childDefaultInputBoxes); 

            $childDefaultInputBoxes.prop('checked', true);
            $childDefaultInputBoxes.parent().addClass('selected');
          }
        } 
        //ingredent popup
        $matchingChildChildIngredientFieldset = $defaultInputBox.closest('.product-modifier-groups').siblings('#main-ingredient-customizer-information-parent').find(`fieldset[data-modifier-for="${defaultInputBoxesId}"]`);
        // console.log('$matchingChildChildIngredientFieldset ', $matchingChildChildIngredientFieldset);

        if($matchingChildChildIngredientFieldset.length > 0) {
          $childDefaultInputBoxes = $matchingChildChildIngredientFieldset.find('span input[radiodefualtcheckedstate]');
          if ($childDefaultInputBoxes.length > 0) {
            // console.log('$childDefaultInputBoxes', $childDefaultInputBoxes); 

            $childDefaultInputBoxes.prop('checked', true);
            $childDefaultInputBoxes.parent().addClass('selected');
          }
        }
      });
    }
    // validateItemForm();

  }
}
function validateDrinkAndSidePopupPresentation() {
  var $ = jQuery;
  // console.log('check buttons');

  let $drinkComboButton = $(`[combo-drink-selection-customizer-information-popup].drink-modifier-parents`);
  let $sideComboButton = $(`[combo-side-selection-customizer-information-popup].side-modifier-parents`);
  if ($drinkComboButton.is('[data-is-valid="false"][data-is-required="true"]') || $sideComboButton.is('[data-is-valid="false"][data-is-required="true"]')) {
    // console.log('drink/side is not valid');
    $('button#combo-side-selection-customizer-information-popup').each(function () {
      $(this).removeClass('checked');
      $(this).find('div.selected-info').empty();
      $(this).find('span[duplicated-data-mandatory-label]').removeClass('valid').text('required');
    });
  }
}
function validateItemForm(comboChange, inputChanged = jQuery(this), useInput) {
  var $ = jQuery;
  // console.log("validateItemForm"); 
  //
  //
  if (comboChange) {
    console.log('combo change');

    let $ = jQuery;
    jQuery('[data-product-option-group]:not(.hide) .main-ingredient-customizer-information-parent ul.selected-info li').remove();

    //DrinkAndSidePopupPresentation
    let $drinkComboButton = $(`[combo-drink-selection-customizer-information-popup].drink-modifier-parents`);
    let $sideComboButton = $(`[combo-side-selection-customizer-information-popup].side-modifier-parents`);
    $drinkComboButton.attr('data-is-valid', 'false');
    $sideComboButton.attr('data-is-valid', 'false');
    validateDrinkAndSidePopupPresentation();


    let $noSelectedOptions = $('.product-modifier:not(.option-hide) input').parent('.selected');

    $noSelectedOptions.each(function () {
      // Get legend and label text for the current element
      let legendsName = $(this).parent().find('legend').text();
      // let labelsObject = $(this).find('label');
      let labelsName = $(this).find('label').text();


      // Find the fieldset that matches the legend  
      let $transferNoSelectedOptionsToMe = $('.product-modifier.option-hide').filter(function () {
        let legendMatch = $(this).find('legend').text() === legendsName;
        return legendMatch; // Return true if both match
      });

      // Find the label that matches labelsName within $transferNoSelectedOptionsToMe
      let matchingLabel = $transferNoSelectedOptionsToMe.find('label').filter(function () {
        return $(this).text() === labelsName;
      });

      // // Console log the result for each iteration
      // console.log('$transferNoSelectedOptionsToMe', $transferNoSelectedOptionsToMe);
      // console.log('Matching label:', matchingLabel);
      if (matchingLabel.length) {
        matchingLabel.siblings('input').prop('checked', true);
        // matchingLabel.parent().addClass('selected');
      }

      if (matchingLabel.is('.ingredient-modifier-children.option-hide > [data-product-option-modifier-option-for-ingredient-selection] > label')) {
        // console.log('ahhh', labelsName, matchingLabel, 'a', matchingLabel.parent().parent().parent().find('input'));
        matchingLabel.siblings('input').prop('checked', true);
        // matchingLabel.parent().parent().parent().parent('.ingredient-modifier-parents').addClass('dsgasdgasdg'); 
        matchingLabel.parent().parent().parent('[data-product-option-modifier-option-for-ingredient-selection]').children('input').prop('checked', true);
        // matchingLabel.parent().parent().parent('[data-product-option-modifier-option-for-ingredient-selection]').find('input').prop('checked', true);
        if (labelsName.trim().toLowerCase() === 'regular') {
          return; // Continue to the next iteration without appending
        }
        let uniqueTextA = '';
        let text = $(this).find('strong').text();
        let label = $(this).parent().parent().find('legend').text();
        if (text && label) {
          uniqueTextA += (uniqueTextA ? ' ' : '') + label + ': ' + text;
          // console.log(uniqueTextA);

          let $selectedInfo = $(this).closest('#main-ingredient-customizer-information-parent').find('.main-ingredients-cont ul.selected-info');
          // $selectedInfo.addClass('adgasdgsdg');
          $selectedInfo.append('<li>' + uniqueTextA + '</li>');
        }
      }



    });


  } else {
    $('fieldset.wings-side-selector>span>input, fieldset.cheesesteak-size-selector>span>input').each(function () {
      // console.log('asdgasdga');
      if ($(this).is('[radiodefualtcheckedstate="true"]')) {
        // console.log('Attribute found for:', this);
        const backgroundImage = $(this).siblings('label').css('background-image');
        // console.log('Background image:', backgroundImage);

        $(this).closest('[data-product-option-group]').css('background-image', backgroundImage);

        let mainIngredientHideShowCont = $(this).closest('[data-product-option-group-options]').find('#main-ingredient-customizer-information-parent');
        if (mainIngredientHideShowCont.find('.product-modifier-groups fieldset:not(.option-hide)')) {
          mainIngredientHideShowCont.removeClass('hide').removeClass('option-hide');
          if ($(this).is('fieldset.wings-side-selector>span>input')) {
            mainIngredientHideShowCont.find('p#product-detail-content-label').addClass('hide');
          }
        }
      } else {
        let mainIngredientHideShowCont = $(this).closest('[data-product-option-group-options]').find('#main-ingredient-customizer-information-parent');
        const fieldsets = $(this).find('fieldset:not(.option-hide)');
        if (fieldsets.length > 0) {
          // console.log('hii!', fieldsets);
          mainIngredientHideShowCont.addClass('fdhgsdfh').css('display', 'none');
        }
        // console.log('No radiodefaultcheckedstate="true" for:', this);
      }
    });

    jQuery('fieldset.cheesesteak-size-selector>span>input, fieldset.wings-side-selector>span>input').on('change', function () {
      const backgroundImage = $(this).siblings('label').css('background-image');
      // console.log(backgroundImage);
      $(this).closest('[data-product-option-group]').css('background-image', backgroundImage);
    });

    //functions for side and drink validation 
    function validateSideOrDrinkSelection(drinkOrSide) {
      let $parentPopup = $(`[combo-${drinkOrSide}-selection-customizer-information-popup].${drinkOrSide}-modifier-parents`);
      let $childModifiers = $(`[combo-${drinkOrSide}-selection-customizer-information-popup].${drinkOrSide}-modifier-children:not(.option-hide)`);
      let $validationFooter = $(`.combo-${drinkOrSide}-selection-customizer-information-popup.customizer-information-popup .pop-up-footer`);
      let $mandatoryLabel = $(`.combo-${drinkOrSide}-selection-customizer-information-parent:not(.hide) .combo-${drinkOrSide}-selection-customizer-information.popup-info-wrap button span[duplicated-data-mandatory-label]`);
      // console.log('asdgasdg');
      if ($parentPopup.is('[data-is-valid="true"][data-is-required="true"]')) {
        $validationFooter.addClass('valid-popup');

        if ($childModifiers.is('[data-is-valid="false"][data-is-required="true"]')) {
          $mandatoryLabel.removeClass('valid').text('Required');
          // console.log('Child exists and is not valid', $childModifiers);
          $validationFooter.removeClass('valid-popup');

        } else {
          $mandatoryLabel.addClass('valid').text('Completed');
          // console.log('Child/parent exists and is valid');
          $validationFooter.addClass('valid-popup');
        }
      } else {
        $validationFooter.removeClass('valid-popup');
      }
    }
    function removeSelectedFromOtherElements(drinkOrSide, thisPassedObject) {
      $(`[combo-${drinkOrSide}-selection-customizer-information-popup].${drinkOrSide}-modifier-parents > [data-product-option-modifier-option-for-combo-${drinkOrSide}-selection]`)
        .not(thisPassedObject.parent())
        .removeClass('selected')
        .find('input') // Find the input box (radio button) within the excluded elements
        .prop('checked', false);

      //insert selected item
      $(`.combo-${drinkOrSide}-selection-customizer-information-parent .customizer-information-popup-button .opened`).removeClass('hide');
      $(`.combo-${drinkOrSide}-selection-customizer-information-parent .customizer-information-popup-button`).addClass('checked');
      let labelHtml = thisPassedObject.next('label').html();
      // console.log(labelHtml);
      $(`.combo-${drinkOrSide}-selection-customizer-information-parent .customizer-information-popup-button div.selected-info`).html(labelHtml);
    }
    // function selectDefualtsForParentElements(drinkOrSide, thisPassedObject) {
    //   const $siblings = thisPassedObject.siblings(`.${drinkOrSide}-modifier-children:not(.option-hide)`);
    //   const $selectedAfterInitialLoad = thisPassedObject.parent().siblings(`.${drinkOrSide}-modifier-children:not(.option-hide)`).find('span input[radiodefualtcheckedstate]').toArray();
    //   let cantUseOtherElse = false;
    //   // console.log('#3');

    //   if (thisPassedObject.is(`[combo-${drinkOrSide}-selection-customizer-information-popup].${drinkOrSide}-modifier-parents > [data-product-option-modifier-option-for-combo-${drinkOrSide}-selection] input`)) {
    //     // Handle default elements
    //     // console.log('#1');
    //     $siblings.find('span input[radiodefualtcheckedstate]').each(function () {
    //       // console.log('#2');
    //       $(this).prop('checked', true);
    //       $(this).parent().addClass('selected');
    //       // const $labelBox = $(this).siblings('label'); 
    //       // $labelBox.click();
    //       // validateItemForm();

    //     });

    //     cantUseOtherElse = true;
    //     validateItemForm();

    //   } else if ($selectedAfterInitialLoad.length > 0 && !cantUseOtherElse) {
    //     // Process elements after initial load
    //     $selectedAfterInitialLoad.forEach(function (element) {
    //       // $(element).prop('checked', true);
    //       // $(element).parent().addClass('selected');

    //       const $labelBox = $(element).siblings('label');
    //       if ($labelBox.length) {
    //         $labelBox.click();
    //       }
    //     });
    //     // validateItemForm();

    //   }
    // }

    //
    sideIsTriggered = false;
    //click default options && validate popupp
    $('[combo-side-selection-customizer-information-popup].side-modifier-parents [data-product-option-modifier-option-for-combo-side-selection]>input').on('change', function () {
      if (!sideIsTriggered) {


        if ($(this).is('[combo-side-selection-customizer-information-popup].side-modifier-parents > [data-product-option-modifier-option-for-combo-side-selection] > input')) {
          //remove selected from other elements
          removeSelectedFromOtherElements('side', $(this));
        }
        // validate 
        validateSideOrDrinkSelection('side');
        sideIsTriggered = true;
      }
    });

    drinkIsTriggered = false;
    $('[combo-drink-selection-customizer-information-popup].drink-modifier-parents [data-product-option-modifier-option-for-combo-drink-selection]>input').on('change', function () {
      if (!drinkIsTriggered) {

        if ($(this).is('[combo-drink-selection-customizer-information-popup].drink-modifier-parents > [data-product-option-modifier-option-for-combo-drink-selection] > input')) {
          //remove selected from other elements
          removeSelectedFromOtherElements('drink', $(this));
        }
        // validates 
        validateSideOrDrinkSelection('drink');
        drinkIsTriggered = true;
      }
    });


    // Attach the event handler
    if (inputChanged) {
      if (inputChanged.is('input[data-item-selector], input[data-item-selector-modifier]')) {
        if (inputChanged.prop('checked')) {

          if (inputChanged.is('.ingredient-modifier-children > [data-product-option-modifier-option-for-ingredient-selection] > input')) {
            // insert selected content
            inputChanged.closest('#main-ingredient-customizer-information-parent').find('.customizer-information-popup-button .opened').removeClass('hide option-hide');
            inputChanged.closest('#main-ingredient-customizer-information-parent').find('.customizer-information-popup-button').addClass('checked');

            inputChanged.closest('#main-ingredient-customizer-information-parent').find('ul.selected-info li').remove();

            $('.product-modifier.ingredient-modifier-parents:not(.option-hide) .ingredient-modifier-children')
              .find('span input:checked') // Find all checked input elementss 
              .each(function () {
                // console.log('i clickssssss');
                // Get the text content of <strong> without the <strong> tags
                let labelText = $(this).next('label').find('strong').text();

                // Skip if labelText is "Regular"
                if (labelText.trim().toLowerCase() === 'regular') {
                  return; // Continue to the next iteration without appending 
                }

                let legendText = $(this).parent().parent().find('legend').text();
                let $selectedInfo = $(this).closest('#main-ingredient-customizer-information-parent').find('.main-ingredients-cont ul.selected-info');

                // Check if the combination of legendText and labelText already exists
                let existingItem = $selectedInfo.find('li').filter(function () {
                  return $(this).text() === legendText + ': ' + labelText;
                });

                // If no existing item is found, append the new item
                if (existingItem.length === 0 && labelText) {
                  $selectedInfo.append('<li>' + legendText + ': ' + labelText + '</li>');
                }
              }); 

          } else if (inputChanged.is('.size-selector>span>input')) {
            validateDrinkAndSidePopupPresentation();
            jQuery('[data-product-option-group]:not(.hide) .main-ingredient-customizer-information-parent ul.selected-info li').remove();
          } else if (inputChanged.is('.cheesesteak-size-selector>span>input')) {
            jQuery('[data-product-option-group]:not(.hide) .main-ingredient-customizer-information-parent ul.selected-info li').remove();
          }
          // // Check defaults
          // let $strongElements = $(this).siblings('.ingredient-modifier-children').find('span input[radiodefualtcheckedstate]').toArray();
          // // console.log('dsfghsfdgh', $strongElements);
          // $strongElements.forEach(function (element) {
          //   let $labelBox = $(element).siblings('label');
          //   if ($labelBox.length) {
          //     // $labelBox.addClass('sdfgsdg');
          //     $labelBox.click();
          //     // console.log($labelBox, 'triggered!');
          //   }
          // });
          let element = inputChanged[0];
          const currentInputId = inputChanged.attr('id');
          selectAllDefaultSelectsion(element, currentInputId);
          validateItemForm();
        }
      }

    }
    // Hide and show main ingredient customize box
    //intital hide
    let $this = $('.main-ingredient-customizer-information-parent');
    // const visibleFieldsets = $this.find('[data-modifier-groups-for-ingredient-customizer] fieldset').not('.hide, .option-hide');
    // let fieldset = $this.find('[data-modifier-groups-for-ingredient-customizer] fieldset');
    if ($this.find('[data-modifier-groups-for-ingredient-customizer] fieldset legend').text().trim() === '' && !$('.right-col').hasClass('formatting-classic-combo')) {
      // console.log('#1!!');

      // console.log('content exitst');
      $this.addClass('hide option-hide');
      $('.right-col:not(.formatting-classic-combo) .main-ingredient-customizer-information-parent').each(function () {
        // console.log('#4!!');
        $(this).addClass('hide option-hide');
      });
      // fieldset.addClass('hide option-hide');
    }
    // else if ($('.right-col').hasClass('formatting-add-accordian')) {
    //   console.log('#2!!');
    //   const legendText = visibleFieldsets.find('legend').text().trim();
    //   // console.log('sdgasdg', legendText);
    //   if ((!visibleFieldsets.hasClass('hide') || !visibleFieldsets.hasClass('option-hide')) && (legendText || !legendText === '')) {
    //     // console.log('#1!!', visibleFieldsets);
    //     visibleFieldsets.closest('#main-ingredient-customizer-information-parent').removeClass('hide option-hide');
    //     // console.log('#2!!: show', visibleFieldsets);
    //   } else {
    //     visibleFieldsets.closest('#main-ingredient-customizer-information-parent').addClass('hide option-hide');
    //     // console.log('#2!!: hide', visibleFieldsets);
    //   }
    // }
    else {
      // console.log('#3!!');
      $('.right-col button#customizer-information-popup').addClass('hide option-hide');
      setTimeout(function () {
        $('.right-col button#customizer-information-popup').removeClass('hide option-hide');

        $('.right-col .main-ingredient-customizer-information-parent').each(function () {
          const fieldsets = $(this).find('fieldset:not(.option-hide)');

          if (fieldsets.length === 0) {
            // console.log('#3!! hide', $(this));
            $(this).addClass('hide option-hide');
          } else {
            // console.log('#3!! no hide', $(this));
            $(this).removeClass('hide option-hide');
          }
        });
      }, 200);

    }
    // hide on change
    if (inputChanged) {
      if (inputChanged.is('[data-product-options] span input, .formatting-classic-combo-wings .wings-side-selector:not(.cheesesteak-size-selector) span input')) {
        // console.log('sdgdsgasdgasdgas');
        let mainIngredientHideShowCont = inputChanged.closest('[data-product-option-group-options]').find('#main-ingredient-customizer-information-parent');
        if (mainIngredientHideShowCont) {
          const fieldsets = $(mainIngredientHideShowCont).find('fieldset:not(.option-hide)');

          if (fieldsets.length > 0) {
            // console.log('no hide!', mainIngredientHideShowCont);
            mainIngredientHideShowCont.removeClass('hide option-hide');
            // $(this).removeClass('hide option-hide').css('display', 'block');
          } else {
            // console.log('hide!', mainIngredientHideShowCont);
            mainIngredientHideShowCont.addClass('hide option-hide');
          }
        }
        
        // if (inputChanged.is('.formatting-classic-combo-wings .wings-side-selector:not(.cheesesteak-size-selector) span input')) {
        //   $labelBox = $(this).parent().parent().siblings('.size-selector:not(.option-hide)').find('input[radiodefualtcheckedstate]').siblings('label');
        //   $labelBox.click();
        //   console.log('i clickss 2', $labelBox);

        // } else {
        //   $labelBox = $(this).parent().parent().siblings('.formatting-classic-combo [data-modifier-groups], .formatting-30-50-pc-wings [data-modifier-groups]').find('.size-selector:not(.option-hide)').find('input[radiodefualtcheckedstate]').siblings('label');
        //   $labelBox.click();
        //   // jQuery('[data-product-option-group]:not(.hide) .main-ingredient-customizer-information-parent ul.selected-info li').remove();

        //   $labelBox2 = $(this).parent().parent().siblings('#main-ingredient-customizer-information-parent').find('input[radiodefualtcheckedstate]');
        //   $labelBox2Sibiling = $labelBox2.parent('span[data-product-option-modifier-option-for-ingredient-selection]').siblings('span');
        //   // $labelBox2Sibiling.addClass('sadgasdg');
        //   if ($labelBox2 && !$labelBox2Sibiling.hasClass('selected')) {
        //     $labelBox2.prop('checked', true);
        //     $labelBox2.parent().addClass('selected');
        //     // $labelBox2.click();
        //     // console.log('i clickss 3', $labelBox2Sibiling);  
        //   }
        //   $labelBox2.siblings('fieldset.ingredient-modifier-children').removeClass('option-hide');


        // }
        // let element = inputChanged[0];
        // const currentInputId = inputChanged.attr('id');
        // selectAllDefaultSelectsion(element, currentInputId);
        // validateItemForm();
      }
    }

  }

  // Update Visual Selection
  $(
    "[data-product-options] input[data-item-selector], [data-modifier-group] input[data-item-selector-modifier], [combo-side-selection-customizer-information-popup] input[data-item-selector-modifier], [combo-drink-selection-customizer-information-popup] input[data-item-selector-modifier], [main-ingredient-customizer-information-popup] input[data-item-selector-modifier]"
  ).each(function () {
    if ($(this).prop("checked")) {
      $(this).parent().addClass("selected");
    } else {
      $(this).parent().removeClass("selected");
    }
  });
  // Add selected image to dropdown on combo items
  // $classicComboParentSelector = $('.right-col.formatting-classic-combo .product-option-wrap>div.product-option-group>[data-product-option-group-options]>fieldset>span>input');
  // if ($classicComboParentSelector.is(':checked')) {
  //   let $labelSibling = $classicComboParentSelector.siblings('label');

  //   // Get the inline style attribute
  //   let style = $labelSibling.attr('style');

  //   // if (style) {
  //   //   // console.log('style', style);
  //   // } else {
  //   //   // console.log('nooo');
  //   // }
  // }


  //hide and show combo info
  const showComboSelections = $('fieldset.highlight > span:nth-of-type(2)').hasClass('selected');
  const parentElement = $('fieldset.highlight').closest('.product-option-group');
  if (parentElement) {
    parentElement.addClass('comboParentSelector');

    // Select the elements within .comboParentSelector
    $('.comboParentSelector .combo-side-selection-customizer-information-parent, .comboParentSelector .combo-drink-selection-customizer-information-parent').each(function () {
      // Check if .combo-side-selection-customizer-information-parent or .combo-drink-selection-customizer-information-parent exists
      if ($(this).length > 0) {
        // Determine visibility based on showComboSelections 
        if (showComboSelections) {
          $(this).removeClass('hide option-hide');
        } else {
          $(this).addClass('hide option-hide');
        }
      }
    });

  }




  $("[data-product-option-group]:not(.hide)").each(function () {
    var $productOptionGroup = $(this);
    var $productOptions = $(this).find(
      "[data-product-options]:not(.hide), [data-modifier-group][data-maxselects]:not(.option-hide), [data-modifier-group]:not(.option-hide), [combo-side-selection-customizer-information-popup]:not(.option-hide), [combo-drink-selection-customizer-information-popup]:not(.option-hide), [main-ingredient-customizer-information-popup]:not(.option-hide)"
    );

    // Selectors
    $productOptions.each(function () {
      // console.log('Raw maxSelects:', $(this).attr("data-maxselects"));
      var minSelects = Number($(this).attr("data-minselects")) || 0,
        maxSelects = Number($(this).attr("data-maxselects")) || 0,
        minChoiceQty = Number($(this).attr("data-minchoicequantity")) || 0,
        maxChoiceQty = Number($(this).attr("data-maxchoicequantity")) || 0,
        isValid = $(this).attr("data-is-valid"),
        isRequired = $(this).attr("data-is-required");

      // console.log('maxSelects', Number($(this).attr("data-maxselects")));
      // Set Valid State
      var fieldsetValid = true;

      // Enable/Disable Selectors based on max qty
      if (maxSelects !== 0) {
        var selectedQty = 0;
        $(this)
          .find("input[data-item-selector]:checked, input[data-item-selector-modifier]:checked")
          .each(function () {
            var selectionID = $(this).attr("id");
            var itemQty = 0;
            $(
              'input[radio][data-qty-for="' + $(this).attr("id") + '"]:checked, input[type="number"][data-qty-for="' + $(this).attr("id") + '"]'
            ).each(function () {
              itemQty += Number($(this).val());
            });
            if (itemQty == 0) {
              itemQty = 1;
            }
            // console.log("itemQty: " + itemQty);
            selectedQty += itemQty;
          });
        // console.log('selectedQty: '+selectedQty);
        // if(selectedQty == 0) {
        //   selectedQty = 1;
        // }
        if (selectedQty == maxSelects) {
          $(this)
            .find("input[data-item-selector]:not(:checked), input[data-item-selector-modifier]:not(:checked)")
            .prop("disabled", true);
          $(this)
            .find("button.qtyplus, button.qtyminus")
            .prop("disabled", true);
          $(this)
            .find('input[type="radio"][value="2"].qtyinput:not(:checked)')
            .prop("disabled", true);
        } else {
          $(this).find("input[data-item-selector], input[data-item-selector-modifier]").prop("disabled", false);
          $(this)
            .find("button.qtyplus, button.qtyminus, input.qtyinput")
            .prop("disabled", false);
          $(this)
            .find('input[type="radio"].qtyinput:not(:checked)')
            .prop("disabled", false);
        }

        // Disable if not available
        if (
          $(this)
            .find("input[data-item-selector], input[data-item-selector-modifier]")
            .attr("data-available-now") == "false"
        ) {
          $(this).find("input[data-item-selector], input[data-item-selector-modifier]").prop("disabled", true);
        }

        // if($(this).find('input[data-item-selector]:checked').length == maxSelects) {
        //   $(this).find('input[data-item-selector]:not(:checked)').prop('disabled', true);
        // } else {
        //   $(this).find('input[data-item-selector]').prop('disabled', false);
        // }
      }

      if (isRequired) {
        var numSelected = $(this).find(
          "input[data-item-selector]:checked, input[data-item-selector-modifier]:checked"
        ).length;
        if (numSelected < minSelects || !numSelected) {
          fieldsetValid = false;
        }
      }

      $(this).attr("data-is-valid", fieldsetValid);

      // console.log();
    });

    // Show/Hide product quantity selectors
    $productOptions.find("[data-qty-container-for]").each(function () {
      var selectedItem = $(this).attr("data-qty-container-for");

      if (
        $(
          'input[data-item-selector][id="' +
          selectedItem +
          '"], input[data-item-selector-modifier][id="' +
          selectedItem +
          '"]'
        ).prop("checked")
      ) {
        $(this).removeClass("option-hide"); // Show QTY Selector
      } else {
        $(this).addClass("option-hide"); // Hide QTY Selector
        $(this)
          .find("input[data-item-selector-modifier]")
          .each(function () {
            $(this).prop("checked", false);
          });
      }
    });

    // Show/Hide Modifiers
    $productOptionGroup.find("[data-modifier-for]").each(function () {
      var selectedItem = $(this).attr("data-modifier-for");

      if (
        $('input[data-item-selector][id="' + selectedItem + '"]').prop(
          "checked"
        ) ||
        $('input[data-item-selector-modifier][id="' + selectedItem + '"]').prop(
          "checked"
        )
      ) {
        $(this).removeClass("option-hide"); // Show Modifier
      } else {
        $(this).addClass("option-hide"); // Hide Modifier
        $(this)
          .find("input[data-item-selector-modifier]")
          .each(function () {
            $(this).prop("checked", false);
          });
      }
    });
  });

  var formValid = false;

  if (!$('[data-is-valid="false"]:not(.option-hide)').length) {
    formValid = true;
  }

  if (formValid) {
    $("#item-add-to-cart").prop("disabled", false);
    $("#item-add-to-cart-update").prop("disabled", false);
  } else {
    $("#item-add-to-cart").prop("disabled", true);
    $("#item-add-to-cart-update").prop("disabled", true);
  }

  // console.log("Form Status: " + formValid);
  return formValid;
}

function calculateProductTotal() {
  var $ = jQuery;

  var itemTotal = 0;
  var itemCalories = 0;

  $(
    "[data-product-selection-list] [data-product-selection-item]:not(.hide)"
  ).remove();

  $(
    "#product-detail-view [data-base-price] input[data-item-selector]:checked, #product-detail-view [data-product-option-group]:not(.hide) fieldset:not(.option-hide) input[data-item-selector]:checked, #product-detail-view [data-product-option-group]:not(.hide) fieldset:not(.option-hide) input[data-item-selector-modifier]:checked"
  ).each(function () {
    var selectedID = $(this).attr("id");

    var selectedQty = 0;
    $(
      'input[type="radio"][data-qty-for="' +
      $(this).attr("id") +
      '"]:checked, input[type="number"][data-qty-for="' +
      $(this).attr("id") +
      '"]'
    ).each(function () {
      selectedQty += Number($(this).val());
    });

    if (selectedQty == 0) {
      selectedQty = 1;
    }

    // console.log('ID: ' + selectedID, 'Label: ' + $('label[for="'+$(this).attr('id')+'"]').text(), 'Cost: $'+formatMoney($(this).attr('data-cost')), 'Qty: ' + selectedQty);

    itemTotal += Number($(this).attr("data-cost")) * selectedQty;
    if ($(this).attr("data-calories")) {
      // console.log('itemCalories', Number($(this).attr("data-calories")));

      itemCalories += Number($(this).attr("data-calories")) * selectedQty;
      // console.log('itemCalories', $(this).siblings('label').text(), itemCalories);
    } else {
      // console.log('askjfgaskjf', this);
    }

    // Add item to list
    var $itemSelectorContainer = $("[data-product-selection-list]");
    var $itemSelectorItem = $(
      "[data-product-selection-list] [data-product-selection-item].hide"
    ).clone();
    var itemID = $(this).attr("id");
    var itemName = $("label[for=" + itemID + "]")
      .find("strong")
      .text();

    var itemQty = 1;
    if ($('input[data-qty-for="' + itemID + '"]:checked').length) {
      itemQty = Number($('[data-qty-for="' + itemID + '"]:checked').val());
    }
    if ($('input[type="number"][data-qty-for="' + itemID + '"]').length) {
      itemQty = Number(
        $('input[type="number"][data-qty-for="' + itemID + '"]').val()
      );
    }

    if (itemQty > 1) {
      itemName = itemName + " (" + itemQty + ")";
    }

    if (itemName.length) {
      $itemSelectorItem.text(itemName);
      $itemSelectorItem.attr("data-item-id", itemID);

      $itemSelectorItem.removeClass("hide");
      $itemSelectorContainer.append($itemSelectorItem);

      $itemSelectorItem.click(function () {
        var unselectID = $(this).attr("data-item-id");
        $("#" + unselectID)
          .prop("checked", false)
          .change();
        // console.log("unselected", $("#" + unselectID));
      });
    } else {
      $itemSelectorItem.remove();
    }
  });

  // console.log('Total: ', '$'+formatMoney(itemTotal));

  var productQty = $("#product-item-qty").val();

  itemTotal *= Number(productQty);
  itemCalories *= Number(productQty);
  if (itemCalories != 0 || itemCalories != '0') {
    $("[data-product-total-calories]").text(itemCalories + " Calories");
  }
  $("[data-item-selection-price]").text("$ " + formatMoney(itemTotal));
}

function clearProductOptions() {
  // Clears out all options in preparation for loading another set of options.
  var $ = jQuery;
  $("#product-detail-view [data-product-option-group]:not(.hide)").each(
    function () {
      $(this).remove();
    }
  );
}

function clearBasketSession() {
  var $ = jQuery;

  // Address Selections
  localStorage.removeItem("charleys_customer_address_selected");
  localStorage.removeItem("charleys_customer_address_streetaddress");
  localStorage.removeItem("charleys_customer_address_city");
  localStorage.removeItem("charleys_customer_address_zipcode");

  // Modes
  localStorage.removeItem("charleys_customer_deliverymode");
  localStorage.removeItem("charleys_customer_schedule");

  // Basket
  localStorage.removeItem("charleys_customer_basket_id");

  // Payment Token
  localStorage.removeItem("charleys_customer_ccsf_token");

  // Schedule
  localStorage.removeItem("charleys_customer_scheduled_time");
  localStorage.removeItem("charleys_customer_scheduled_day");

  // Guest Checkout
  // localStorage.removeItem("charleys_customer_guest_first_name");
  // localStorage.removeItem("charleys_customer_guest_last_name");
  localStorage.removeItem("charleys_customer_guest_phone_number");
  localStorage.removeItem("charleys_customer_guest_email_address");

  updateBasketDisplay();
}

function charleys_set_form_errors(errorData, $form) {
  var $ = jQuery;

  if (errorData) {
    Object.keys(errorData).forEach((k, i) => {
      // console.log(result.data.errors[k]);
      if ($('input[name="' + k + '"]').length) {
        var $inputErrorMessage = $('input[name="' + k + '"]').next();
        $inputErrorMessage.attr("original-error", $inputErrorMessage.text());
        $inputErrorMessage.text(errorData[k]);
        $form.foundation("addErrorClasses", $('input[name="' + k + '"]'), []);
      }

      if (k == "base") {
        $form.find("[data-abide-error] p").text(errorData[k]);
      }
    });
  }

  $form.find("[data-abide-error]").show();
} // charleys_set_form_errors

function punchh_get_user_offers() {
  var $ = jQuery;

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "punchh_get_user_offers",
      accesstoken: localStorage.getItem("charleys_access_token"),
    },
    success: function (response) {
      // console.log(response);
    },
    complete: function () {
      charleys_hide_loading();
    },
  });
}

function punchh_get_user_points() {
  var $ = jQuery;

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "punchh_get_user_points",
      accesstoken: localStorage.getItem("charleys_access_token"),
    },
    success: function (response) {
      // console.log(response);
    },
    complete: function () {
      charleys_hide_loading();
    },
  });
}

function punchh_olo_sso(providertoken, provideruserid, isNewAccount = false) {
  var $ = jQuery;

  // console.log("olo_ss0", providertoken);

  localStorage.setItem("charleys_access_token", providertoken);
  localStorage.setItem("charleys_user_id", provideruserid);

  var olo_sso_creds = {
    provider: "punchh",
    providertoken: providertoken,
    provideruserid: provideruserid,
    basketid: $('input[name="basketGuid"]').val(),
  };

  if (isNewAccount) {
    olo_sso_creds.firstname = $('input[name="first_name"]').val();
    olo_sso_creds.lastname = $('input[name="last_name"]').val();
    olo_sso_creds.contactnumber = $('input[name="phone"]')
      .val()
      .replace(/[^\d.-]/g, "");
    olo_sso_creds.emailaddress = $('input[name="email"]').val();
  }

  // console.log(olo_sso_creds);

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "punchh_olo_authenticate",
      olo_sso_creds: olo_sso_creds,
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));

      var result = JSON.parse(response);

      localStorage.setItem("charleys_auth_token", result.authtoken);
      $('.accountButton').removeClass("hide");
      $('.signInButton').addClass("hide");

      if (isNewAccount) {
        $.when(olo_set_fave_location(Number($("#punchh_location").val()))).done(
          function (restaurant_json) {
            // console.log(restaurant_json);
            olo_login_route();
          }
        );
      } else {
        olo_login_route();
      }
    },
    complete: function () {
      charleys_hide_loading();
    },
  });
} // punchh_olo_sso

function olo_login_route() {
  // Check for basket
  if (localStorage.getItem("charleys_customer_basket_id")) {
    change_view("checkout");
  } else {
    change_view("home");
  }
}

function olo_set_fave_location(restaurant_id) {
  var $ = jQuery;

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_set_fave_location",
      authtoken: localStorage.getItem("charleys_auth_token"),
      restaurant_id: restaurant_id,
    },
    success: function (response) { },
    complete: function () { },
  });
}

function olo_delete_fave_location(restaurant_id) {
  var $ = jQuery;

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_delete_fave_location",
      authtoken: localStorage.getItem("charleys_auth_token"),
      restaurant_id: restaurant_id,
    },
    success: function (response) { },
    complete: function () { },
  });
}

function olo_get_nearby_locations(lat, lng, dist, view_context) {
  // console.log("get nearby locations");

  charleys_show_loading();

  // console.log("getLocations", lat, lng, dist);
  var $ = jQuery;

  var nearbyData = {
    action: "get_nearby_locations",
    lat: lat,
    long: lng,
    distance: dist,
  };

  // if($('[name="order-type"]:checked').val() == 'dispatch') {
  //if($('input[name="' + view_context + '-order-type"]:checked').val() == 'dispatch') {
  //  nearbyData.is_delivery = true;
  //}

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: nearbyData,
    success: function (response) {
      // console.log(response);
      var result = JSON.parse(response);
      userHasSearched = true;
      if (result.status == "success" && result.data !== null) {
        // console.log('result.data.restaurants', result.data.restaurants);
        //var isDelivery = false;
        // if($('[name="order-type"]:checked').val() == 'dispatch') {
        //if($('input[name="' + view_context + '-order-type"]:checked').val() == 'dispatch') {
        //  isDelivery = true;
        //}

        set_location_selections(result.data.restaurants, view_context);
        // charleys_hide_loading();
      } else {
        // console.log('no result.data.restaurants', result.data.restaurants);

        set_location_selections({}, view_context);
        // charleys_hide_loading();
      }
    },
    complete: function () { },
  });
}

function clearLocationList() {
  var $ = jQuery;
  // move the order type selector outside of the location item so it doesn't get wiped out
  $("#start-order-order-location-search-error-delivery").addClass("hide");
  $("#start-order-order-location-search-error").addClass("hide");
  $(".wf-ordering-start-order").append(
    $("#start-order-select-order-type-embedded")
  );
  // Clear any restaurant listings
  $("[data-location-list] [data-location-item-template]:not(.hide)").remove();
}

function set_location_selections(restaurants, view_context) {
  var $ = jQuery;

  // console.log("Set Location Selections", restaurants);

  clearLocationList();

  //var orderType = $('input[name="' + view_context + '-order-type"]:checked').val();

  // Hide not found message
  $("[data-location-not-found]").addClass("hide");
  $("[data-location-found]").addClass("hide");
  $("[data-location-not-selected]").addClass("hide");
  $("#" + view_context + "-order-location-search").removeClass("form-alert");
  $("#" + view_context + "-order-location-search-error").addClass("hide");
  $("#" + view_context + "-order-location-search-error-delivery").addClass(
    "hide"
  );

  //var isDelivery = false;
  // if($('[name="order-type"]:checked').val() == 'dispatch') {
  //if(orderType == 'dispatch') {
  //  isDelivery = true;
  //}
  //redo search if user clicks wings box
  $("#wingsLocationsCheckbox").change(function () {
    $("#start-order-order-location-search-form").submit();
  });
  // Clear all map markers
  if ($("#tt-map").length) {
    for (var m = 0; m < order_markers.length; m++) {
      order_markers[m].remove();
    }
    order_markers = [];
  }
  // Create a Set to keep track of processed restaurant IDs
  const processedIds = new Set();
  if (restaurants !== null && restaurants.length) {
    for (var i = 0; i < restaurants.length; i++) {
      const restaurant = restaurants[i];
      if (!processedIds.has(restaurant.id)) {
        // console.log('restaurant.id', restaurant.id);
        processedIds.add(restaurant.id);
        if ($('#wingsLocationsCheckbox').prop('checked')) {
          //only wings
          if (restaurants[i]['location_groups'].split(',').includes('cpsw')) {
            // console.log("only wings");
            getLocationInfo();
          }
        } else {
          //all stores
          // console.log("not only wings");
          getLocationInfo();
        }
        function getLocationInfo() {
          if (restaurants[i].isavailable) {
            // Ensure store is available

            // console.log(restaurants[i]);
            //console.log(isDelivery, restaurants[i].supportsdispatch);

            if ($("#tt-map").length) {

              var order_popupHTML =
                '<div class="title">' +
                "<strong>" +
                restaurants[i].name +
                "</strong>" +
                "</div>" +
                '<div class="address">' +
                restaurants[i].streetaddress +
                "<br /> " +
                restaurants[i].city +
                ", " +
                restaurants[i].state +
                " " +
                restaurants[i].zip +
                "</div>" +
                '<div class="phone"><a href="tel:' +
                restaurants[i].telephone +
                '" class="underline">' +
                restaurants[i].telephone +
                "</a></div>";
              if (("location_groups" in restaurants[i]) && restaurants[i]["location_groups"].includes("cpsw")) {
                order_popupHTML += '<div class="wings-on-map"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true"> <path d="M5.84536 15.875C6.07036 16.3417 5.99536 16.9083 5.60369 17.2917C5.43406 17.4638 5.21786 17.5828 4.98161 17.6339C4.74537 17.685 4.49934 17.666 4.27372 17.5793C4.0481 17.4926 3.85269 17.3419 3.71147 17.1457C3.57024 16.9496 3.48934 16.7165 3.47869 16.475C3.23721 16.4643 3.0041 16.3834 2.80794 16.2422C2.61178 16.101 2.4611 15.9056 2.37439 15.68C2.28768 15.4543 2.26871 15.2083 2.31981 14.9721C2.3709 14.7358 2.48983 14.5196 2.66202 14.35C3.04536 13.9667 3.62036 13.8833 4.07869 14.1083L6.14536 12.0833C6.26202 12.2417 6.39536 12.425 6.54536 12.575L7.37036 13.4C7.54536 13.5667 7.71202 13.7083 7.92869 13.8333L5.84536 15.875Z" stroke="#e21837" stroke-width="0.8"></path> <path d="M16.799 10.6126C17.3532 10.0591 17.7759 9.38819 18.0358 8.64936C18.2958 7.91054 18.3863 7.12274 18.3007 6.34423C18.215 5.56571 17.9555 4.8164 17.5412 4.15172C17.127 3.48704 16.5686 2.92399 15.9074 2.50422C14.2324 1.39589 11.9907 1.38755 10.299 2.47922C8.83238 3.42089 8.02405 4.88755 7.88238 6.40422C7.77405 7.50422 7.35738 8.52922 6.59071 9.29589L6.56571 9.32089C5.59905 10.2876 5.59905 11.7626 6.50738 12.6626L7.33238 13.4876C7.76898 13.9239 8.36097 14.169 8.97821 14.169C9.59546 14.169 10.1874 13.9239 10.624 13.4876C11.4324 12.6792 12.499 12.2376 13.6574 12.1126C14.799 11.9876 15.9157 11.4876 16.799 10.6126Z" fill="#e21837" stroke="#e21837" stroke-width="0.8"></path> </svg><p>WINGS AVAILABLE</p></div>';
              }

              order_markers.push(
                createMarker(
                  [
                    parseFloat(restaurants[i].longitude),
                    parseFloat(restaurants[i].latitude),
                  ],
                  order_popupHTML,
                  ttmap_order
                )
              );
            }

            var supportedOrderTypes = [];

            // Since we have to use olo_check_delivery_coverage, php will convert booleans to strings in json.
            var canDispatch =
              restaurants[i].supportsdispatch === "true"
                ? true
                : restaurants[i].supportsdispatch === "false"
                  ? false
                  : restaurants[i].supportsdispatch;
            if (canDispatch) {
              supportedOrderTypes.push("dispatch");
            }
            var canCurbside =
              restaurants[i].supportscurbside === "true"
                ? true
                : restaurants[i].supportscurbside === "false"
                  ? false
                  : restaurants[i].supportscurbside;
            if (canCurbside) {
              supportedOrderTypes.push("curbside");
            }
            var canPickup =
              restaurants[i].canpickup === "true"
                ? true
                : restaurants[i].canpickup === "false"
                  ? false
                  : restaurants[i].canpickup;
            if (canPickup) {
              supportedOrderTypes.push("pickup");
            }
            var canDinein =
              restaurants[i].supportsdinein === "true"
                ? true
                : restaurants[i].supportsdinein === "false"
                  ? false
                  : restaurants[i].supportsdinein;
            if (canDinein) {
              supportedOrderTypes.push("dinein");
            }

            // if(isDelivery && !(supportedOrderTypes.includes('dispatch'))) { // If customer has chosen delivery, ensure it supports dispatch
            //   console.log('continue');
            //   continue;
            // }

            //console.log(orderType, supportedOrderTypes);

            //if(!supportedOrderTypes.includes(orderType)) {
            //  console.log('continue');
            //  continue;
            //}

            var $locationItem = $('#order-location-list [data-location-item-template].hide').clone();

            var locationHours = '';

            $.each(restaurants[i].calendar, function (key, calendar) {
              // console.log('calendar', calendar);
              if (typeof calendar.ranges !== 'undefined' && calendar.ranges !== null && calendar.ranges.length) {
                var storeCalendar = calendar.ranges[0];
                var startDate = new Date(storeCalendar.start.substr(0, 4) + '-' + storeCalendar.start.substr(4, 2) + '-' + storeCalendar.start.substr(6, 2) + 'T' + storeCalendar.start.substr(9, 5));
                var endDate = new Date(storeCalendar.end.substr(0, 4) + '-' + storeCalendar.end.substr(4, 2) + '-' + storeCalendar.end.substr(6, 2) + 'T' + storeCalendar.end.substr(9, 5));

                var hourslabel = calendar.type.charAt(0).toUpperCase() + calendar.type.substr(1).toLowerCase();
                if (calendar.label !== null) {
                  hourslabel = calendar.label.charAt(0).toUpperCase() + calendar.label.substr(1).toLowerCase();
                } else if (calendar.type == 'dinein') {
                  hourslabel = "Dine In";
                }

                locationHours += hourslabel + ' Hours: ' + formatAMPM(startDate) + ' - ' + formatAMPM(endDate) + '<br>';
              }
            });

            $locationItem.find('[data-location-hours]').html(locationHours);
            $locationItem.find('.order-button').attr('data-store-url', restaurants[i].url);
            $locationItem.find('.order-button').attr('data-store-number', restaurants[i].extref);

            // military base alt. flow
            let militaryBaseIds = [
              254063, // #209 Andrews AFB
              254058, // #292 Fort Leavenworth
              254050, // #242 Ft Gregg Adams
              254072, // #195 Fort Robins AFB
              254056, // #418 Fort Leonard Wood
              254066, // #163 Fort Jackson
              254070, // #388 Fort Irwin
              254061, // #139 Fort Sam Houston 
              254085, // #532 Nellis
              254077, // #247 Fort Stewart Exchange 
              254073, // #142 Tinker Barracks
              254055, // #394 Schofield Barracks
              254083, // #612 Fort Bliss
              254051, // #77 Hickam AFB
              254227, // #396 Fort Sill 
              254053, // #277 Barksdale AFB
              254065, // #221 Fort Eisenhower
              251330, // #366 Luke AFB 
              254229, // #351 Fort Eustis 
              254084, // #678 Fort Bliss III 
              254059, // #594 Randolph AFB II
              254079, // #177 Fort Carson
              254074, // #411 Holloman AFB
              254069, // #91 Elmendorf AFB
              254067, // #393 Peterson AFB
              254064, // #308 Eglin AFB 
              251327, // #353 Fort Drum
              251340, // #499 Fort Moore 
              251329, // #376 Travis AFB
              251331, // #845 Fort Huachuca 
              251343, // #845 Fort Meade II 
              226114, // #679 JBLM North Post Food Court
              226115, // #232 Fort Liberty Mini Mall Food Court
              226116, // #230 Ft Lewis Shopping Center Food Ct
              226117, // #326 Ft Liberty North Post Food Court
              226118, // #325 JBLM McChord Food Court
              226119,
              226120, // #188 Fort Campbell Food Court
              226121, // #119 Ft Liberty S Post Food Court
              226122, // #375 Ft Liberty 82nd Airborne Food Ct
              226123, // #869 Ft Cavazos Clear Creek Food Court
              251341, // #303 Hill AFB
              251332, // #804 Fort Belvoir II
              251335, // #549 Fort Riley II
              // 251334, // #360 Edwards AFB
              251338, // #350 Davis Monthan AFB
              251339, // #140 Fort Riley
              251342, // #614 Fort Johnson II
              251333, // #342 Fort Knox
              226116 // #230 Ft Lewis Shopping Center Food Ct
            ];

            if (militaryBaseIds.includes(restaurants[i]["id"])) {
              $locationItem.find(".location-button-container").addClass("hide");
              $locationItem.find(".location-button-container-military").removeClass("hide");
            }
            if (("location_groups" in restaurants[i]) && restaurants[i]["location_groups"].includes("cpsw")) {
              $locationItem.find(".location-indicators").removeClass("hidden");
              $locationItem.find(".location-indicator-wing").removeClass("hide");
              // console.log("yes wings :)");

            } else {
              // console.log("no wings :(");
            }
            $locationItem.find(".pickup-button").click(function () {
              // window.location.href = $(this).closest('.location-item').find('.order-button').attr('data-store-url');
            });

            let doordashLink = 'https://doordash.com';
            switch (restaurants[i]["id"]) {
              case 254063: // #209 Andrews AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-joint-base-andrews-2526803/';
                break;
              case 254058: // #292 Fort Leavenworth
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-leavenworth-2491527/';
                break;
              case 254050: // #242 Ft Gregg Adams
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-fort-lee-1841987/';
                break;
              case 254072: // #195 Fort Robins AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-robins-air-force-base-23106290/';
                break;
              case 254056: // #418 Fort Leonard Wood
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-fort-leonard-wood-2303991/';
                break;
              case 254066: // #163 Fort Jackson
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-columbia-2427717/';
                break;
              case 254070: // #388 Fort Irwin
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-fort-irwin-2197122/';
                break;
              case 254061: // #139 Fort Sam Houston
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-san-antonio-2197204/';
                break;
              case 254085: // #532 Nellis
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-nellis-air-force-base-2375699/';
                break;
              case 254077: // #247 Fort Stewart Exchange
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-and-wings-fort-stewart-2196993/';
                break;
              case 254073: // #142 Tinker Barracks
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-oklahoma-city-2529666/';
                break;
              case 254055: // #394 Schofield Barracks
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-schofield-barracks-2267619/';
                break;
              case 254083: // #612 Fort Bliss
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-bliss-1794073/';
                break;
              case 254051: // #77 Hickam AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-joint-base-pearl-harbor-hickam-2267758/';
                break;
              case 254227: // #396 Fort Sill
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-sill-1841729/';
                break;
              case 254053: // #277 Barksdale AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-barksdale-air-force-base-24700402/';
                break;
              case 254065: // #221 Fort Eisenhower
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-augusta-1825126/';
                break;
              case 251330: // #366 Luke AFB 
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-glendale-24063923/';
                break;
              case 254229: // #351 Fort Eustis 
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-newport-news-2137844/';
                break;
              case 254084: // #678 Fort Bliss III 
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-bliss-1794170/';
                break;
              case 254059: // #594 Randolph AFB II
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-universal-city-2195468/';
                break;
              case 254079: // #177 Fort Carson
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-carson-1662330/';
                break;
              case 254074: // #411 Holloman AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-holloman-air-force-base-2376559/';
                break;
              case 254069: // #91 Elmendorf AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-anchorage-2375955/';
                break;
              case 254067: // #393 Peterson AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-colorado-springs-24063755/';
                break;
              case 254064: // #308 Eglin AFB 
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-eglin-air-force-base-1897146/';
                break;
              case 251327: // #353 Fort Drum
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-drum-1897286/';
                break;
              case 251340: // #499 Fort Moore 
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-benning-1899555/';
                break;
              case 251329: // #376 Travis AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-carson-1662330/';
                break;
              case 251331: // #323 Fort Huachuca
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-sierra-vista-2433373/';
                break;
              case 251343: // #845 Fort Meade II 
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-meade-2466507/';
                break;
              case 226114: // #679 JBLM North Post Food Court
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-lewis-1841146/29765746/';
                break;
              case 226115: // #232 Fort Liberty Mini Mall Food Court
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-bragg-1672000/29134952/';
                break;
              case 226116: // #230 Ft Lewis Shopping Center Food Ct
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-tacoma-1841808/29165348/';
                break;
              case 226117: // #326 Ft Liberty North Post Food Court
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-bragg-1672038/29130357/';
                break;
              case 226118: // #325 JBLM McChord Food Court
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-joint-base-lewis-mcchord-1841832/29157347/';
                break;
              case 226119:
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-hood-1624506/29154949/';
                break;
              case 226120: // #188 Fort Campbell Food Court
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-campbell-1897032/29139351/';
                break;
              case 226121: // #119 Ft Liberty S Post Food Court
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-bragg-1672652/29129355/';
                break;
              case 226122: // #375 Ft Liberty 82nd Airborne Food Ct
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-bragg-1672005/29158152/';
                break;
              case 226123: // #869 Ft Cavazos Clear Creek Food Court
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-hood-1624917/29167948/';
                break;

              case 251341: // #303 Hill AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-hill-air-force-base-2526788/';
                break;
              case 251332: // #804 Fort Belvoir II
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-belvoir-1897088/';
                break;
              case 251335: // #549 Fort Riley II
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-riley-2376578/';
                break;
              // case 251334: // #360 Edwards AFB
              //   doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-riley-2376578/';
              //   break;
              case 251338: // #350 Davis Monthan AFB
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-tucson-2491517/';
                break;

              case 251339: // #140 Fort Riley
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-riley-2377506/';
                break;
              case 251342: // #614 Fort Johnson II
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-polk-south-2433364/';
                break;
              case 251333: // #342 Fort Knox
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-fort-knox-2526590/';
                break;
              case 226116: // #230 Ft Lewis Shopping Center Food Ct
                doordashLink = 'https://www.doordash.com/store/charleys-cheesesteaks-tacoma-1841808/29165348/';
                break;
            }

            $locationItem.find(".delivery-button").click(function () {
              window.location.href = doordashLink;
            });

            new Foundation.Accordion($locationItem.find('[data-accordion]'));

            if (restaurants[i].customerfacingmessage) {
              $locationItem.find('[data-location-customer-message]').text(restaurants[i].customerfacingmessage);
              $locationItem.find('[data-location-customer-message]').removeClass('hide');
            }

            // if(restaurants[i].calendar) {
            //   var storeCalendar = restaurants[i].calendar[0].ranges[0];
            //   var startDate = new Date(storeCalendar.start.substr(0,4) + '-' + storeCalendar.start.substr(4,2) + '-' + storeCalendar.start.substr(6,2) + 'T' + storeCalendar.start.substr(9, 5));
            //   var endDate = new Date(storeCalendar.end.substr(0,4) + '-' + storeCalendar.end.substr(4,2) + '-' + storeCalendar.end.substr(6,2) + 'T' + storeCalendar.end.substr(9, 5));
            //
            //   $locationItem.find('[data-location-hours]').text('Business Hours: ' + formatAMPM(startDate) + ' - ' + formatAMPM(endDate));
            //
            //   if(restaurants[i].calendar.length > 1) {
            //     var deliveryCalendar = restaurants[i].calendar[1].ranges[0];
            //     var startDate_d = new Date(deliveryCalendar.start.substr(0,4) + '-' + deliveryCalendar.start.substr(4,2) + '-' + deliveryCalendar.start.substr(6,2) + 'T' + storeCalendar.start.substr(9, 5));
            //     var endDate_d = new Date(deliveryCalendar.end.substr(0,4) + '-' + deliveryCalendar.end.substr(4,2) + '-' + deliveryCalendar.end.substr(6,2) + 'T' + storeCalendar.end.substr(9, 5));
            //
            //     $locationItem.find('[data-location-hours-delivery]').text('Delivery Hours: ' + formatAMPM(startDate_d) + ' - ' + formatAMPM(endDate_d));
            //   } else {
            //     $locationItem.find('[data-location-hours-delivery]').remove();
            //   }
            // } else {
            //   $locationItem.find('[data-location-hours]').remove();
            //   $locationItem.find('[data-location-hours-delivery]').remove();
            // }

            $locationItem.find("[data-location-name]").html(restaurants[i]["name"]);

            // Fav button
            if (
              localStorage.getItem("charleys_visitor_nearest_location_id") ==
              restaurants[i]["id"]
            ) {
              $locationItem
                .find(".set-location-button")
                .addClass("current-location");
            }

            $locationItem
              .find(".set-location-button")
              .attr("data-location-id", restaurants[i]["id"]);
            $locationItem
              .find(".set-location-button")
              .attr("data-title", restaurants[i]["name"]);
            // console.log('adsgasdg', restaurants[i]);
            $locationItem
              .find(".set-location-button")
              .attr("data-permalink", restaurants[i]["permalink"]);
            $locationItem
              .find(".set-location-button")
              .attr("data-store-id", restaurants[i]["extref"]);
            $locationItem
              .find(".set-location-button")
              .attr("data-location-groups", restaurants[i]["location_groups"]);

            if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes($locationItem.attr("data-store-number")))) {
              $locationItem
                .find(".set-location-button")
                .attr("data-order-url", "/order/?store=" + restaurants[i]["slug"]);
            } else {
              $locationItem
                .find(".set-location-button")
                .attr("data-order-url", restaurants[i]["url"]);
            }

            $locationItem.find(".set-location-button").click(function () {
              setAsStore(
                $(this).attr("data-location-id"),
                $(this).attr("data-title"),
                $(this).attr("data-order-url"),
                $(this).attr("data-permalink"),
                $(this).attr("data-store-id"),
                $(this).attr("data-location-groups")
              );
            });

            // console.log('distance: ', restaurants[i]['distance'], Number(restaurants[i]['distance']));

            if (restaurants[i]["distance"] == 0) {
              $locationItem.find("[data-location-distance]").addClass("hide");
            }
            $locationItem
              .find("[data-location-distance]")
              .text(restaurants[i]["distance"] + " miles away");

            var storeAddress =
              restaurants[i]["streetaddress"] +
              "<br> " +
              restaurants[i]["city"] +
              ", " +
              restaurants[i]["state"] +
              " " +
              restaurants[i]["zip"];
            $locationItem.find("[data-location-address]").html(storeAddress);
            $locationItem
              .find("[data-location-phone]")
              .attr("href", "tel:" + restaurants[i]["telephone"].replace(/[\s()-]/g, ""))
              .text(restaurants[i]["telephone"]);

            $locationItem
              .find(".location-learn-more")
              .attr("href", restaurants[i]["permalink"]);

            $locationItem.attr("data-store-number", restaurants[i]["extref"]);
            $locationItem.attr("data-store-url", restaurants[i]["url"]);

            $locationItem.attr("data-location-id", restaurants[i]["id"]);
            $locationItem.attr("data-location-name", restaurants[i]["name"]);
            $locationItem.attr(
              "data-location-address",
              restaurants[i]["streetaddress"]
            );
            $locationItem.attr(
              "data-location-city-zip",
              restaurants[i]["city"] +
              ", " +
              restaurants[i]["state"] +
              " " +
              restaurants[i]["zip"]
            );

            $locationItem.attr(
              "data-supportsbaskettransfers",
              restaurants[i]["supportsbaskettransfers"]
            );

            $locationItem.find(".location-learn-more").click(function (e) {
              e.stopPropagation();
            });

            supportedOrderTypes.forEach(function (supportedOrderType) {
              $locationItem
                .find(".supported-order-type-" + supportedOrderType)
                .text("yes");
            });

            // Select A Location
            $locationItem.find(".order-button").click(function () {
              // console.log("clicked");
              $(this).fadeOut(400, function () {
                $(this).hide(); // Optional: ensure the element is completely hidden
              });
              hideFakeMenuIfAddedLocation();
              if (experienceOptInStores === null || (experienceOptInStores !== null && experienceOptInStores.includes($(this).attr("data-store-number")))) {

                var thisOrderTypeContainer = $(this)
                  .closest(".location-item")
                  .find(".location-order-type-container");

                $("#start-order-order-location-search-error-delivery").addClass(
                  "hide"
                );
                $("#start-order-order-location-search-error").addClass("hide");

                if (!thisOrderTypeContainer.hasClass("last-selected")) {
                  $(".location-order-type-container.last-selected").addClass(
                    "location-order-type-container-hidden"
                  );
                  $(".location-order-type-container").removeClass("last-selected");

                  thisOrderTypeContainer.addClass("last-selected");

                  $("#start-order-select-order-type-embedded").appendTo(
                    thisOrderTypeContainer
                  );
                  $("#start-order-select-order-type-embedded").removeClass("hide");
                }

                if (
                  thisOrderTypeContainer.hasClass(
                    "location-order-type-container-hidden"
                  )
                ) {
                  thisOrderTypeContainer.removeClass(
                    "location-order-type-container-hidden"
                  );

                } else {
                  thisOrderTypeContainer.addClass(
                    "location-order-type-container-hidden"
                  );
                }

                var thisLocationItem = $(this).closest(".location-item");

                $(".start-order-order-type-label").show();
                $("#pickup").prop("checked", true).change();
                // $("#start-order-asap").prop("checked", true).change();

                if (
                  thisLocationItem.find(".supported-order-type-pickup").text() !=
                  "yes"
                ) {
                  $("label[for='pickup']").hide();
                  if ($("#pickup").prop("checked")) {
                    $("#pickup").prop("checked", false);
                    $("#curbside").prop("checked", true);
                  }

                }

                if (
                  thisLocationItem.find(".supported-order-type-curbside").text() !=
                  "yes"
                ) {
                  $("label[for='curbside']").hide();
                  if ($("#curbside").prop("checked")) {
                    $("#curbside").prop("checked", false);
                    $("#dispatch").prop("checked", true);
                  }
                }

                if (
                  thisLocationItem.find(".supported-order-type-dinein").text() !=
                  "yes"
                ) {
                  $("label[for='dinein']").hide();
                  if ($("#dinein").prop("checked")) {
                    $("#dinein").prop("checked", false);
                    $("#dispatch").prop("checked", true);
                  }
                }

                if (
                  thisLocationItem.find(".supported-order-type-dispatch").text() !=
                  "yes"
                ) {
                  $("label[for='dispatch']").hide();
                }

                $([document.documentElement, document.body]).animate(
                  {
                    scrollTop: $("#start-order-select-order-type-embedded")
                      .closest(".location-item")
                      .offset().top,
                  },
                  1000
                );

              } else {

                // Opt-out store, go to store page
                charleys_show_loading();
                if (localStorage.getItem('charleys_access_token')) {
                  window.location = 'https://order.charleys.com/login/punchh/' + localStorage.getItem('charleys_access_token');
                } else {
                  window.location = $(this).attr('data-store-url');
                }

              }
              //$('.data-order-type-location-id').text($(this).attr('data-location-id'));

              //$('#' + view_context + '-select-order-type').foundation('open');
              //$('#' + view_context + '-select-order-type-button').trigger('click');
            });

            // set fave button status
            // if (localStorage.getItem("charleys_auth_token")) {
            //   $.ajax({
            //     type: "POST",
            //     url: ajax_url,
            //     data: {
            //       action: "olo_get_fave_locations",
            //       authtoken: localStorage.getItem("charleys_auth_token"),
            //     },
            //     success: function (response) {
            //       result = JSON.parse(response);
            //
            //       var is_fave = false;
            //       if ("favelocations" in result) {
            //         result.favelocations.every(function (fave) {
            //           if (fave.vendorid == $locationItem.attr("data-location-id")) {
            //             is_fave = true;
            //           }
            //           return !is_fave;
            //         });
            //       }
            //
            //       if (is_fave) {
            //         $locationItem
            //           .find(".location-favorite")
            //           .addClass("location-favorite-active");
            //         $locationItem.find(".fa-star-o").addClass("fa-star");
            //         $locationItem.find(".fa-star-o").removeClass("fa-star-o");
            //       }
            //     },
            //   });
            // }

            $locationItem.removeClass("hide");
            $("[data-location-list]").append($locationItem);
          }
        }
      } else {
        // console.log('processedId already exists');
      }

    }

    if (!$("[data-location-list] .location-item:not(.hide)").length) {
      if (userHasSearched) {
        $("[data-location-not-found]").removeClass("hide");
      } else {
        $("[data-location-not-selected]").removeClass("hide");
      }
    } else {
      $("[data-location-found]").removeClass("hide");
    }
    if ($("#tt-map").length) {

      fitToMarkerBounds_order(ttmap_order);
    }
  } else {
    if (userHasSearched) {
      $("[data-location-found]").addClass("hide");
      $("[data-location-not-found]").removeClass("hide");
    } else {
      $("[data-location-not-selected]").removeClass("hide");
    }
  }

  $(".location-favorite").click(function (e) {
    e.stopPropagation();
    if (!$(this).hasClass("location-favorite-active")) {
      olo_delete_fave_location(
        $(".location-favorite-active")
          .closest(".location-item")
          .data("location-id")
      );

      // $(".location-favorite-active").find(".fa-star").addClass("fa-star-o");
      // $(".location-favorite-active").find(".fa-star").removeClass("fa-star");

      $(".location-favorite-active").removeClass("location-favorite-active");

      olo_set_fave_location(
        $(this).closest(".location-item").data("location-id")
      );

      $(this).addClass("current-location");

      // $(this).find(".fa-star-o").addClass("fa-star");
      // $(this).find(".fa-star-o").removeClass("fa-star-o");
      $(this).addClass("location-favorite-active");
    }
  });

  /*
  $('#' + view_context + '-select-order-type-button').click(function() {
    //$('#' + view_context + '-select-order-type').foundation('close');

    var validAddress = true;
    var isDelivery = Boolean($('input[name="' + view_context + '-order-type"]:checked').val() == 'dispatch');
    console.log('location id');
    console.log($(this).closest('#' + view_context + '-select-order-type').find('[data-order-type-location-id]').text());
    var vendorid = $(this).closest('#' + view_context + '-select-order-type').find('[data-order-type-location-id]').text();
    var supportsbaskettransfers = ($(this).attr('data-supportsbaskettransfers') == 'true');

    // Delivery requires a full address, thus fails validation if no street address is present
    if(isDelivery && !$('#' + view_context + '-order-location-search-streetaddress').val().length) {
      validAddress = false;
    }

    console.log('validAddress', validAddress);

    $('#' + view_context + '-order-location-search').removeClass('form-alert');
    $('#' + view_context + '-order-location-search-error').addClass('hide');

    if(validAddress) {

      charleys_show_loading();
      setAddressComponents(view_context);
      selectLocation(vendorid, supportsbaskettransfers, false, view_context);

    } else {
      $('#' + view_context + '-order-location-search').addClass('form-alert');
      $('#' + view_context + '-order-location-search-error').removeClass('hide');
    }
  });
  */

  charleys_hide_loading();
}

function selectLocation(
  vendorid,
  supportsbaskettransfers,
  showcartdialog = false,
  view_context
) {
  var $ = jQuery;
  // console.log(
  //   "selectLocation",
  //   vendorid,
  //   supportsbaskettransfers,
  //   showcartdialog,
  //   view_context
  // );
  // clearBasketSession();
  charleys_show_loading();
  $.when(olo_create_basket(vendorid, supportsbaskettransfers)).done(function (
    ocb_json
  ) {
    // console.log(ocb_json);
    var ocb = JSON.parse(ocb_json);
    $.when(
      olo_set_basket_settings(
        view_context,
        ocb.earliestreadytime,
        Number(ocb.leadtimeestimateminutes)
      )
    ).done(function (osbs_json) {
      // Go to the restaurant menu
      var osbs = JSON.parse(osbs_json);
      // console.log('osbs', osbs);
      // Display basket setting errors
      // Dispatch address
      if ("dispatchaddress" in osbs && "code" in osbs.dispatchaddress) {
        $("[data-delivery-error]").text(osbs.dispatchaddress.message);
        $(
          "#" + view_context + "-order-location-search-error-delivery"
        ).removeClass("hide");
        clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
        charleys_hide_loading();
        // Time wanted
      } else if ("timewanted" in osbs && "code" in osbs.timewanted) {
        $("[data-delivery-error]").text(osbs.timewanted.message);
        $(
          "#" + view_context + "-order-location-search-error-delivery"
        ).removeClass("hide");
        clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
        charleys_hide_loading();
        // Delivery mode
      } else if ("deliverymode" in osbs && "code" in osbs.deliverymode) {
        $("[data-delivery-error]").text(osbs.deliverymode.message);
        $(
          "#" + view_context + "-order-location-search-error-delivery"
        ).removeClass("hide");
        clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
        charleys_hide_loading();
        // Otherwise, good to proceed
      } else {
        updateBasketDisplay();
        if ($("#home-select-order-type").length) {
          $("#home-select-order-type").foundation("close");
        }
        if ($("#account-select-order-type").length) {
          $("#account-select-order-type").foundation("close");
        }
        if ($("#location-detail-select-order-type").length) {
          $("#location-detail-select-order-type").foundation("close");
        }

        if (view_context == "block") {
          change_view("menu-cart");
        } else {
          charleys_hide_loading();
          change_view("menu");
        }

        if (showcartdialog) {
          $("#shopping-cart-view").foundation("open");
          $(".reveal-overlay").addClass('differnt-popup-overlay');
        } else {
          $(".reveal-overlay").removeClass('differnt-popup-overlay');

        }
      }
    });
  });
}

function setGoogleReferral() {
  var $ = jQuery;

  let googleReferralToken = getCookie('charleys_google_referral_token');
  // console.log('googleReferralToken');
  // console.log(googleReferralToken);

  if (typeof googleReferralToken !== 'undefined' && googleReferralToken.length > 0) {
    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'set_olo_basket_referral',
        authtoken: localStorage.getItem('charleys_auth_token'),
        basketGuid: localStorage.getItem('charleys_customer_basket_id')
      }
    });
  }
}

function setAddressComponents(view_context) {
  var $ = jQuery;

  let address_selected = $("#" + view_context + "-order-location-search").val();
  if (view_context == "start-order" || view_context == "location-detail") {
    address_selected = $(
      "#" + view_context + "-order-location-search-delivery"
    ).val();
  }

  localStorage.setItem("charleys_customer_address_selected", address_selected);
  localStorage.setItem(
    "charleys_customer_address_streetaddress",
    $("#" + view_context + "-order-location-search-streetaddress").val()
  );
  localStorage.setItem(
    "charleys_customer_address_city",
    $("#" + view_context + "-order-location-search-city").val()
  );
  localStorage.setItem(
    "charleys_customer_address_zipcode",
    $("#" + view_context + "-order-location-search-zipcode").val()
  );

  // if($('[name="order-type"]:checked') == 'dispatch') {
  if (
    $('input[name="' + view_context + '-order-type"]:checked').val() ==
    "dispatch"
  ) {
    localStorage.setItem(
      "charleys_customer_address_building",
      $("#" + view_context + "-order-location-search-building").val()
    );
  } else {
    localStorage.removeItem("charleys_customer_address_building");
  }

  localStorage.setItem(
    "charleys_customer_schedule",
    $('input[name="' + view_context + '-order-schedule"]:checked').val()
  );

  var deliverymode = $(
    'input[name="' + view_context + '-order-type"]:checked'
  ).val();

  // localStorage.setItem('charleys_customer_deliverymode', $('[name="order-type"]:checked').val());
  localStorage.setItem("charleys_customer_deliverymode", deliverymode);

  if (
    $('[name="' + view_context + '-order-schedule"]:checked').val() == "advance"
  ) {
    localStorage.setItem(
      "charleys_customer_scheduled_day",
      $("#" + view_context + "-time-wanted-day").val()
    );
    localStorage.setItem(
      "charleys_customer_scheduled_time",
      $("#" + view_context + "-time-wanted-time-slot").val()
    );
  } else {
    localStorage.removeItem("charleys_customer_scheduled_day");
    localStorage.removeItem("charleys_customer_scheduled_time");
  }
}

function updateBasketDisplay(openBasket = false) {
  var $ = jQuery;

  // console.log("updateBasket");

  charleys_show_loading();

  canCheckout = false;

  $(".shopping-cart-icon [data-counter]").addClass("hide");

  // if(isUserLoggedIn(true)) {
  //   $('[data-group-order-button]').removeClass('hide');
  // } else {
  //   $('[data-group-order-button]').addClass('hide');
  // }

  // Session Basket ID is present, check if basket exists in OLO systems
  if (localStorage.getItem("charleys_customer_basket_id")) {
    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_basket",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      },
      success: function (response) {
        // console.log(response);
        // console.log('customers basket', JSON.parse(response));
        var result = JSON.parse(response);

        // reset basket
        $("[data-cart-empty]").removeClass("hide");
        $("[data-cart-product-template]:not(.hide), [data-tax-row-template]:not(.hide)").each(function () {
          $(this).remove();
        });
        $("[data-cart-upsell-items]").addClass("hide");
        $("[data-cart-totals]").addClass("hide");
        $(".shopping-cart-icon [data-counter]").addClass("hide");

        // Basket Found
        if (result.id) {
          // console.log("basket found");
          // Show cart location detail block
          $("[data-location-order-details]").removeClass("hide");
          $("[data-add-another-menu-item]").removeClass("hide");
          $("[data-start-a-new-order]").addClass("hide");

          // Set Delivery and Time Mode
          var deliverymode = result.deliverymode;
          if (result.deliverymode == "dispatch") {
            deliverymode = "Delivery";
          }
          $("[data-delivery-mode]").text(deliverymode);
          $("[data-timemode]").text(result.timemode.toUpperCase());

          var customer_schedule = result.timemode.toUpperCase();

          // console.log(customer_schedule, result);

          if (customer_schedule !== "ASAP") {
            var timeWanted = "";
            if (result.timewanted) {
              timeWanted = result.timewanted.split(" ");
            }
            var scheduledTime = "";
            var scheduledDate = "";

            // console.log(timeWanted.length);

            if (timeWanted.length > 0) {
              scheduledDate = timeWanted[0];
              scheduledTime = timeWanted[1];
              scheduledDate =
                scheduledDate.substring(4, 6) +
                "-" +
                scheduledDate.substring(6, 8) +
                "-" +
                scheduledDate.substring(0, 4);
            }

            // console.log(scheduledTime);

            if (scheduledTime.substring(0, 2) > 12) {
              scheduledTime =
                scheduledTime.substring(0, 2) -
                12 +
                scheduledTime.substring(2) +
                " PM";
            } else {
              if (scheduledTime.substring(0, 2) == 12) {
                scheduledTime = scheduledTime + " PM";
              } else {
                scheduledTime = scheduledTime + " AM";
              }
            }

            customer_schedule =
              "at <strong>" +
              scheduledTime +
              "</strong> on <strong>" +
              scheduledDate +
              "</strong>";
          } else {
            customer_schedule =
              "<strong>" + customer_schedule.toUpperCase() + "</strong>";
          }
          $("[data-delivery-timing]").html(customer_schedule);

          $.when(
            olo_get_restaurant(
              localStorage.getItem("charleys_customer_store_location_id")
            )
          ).done(function (restaurant_data_json) {
            var restaurant_data = JSON.parse(restaurant_data_json);
            // console.log('restaurant_data', restaurant_data);
            $("[data-menu-selected-store]").text(restaurant_data.name);

            restaurant_data.labels.forEach(function (label) {
              if (
                label.key ==
                "handoffmode_" +
                localStorage.getItem("charleys_customer_deliverymode")
              ) {
                $("[data-menu-handoff-mode]").text(label.value);
              }
            });

            var customer_schedule = localStorage.getItem(
              "charleys_customer_schedule"
            );
            if (customer_schedule !== "asap") {
              var scheduledTime = localStorage.getItem(
                "charleys_customer_scheduled_time"
              );

              if (scheduledTime.substring(0, 2) > 12) {
                scheduledTime =
                  scheduledTime.substring(0, 2) -
                  12 +
                  scheduledTime.substring(2) +
                  " PM";
              } else {
                scheduledTime = scheduledTime + " AM";
              }

              customer_schedule =
                "at " +
                scheduledTime +
                " on " +
                localStorage.getItem("charleys_customer_scheduled_day");
            } else {
              customer_schedule = customer_schedule.toUpperCase();
            }
            $("[data-menu-handoff-time]").text(customer_schedule);

            // show formatted store hours
            var hoursCalendar;
            var calendarMatched = false;

            // if there is a specific calendar of hours for this delivery type (e.g. dispatch), use it
            // restaurant_data.calendar.every(function (calendar) {
            //   if (
            //     calendar.type ==
            //     localStorage.getItem("charleys_customer_deliverymode")
            //   ) {
            //     hoursCalendar = calendar;
            //     calendarMatched = true;
            //   }
            //
            //   return !calendarMatched;
            // });

            // otherwise use the regular business hours
            // if (calendarMatched == false) {
            //   restaurant_data.calendar.every(function (calendar) {
            //     if (calendar.type == "business") {
            //       hoursCalendar = calendar;
            //       calendarMatched = true;
            //     }
            //
            //     return !calendarMatched;
            //   });
            // }

            // format the stupid nonstandard olo dates
            // var startDateRaw = hoursCalendar.ranges[0].start;
            // var endDateRaw = hoursCalendar.ranges[0].end;
            //
            // var jsStartDate = new Date(
            //   startDateRaw.substring(0, 4),
            //   startDateRaw.substring(4, 6),
            //   startDateRaw.substring(6, 8),
            //   startDateRaw.substring(9, 11),
            //   startDateRaw.substring(12, 14),
            //   0,
            //   0
            // );
            // var jsEndDate = new Date(
            //   endDateRaw.substring(0, 4),
            //   endDateRaw.substring(4, 6),
            //   endDateRaw.substring(6, 8),
            //   endDateRaw.substring(9, 11),
            //   endDateRaw.substring(12, 14),
            //   0,
            //   0
            // );
            //
            // var startTimeFormatted = jsStartDate.toLocaleString("en-US", {
            //   hour: "numeric",
            //   minute: "numeric",
            //   hour12: true,
            // });
            // var endTimeFormatted = jsEndDate.toLocaleString("en-US", {
            //   hour: "numeric",
            //   minute: "numeric",
            //   hour12: true,
            // });
            //
            // $(".store-hours").text(
            //   "Hours " + startTimeFormatted + " - " + endTimeFormatted
            // );
            //
            // $("[data-store-info]").removeClass("hide");
          });

          // result.vendorid

          // Set Lead Time
          var leadTime = result.leadtimeestimateminutes;
          if (Number(leadTime) > 60) {
            var leadTimeHours = Math.floor(Number(leadTime) / 60);
            var leadTimeMinutes = Number(leadTime) - leadTimeHours * 60;
            leadTime = leadTimeHours + " hrs";
            if (leadTimeMinutes > 0) {
              leadTime += " " + leadTimeMinutes + " mins";
            }
          } else {
            leadTime += " mins";
          }
          $("[data-leadtimeestimateminutes]").text("(" + leadTime + " est.)");
          // Set Time wanted
          if (result.timewanted && result.deliverymode == "dispatch") {
            // console.log(result.timewanted);
            var timeWantedString =
              result.timewanted.slice(0, 4) +
              "-" +
              result.timewanted.slice(4, 6) +
              "-" +
              result.timewanted.slice(6, 8) +
              "T" +
              result.timewanted.slice(9, 14) +
              ":00";
            // console.log(timeWantedString);
            var timeWanted = new Date(timeWantedString);
            var timeWantedDisplay =
              timeWanted.toLocaleDateString("en-US") +
              " at " +
              timeWanted.toLocaleTimeString("en-US");

            $("[data-timemode]").text(
              result.timemode.toUpperCase() + " (" + timeWantedDisplay + ")"
            );
            $("[data-leadtimeestimateminutes]").text(
              "(" + timeWantedDisplay + ")"
            );
          }

          // Basket Products
          if (result.products.length) {
            // Display upsell Items
            if ($("[data-cart-upsell-items]").length) {
              $.ajax({
                type: "POST",
                url: ajax_url,
                data: {
                  action: "olo_get_basket_upsell_items",
                  basketGuid: localStorage.getItem(
                    "charleys_customer_basket_id"
                  ),
                },
                success: function (response) {
                  var upsells = JSON.parse(response);

                  // Testing Upsell Items
                  //if(true) {
                  //   upsells = JSON.parse('{"groups": [{"title": "Desserts","items": [{"id": 416618,"name": "Green Tea","cost": "3.19","shortdescription": "A lightly sweetened mix of citrus & green tea flavors.","minquantity": 1,"maxquantity": 12}, {"id": 15510697,"name": "Spindrift - Blackberry","cost": "2.19","shortdescription": "Sparkling water with a touch of real blackberry juice","minquantity": 1,"maxquantity": 12}]}]}');
                  //}

                  // console.log('upsells: ', upsells);

                  // Clear upsell display
                  var $upsellContainer = $("[data-cart-upsell-items-list]");
                  $upsellContainer
                    .find("[data-cart-upsell-item]:not(.hide)")
                    .each(function () {
                      $(this).remove();
                    });

                  if (upsells.groups.length) {
                    $("#cart-upsell-items-list.slick-initialized").slick(
                      "unslick"
                    );
                    $("[data-cart-upsell-item]:not(.hide)").remove();

                    var itemAdded = false;

                    $.each(upsells.groups, function (key, group) {
                      $.each(group.items, function (key, item) {
                        // if (item.cost !== "$0.00") {
                        var $upsellItem = $(
                          "[data-cart-upsell-item].hide"
                        ).clone();

                        if ("images" in item) {
                          $.each(item.images, function (key, image) {
                            if (image.groupname == "mobile-webapp-menu") {
                              $upsellItem.find(".product-image").css({
                                "background-image":
                                  "url(" +
                                  upsells.imagepath +
                                  image.filename +
                                  ")",
                              });
                            }
                          });
                        }

                        $upsellItem
                          .find("[data-product-title]")
                          .text(toTitleCase(item.name));

                        $upsellItem
                          .find("[data-add-upsell-to-cart]")
                          .attr("data-item-id", item.id);

                        $upsellItem
                          .find("[data-description]")
                          .text(item.shortdescription);
                        if (item.cost !== "$0.00") {
                          $upsellItem
                            .find("[data-price]")
                            .html(
                              item.cost.replace("$", "$") +
                              "<small>/ea.</small>"
                            );
                        } else {
                          $upsellItem.find("[data-price]").remove();
                        }

                        $upsellItem.removeClass("hide");
                        $upsellContainer.append($upsellItem);

                        itemAdded = true;

                        $upsellItem
                          .find("[data-add-upsell-to-cart]")
                          .click(function () {
                            charleys_show_loading();

                            let productId = $(this).attr("data-item-id");
                            $.ajax({
                              type: "POST",
                              url: ajax_url,
                              data: {
                                action: "get_olo_get_menu_options",
                                productId: productId,
                              },
                              success: function (response) {
                                // console.log('Raw Response:', response);

                                var optionGroups =
                                  JSON.parse(response).optiongroups;
                                // if product is customizable
                                if (optionGroups.length > 0) {
                                  // open as product detail item
                                  change_view("menu__" + productId);
                                } else {
                                  // else add directly as upsell item
                                  $.when(
                                    olo_add_upsell_items(productId, 1)
                                  ).done(function (upsell_item_json) {
                                    charleys_hide_loading();
                                    // console.log(upsell_item_json);
                                    updateBasketDisplay(true);
                                  });
                                }
                              },
                            });
                          });
                        // }
                      });
                    });

                    if (itemAdded) {
                      $("[data-cart-upsell-items]").removeClass("hide");
                    }

                    $("#cart-upsell-items-list").slick({
                      infinite: true,
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      dots: true,
                      autoplay: false,
                      responsive: [
                        {
                          breakpoint: 1025,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                          }
                        }
                      ]
                    });
                  } else {
                    $("[data-cart-upsell-items]").addClass("hide");
                  }
                },
              });
            }

            if (result.deliverymode == "dispatch") {
              $(".location-order-details [data-row-deliverymode]").text(
                "Delivery"
              );
              // $(".location-order-details [data-store-address]").text(restaurant_data.streetaddress);
            } else {
              $(".location-order-details [data-row-deliverymode]").text(
                "Pickup"
              );
              // $(".location-order-details [data-store-address]").text(restaurant_data.streetaddress);
            }
            canCheckout = true;
            $(".shopping-cart-icon [data-counter]").text(
              result.products.length
            );
            $(".shopping-cart-icon [data-counter]").removeClass("hide");

            //get product image call
            let restaurant_id = localStorage.getItem("charleys_customer_store_location_id");

            for (var i = 0; i < result.products.length; i++) {
              var $cartProduct = $(
                "[data-cart-product-template].hide:first"
              ).clone();

              var product = result.products[i];

              // console.log('product', product);
              //get product image
              $cartProduct
                .find("[data-product-img]")
                .attr("id", product.productId);
              // Check if the product.id is already in productsOrderImgs
              let productsIdForGettingImg = product.productId;
              let productsOrderImgs = JSON.parse(localStorage.getItem('productsOrderImgs')) || [];
              let productsOrderMetaData = JSON.parse(localStorage.getItem('productsOrderMetaData')) || [];
              let existingProduct = productsOrderImgs.find(item => item.id === productsIdForGettingImg);
              let existingProductMetaData = productsOrderMetaData.find(item => item.id === productsIdForGettingImg);

              if (existingProduct && existingProductMetaData) {
                // console.log('The variable productsIdForGettingImg exists in local storage.');
                $cartProduct.find("[data-product-img]").attr("src", existingProduct.imagePath).removeClass("hide");
              } else if (restaurant_id) {
                // console.log('Call ajax for productsIdForGettingImg');

                // Initialize the productsOrderImgs array
                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "get_olo_get_menu",
                    restaurant_id: restaurant_id,
                  },
                  success: function (response) {
                    let rawProductData = JSON.parse(response);
                    // console.log('Raw Response:', rawProductData);
                    function getMenuItemImages(categoryType) {
                      // console.log('categories', categoryType);
                      if (categoryType && categoryType.length > 0) {
                        categoryType.forEach(category => {
                          if (category.products && category.products.length > 0) {
                            // Iterate over products within each category
                            category.products.forEach(product => {
                              // Check if the product ID is in the productsIdForGettingImg array
                              if (productsIdForGettingImg === product.id) {
                                let formattedImagePath;
                                let productsOrderImgs = JSON.parse(localStorage.getItem('productsOrderImgs')) || [];
                                let productsOrderMetaData = JSON.parse(localStorage.getItem('productsOrderMetaData')) || [];
                                // product.metadata.forEach((item) => console.log('Metadata Value:', item.value));                                
                                if (product.imagefilename) {
                                  // console.log('Image Filename:', rawProductData.imagepath + product.imagefilename);
                                  formattedImagePath = rawProductData.imagepath + product.imagefilename;
                                  $("#" + product.id + "[data-product-img]")
                                    .attr("src", formattedImagePath).removeClass("hide");
                                  // console.log('cart', "#" + product.id + "[data-product-img]");
                                } else {
                                  formattedImagePath = '/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg';
                                  $("#" + product.id + "[data-product-img]")
                                    .attr("src", formattedImagePath).removeClass("hide");
                                }
                                if (product.metadata) {
                                  formattedMetaData = product.metadata.map(item => item.value);
                                  // console.log('formattedMetaData', formattedMetaData);
                                  if (formattedMetaData[0] === 'Hide indent values of 2 and above') {
                                    $("span[regular-option]").parent().addClass('hide');
                                  }
                                } else {
                                  formattedMetaData = null;
                                }
                                productsOrderImgs.push({
                                  id: product.id,
                                  imagePath: formattedImagePath
                                });
                                productsOrderMetaData.push({
                                  id: product.id,
                                  metaDataValue: formattedMetaData
                                });
                                // Store the productsOrderImgs array in local storage
                                localStorage.setItem('productsOrderImgs', JSON.stringify(productsOrderImgs));
                                localStorage.setItem('productsOrderMetaData', JSON.stringify(productsOrderMetaData));
                                // console.log('Stored productsOrderImgs in local storage:', productsOrderImgs);
                                // console.log('Stored productsOrderMetaData in local storage:', productsOrderMetaData);
                              }
                            });
                          } else {
                            // console.log('No products found in this category');
                          }

                        });
                      }
                    }
                    getMenuItemImages(rawProductData.categories);
                    getMenuItemImages(rawProductData.singleusecategories);


                  }
                });
              } else {
                // console.log('no work ;(');
              }


              //end of get product image

              var recipient = "";
              if (product.recipient) {
                var recipientSpan = $('<span>').text(product.recipient);
                $cartProduct.find("[data-recipient]").empty().append(recipientSpan);
              }

              $cartProduct
                .find("[data-qty]")
                .text(product.quantity);
              // if (product.quantity > 1) {
              //   $cartProduct.find("[data-qty]").removeClass("hide");
              // } else {
              //   $cartProduct.find("[data-qty]").addClass("hide");
              // }

              // Add select option for qty over 9
              //  may want to add incremental options from 9 to destination quantity?
              // console.log('product', product);
              if (product.quantity > 9) {
                $cartProduct
                  .find("[data-qty-cart-update]")
                  .append('<option>' + product.quantity + '</option>');
              }

              $cartProduct
                .find("[data-qty-cart-update]")
                .val(product.quantity);

              // Add some details
              $cartProduct
                .find("[data-qty-cart-update]")
                .attr("data-product-id", product.id)
                .attr("data-product-choices", JSON.stringify(product.choices))
                .attr('data-product-recipient', product.recipient);

              // Actin for quantity change
              $cartProduct.find("[data-qty-cart-update]").change(function () {

                charleys_show_loading();

                var productSelectionsQty = {
                  productid: Number($(this).attr("data-product-id")),
                  quantity: Number($(this).val()),
                  choices: [],
                  recipient: $(this).attr('data-product-recipient')
                };

                var choiceJSON = JSON.parse($(this).attr("data-product-choices"));

                for (let j = 0; j < choiceJSON.length; j++) {
                  var choiceQty = choiceJSON[j].quantity;
                  var choiceID = choiceJSON[j].optionid;

                  var choice = {
                    quantity: choiceQty,
                    choiceid: choiceID,
                  };

                  productSelectionsQty.choices.push(choice);
                }

                productSelectionsQty = {
                  products: [productSelectionsQty]
                };

                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "olo_update_basket_product",
                    productSelections: JSON.stringify(productSelectionsQty),
                    basketGuid: localStorage.getItem("charleys_customer_basket_id"),
                  },
                  success: function (response) {
                    // console.log('update basket response', response);
                    // console.log(JSON.parse(response));
                    var result = JSON.parse(response);
                    if (
                      result.errors &&
                      result.errors.length > 0 &&
                      result.errors[0].message.includes("Please enter a valid quantity between")
                    ) {
                      // Extract the "between # and #" part using a regular expression
                      let match = result.errors[0].message.match(/between (\d+) and (\d+)/);

                      if (match) {
                        // Get the numbers from the regex match
                        let min = match[1];
                        let max = match[2];
                        if (min === max) {
                          alert(`You can only have ${min} of this item in your cart.`);
                        } else {
                          alert(`You can only have between ${min} and ${max} of this item in your cart.`);
                        }
                        // Display the alert with the extracted values
                      }
                    }
                  },
                  error: function () {
                    // Log error details
                    // console.log("AJAX request failed:");
                  },
                  complete: function () {
                    // Close menu selection modal
                    $("#product-detail-view").foundation("close");
                    // Reset the current state to the menu view
                    if (window.location.hash !== "#menu-product-view") {
                      history.replaceState({}, "", "#menu");
                    }
                    updateBasketDisplay(true);
                    charleys_hide_loading();
                  },
                });

              });




              $cartProduct
                .find("[data-product-edit-url]")
                .attr("href", "#menu_" + product.id + "_" + product.productId);

              $cartProduct
                .find("[data-product-edit-url]")
                .attr("data-product-id", product.productId);
              $cartProduct
                .find("[data-product-edit-url]")
                .attr("data-product-choices", JSON.stringify(product.choices));
              //combo upsell stuff 
              if (product.choices) {
                product.choices.forEach(function (choice) {
                  if (choice.name === "No" && (choice.indent === 1 || choice.indent === 0)) {
                    // console.log('display combo upsell');
                    $cartProduct
                      .find("[data-product-edit-url][data-make-it-a-combo-upsell]")
                      .removeClass('hide')
                      .on('click', function () {
                        // Before navigating to the new page, set the scroll flag
                        localStorage.setItem('scrollToComboModifier', 'true');
                        localStorage.setItem('scrollToComboModifierOptions', JSON.stringify(product.choices));
                      });
                  }
                });
              }

              $cartProduct
                .find("[data-product-name]")
                .text(
                  product.name.toLowerCase().replace(/\b(?!\()[a-z]/g, function (char, index, fullText) {
                    // Check if the character is inside parentheses
                    if (fullText[index - 1] !== "(") {
                      return char.toUpperCase(); // Capitalize the letter if not inside parentheses
                    } else {
                      return char; // Leave the letter as lowercase if inside parentheses
                    }
                  })
                );

              $cartProduct
                .find("[data-price]")
                .text("$" + formatMoney(product.totalcost));

              if (product.choices && product.choices.length) {
                // console.log('product.choices', product.choices);
                let productsOrderMetaData = JSON.parse(localStorage.getItem('productsOrderMetaData'));
                hideAtIndentOf2 = false;

                if (productsOrderMetaData) {
                  let existingProductMetaData = productsOrderMetaData.find(product => product.id === productsIdForGettingImg);
                  if (existingProductMetaData && existingProductMetaData.metaDataValue && existingProductMetaData.metaDataValue[0] === 'Hide indent values of 2 and above') {
                    hideAtIndentOf2 = true;
                    // console.log('hideAtIndentOf2', hideAtIndentOf2);
                  }
                }


                // console.log('hideAtIndentOf2', hideAtIndentOf2);
                var $dataChoicesContainer = $cartProduct.find("[data-choices]");
                var $dataSizeChoiceContainer = $cartProduct.find("[data-size-choice]");

                // Clear the containers first
                $dataChoicesContainer.empty();
                $dataSizeChoiceContainer.empty();

                // Initialize variables to hold the choices
                let currentGroup = [];
                let firstIndentOneName = null;
                let firstIndentOneProcessed = false; // Flag to track first indent 1

                // Define special names where we want a colon instead of a comma
                var colonNames = ['Regular', 'Small', 'Large', 'Extra', 'None', 'Lite', 'Place on the Side'];

                // Loop through the product.choices
                for (let ii = 0; ii < product.choices.length; ii++) {
                  let choice = product.choices[ii];
                  let choiceName = choice.name;

                  // Handle indent of 0
                  if (choice.indent === 0) {
                    if (choiceName.toLowerCase() === "yes" || choiceName.toLowerCase() === "no") {
                      // console.log('Handling "Yes" or "No":', choiceName);
                      firstIndentOneName = true;
                    } else if (choiceName.toLowerCase() !== "product size") {
                      $dataSizeChoiceContainer.append('<p>' + choiceName + '</p>');
                    }
                    continue; // Skip further processing for indent 0
                  }

                  // Handle indent of 1
                  if (choice.indent === 1) {
                    // Update the first indent 1 name if not already set
                    if (!firstIndentOneProcessed && firstIndentOneName) {
                      $dataSizeChoiceContainer.append('<p>' + choiceName + '</p>');
                      firstIndentOneProcessed = true; // Set flag to true after processing
                    } else if (choiceName === 'Regular') {

                    } else {
                      // If there's an existing group, append it to the DOM
                      if (currentGroup.length > 0) {
                        // console.log('choiceName', choice.name);
                        $dataChoicesContainer.append('<p class="bullet" data-choices>' + currentGroup.join(', ') + '</p>');
                      }

                      // Start a new group with the current choice name
                      currentGroup = [choiceName];
                    }
                  } else if (choice.indent > 1) {
                    // Check if the choice name should use a colon or comma as a separator
                    if (colonNames.includes(choiceName)) {
                      // console.log('sdfgasdg', choiceName, choice.indent);
                      // Append the last item with a colon and start a new group with this choice
                      if ((choice.indent === 3 && choiceName.includes('Regular')) || (hideAtIndentOf2 === true && choiceName.includes('Regular'))) {
                        let lastChoice = currentGroup.pop();
                        const index = currentGroup.indexOf(lastChoice);
                        if (index > -1) {
                          currentGroup.splice(index, 1);  // Removes the lastChoice from the array
                        }
                      } else if (choiceName.includes('Regular')) {
                        let lastChoice = currentGroup.pop();
                        currentGroup.push('<span regular-option class="' + product.productId + ' ">' + lastChoice + ': ' + choiceName + '</span>');
                      } else if (currentGroup.length > 0) {
                        let lastChoice = currentGroup.pop();
                        currentGroup.push(lastChoice + ': ' + choiceName);
                      } else {
                        currentGroup.push(choiceName + '');
                      }
                    } else {
                      currentGroup.push(choiceName);
                    }
                  }
                }

                // After the loop, append the last group if it exists
                if (currentGroup.length > 0) {
                  // console.log('currentGroup', currentGroup);
                  $dataChoicesContainer.append('<p class="bullet" data-choices>' + currentGroup.join(', ') + '</p>');
                }
              }
              else {
                $cartProduct.find("[data-choices]").addClass("hide");
                $cartProduct.find(".toggle-choices").addClass("hide");
              }


              $cartProduct
                .find("[data-remove-item]")
                .attr("data-product-id", product.id);
              $cartProduct
                .find("[data-remove-item]")
                .attr("data-product-name", product.name);
              $cartProduct
                .find("[data-remove-item]")
                .attr("data-product-price", formatMoney(product.totalcost));
              // if (choices) {
              //   $cartProduct
              //     .find("[data-remove-item]")
              //     .attr("data-product-variant", choices.join(", "));
              // } else {
              //   $cartProduct
              //     .find("[data-remove-item]")
              //     .attr("data-product-variant", "");
              // }

              $cartProduct
                .find("[data-remove-item]")
                .attr("data-product-qty", product.quantity);

              $cartProduct.find("[data-remove-item]").click(function () {
                var productId = Number($(this).attr("data-product-id"));
                var productName = $(this).attr("data-product-name");
                var productPrice = $(this).attr("data-product-price");
                var productVariant = $(this).attr("data-product-variant");
                var productQuantity = Number($(this).attr("data-product-qty"));

                // remove cart item
                charleys_show_loading();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                var addToCartData = {
                  event: "remove_from_cart",
                  ecommerce: {
                    currency: "USD",
                    value: productPrice,
                    items: [
                      {
                        item_id: productId,
                        item_name: productName,
                        affiliation: localStorage.getItem(
                          "charleys_customer_store_location_name"
                        ), //$('[data-menu-selected-store]:first').text(),
                        price: productPrice,
                        item_variant: productVariant,
                        quantity: productQuantity,
                      },
                    ],
                  },
                };
                // console.log("GA4", addToCartData);
                window.dataLayer.push(addToCartData);

                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "olo_remove_from_basket",
                    basketGuid: localStorage.getItem(
                      "charleys_customer_basket_id"
                    ),
                    basketProductId: productId,
                  },
                  success: function (response) {
                    // console.log(response);
                    // console.log(JSON.parse(response));
                    var result = JSON.parse(response);
                  },
                  complete: function () {
                    // refresh cart view
                    updateBasketDisplay();
                  },
                });
              });

              $cartProduct.removeClass("hide");
              $("[data-cart-product-selections]").append($cartProduct);
            }

            //end of get product image call

            $("[data-cart-empty]").addClass("hide");

            $("[data-cart-subtotal]").text("$ " + formatMoney(result.subtotal));
            $("[data-cart-subtotal]").attr(
              "data-cart-subtotal",
              formatMoney(result.subtotal)
            );

            // Display Rewards/Discounts
            if (result.discounts && result.discounts.length) {
              for (var iv = 0; iv < result.discounts.length; iv++) {
                var $taxRow = $('[data-tax-row-template].hide').clone();
                $taxRow.find('[data-label]').text(result.discounts[iv].description);
                $taxRow.find('[data-tax]').text('($ ' + formatMoney(result.discounts[iv].amount) + ')');

                $taxRow.removeClass('hide');
                $('[data-taxes-table]').append($taxRow);
              }
            }
            // console.log('results', result, result.taxes)
            // Display taxes
            if (result.taxes && result.taxes.length) {
              for (var iii = 0; iii < result.taxes.length; iii++) {
                var $taxRow = $("[data-tax-row-template].hide").clone();
                $taxRow.find("[data-label]").text(result.taxes[iii].label);
                $taxRow
                  .find("[data-tax]")
                  .text("$ " + formatMoney(result.taxes[iii].tax));

                $taxRow.removeClass("hide");
                $("[data-taxes-table]").append($taxRow);
              }
            }

            // Display tip
            if (Number(result.tip)) {
              var $taxRow = $("[data-tax-row-template].hide").clone();
              $taxRow.find("[data-label]").text("Tip");
              $taxRow.find("[data-tax]").text("$ " + formatMoney(result.tip));

              $taxRow.removeClass("hide");
              $("[data-taxes-table]").append($taxRow);

              if ($("#custom-tip-amount").length) {
                $("#custom-tip-amount").val(formatMoney(result.tip));
              }
            }

            // Display fees
            if (result.fees && result.fees.length) {
              for (var v = 0; v < result.fees.length; v++) {
                var $taxRow = $("[data-tax-row-template].hide").clone();
                $taxRow.find("[data-label]").text(result.fees[v].amount);
                $taxRow
                  .find("[data-tax]")
                  .text("$ " + formatMoney(result.fees[v].amount));

                $taxRow.removeClass("hide");
                $("[data-taxes-table]").append($taxRow);
              }
            }

            if (result.customerhandoffcharge) {
              var $taxRow = $("[data-tax-row-template].hide").clone();

              $taxRow.find("[data-label]").text("Delivery Fee");
              $taxRow
                .find("[data-tax]")
                .text("$ " + formatMoney(result.customerhandoffcharge));

              $taxRow.removeClass("hide");
              $("[data-taxes-table]").append($taxRow);
            }

            $("[data-cart-grand-total]").attr(
              "data-cart-grand-total",
              formatMoney(result.total)
            );
            $("[data-cart-grand-total]").text("$ " + formatMoney(result.total));

            $("[data-cart-totals]").removeClass("hide");

            // display tip
            if ($("[data-tip-container]").length) {
              if (result.allowstip) {
                // if(true) {
                $("[data-tip-container]").removeClass("hide");
                // console.log("Tip Status: ", result.allowstip);

                if (result.deliverymode == "dispatch") {
                  $("[data-tip-note]").text(" – 100% goes to the driver");
                } else {
                  $("[data-tip-note]").text(
                    " – 100% goes to the restaurant staff"
                  );
                }

                // tip amount display for buttons
                $("[data-tip-amount]").each(function () {
                  var tipAmount =
                    Math.round(
                      (Number(result.subtotal) *
                        100 *
                        (Number($(this).attr("data-tip-amount")) * 100)) /
                      100
                    ) / 100;
                  // $(this).text('$ ' + formatMoney(tipAmount));
                  // $(this).parent().prev().attr('data-amount', tipAmount);
                  $(this).val(tipAmount);
                });

                $("#custom-tip-amount").inputmask({
                  alias: "numeric",
                  allowMinus: false,
                  digits: 2,
                  max: 9999.99,
                });
              } else {
                $("[data-tip-container]").addClass("hide");
              }
            }

            // Custom Fields
            if (
              result.customfields.length &&
              $("[data-custom-fields-info]").length
            ) {
              var customFields = [];
              // filter customf fields to only applicable basket types
              // console.log(result.deliverymode);
              for (var b = 0; b < result.customfields.length; b++) {
                if (
                  result.customfields[b].scope.includes(result.deliverymode) &&
                  result.deliverymode !== "pickup"
                ) {
                  // console.log(result.customfields[b].scope);
                  customFields.push(result.customfields[b]);
                }
              }

              // Put Custom Fields In Order
              customFields.sort(function (a, b) {
                if (a.id < b.id) {
                  return -1;
                }
                if (a.id > b.id) {
                  return 1;
                }
                return 0;
              });

              // console.log("custom fields", customFields);

              // If custom fields are available, display them
              if (customFields.length) {
                for (var c = 0; c < customFields.length; c++) {
                  var $cField = $(
                    "[data-custom-fields-info] [data-custom-fields-form] [data-custom-field-template].hide"
                  ).clone();

                  var fieldLabel = customFields[c].label;

                  $cField
                    .find("input")
                    .attr("data-custom-field-id", customFields[c].id);
                  $cField.find("input").attr("value", customFields[c].value);

                  if (customFields[c].isrequired) {
                    $cField.find("input").prop("required", true);
                    fieldLabel += " *";
                  }
                  $cField.find("[data-custom-field-label]").text(fieldLabel);

                  $cField.removeClass("hide");
                  $(
                    "[data-custom-fields-info] [data-custom-fields-form]"
                  ).append($cField);
                }

                // new Foundation.Abide($('#custom-fields'), {});

                $("[data-custom-fields-info]").removeClass("hide");
                $(
                  "[data-custom-fields-info] [data-custom-fields-form] [data-custom-field-template].hide"
                ).remove();
              }
            }

            var loginRewardsPromptView = '<div class="wf-ordering-login login-form login-wrap">    <a href="#basket" class="close-button" data-open="shopping-cart-view" onclick="return false;" aria-label="Shopping Basket" data-header-ecomm-link="" aria-controls="shopping-cart-view" aria-haspopup="dialog" tabindex="0">      <span aria-hidden="true"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">          <path d="M24.6067 14.0003L14.0001 24.6069L16.1214 26.7283L26.728 16.1217L24.6067 14.0003Z" fill="#252933"></path>          <path d="M26.7277 24.6066L16.1211 14L13.9998 16.1213L24.6064 26.7279L26.7277 24.6066Z" fill="#252933"></path>          <path d="M20 39.5C30.7696 39.5 39.5 30.7696 39.5 20C39.5 9.23045 30.7696 0.5 20 0.5C9.23045 0.5 0.5 9.23045 0.5 20C0.5 30.7696 9.23045 39.5 20 39.5Z" stroke="#252933"></path>        </svg>      </span>      <span class="sr-only">Go back to your basket</span>    </a>    <h2 class="text-left uppercase modal-heading" style="margin:0">Sign In</h2> <p><strong>Don\'t have an account? <br class="hide-for-medium"></strong><a id="rewards-signup"><strong>Join Now</strong></a></p>    <form id="punchh-login-form" novalidate="">      <div data-abide-error="" role="alert" class="alert callout" style="display: none;">        <p><strong>Please correct the errors highlighted in the form below.</strong></p>      </div>      <label><span class="sr-only">Email</span>        <input type="text" id="punchh_email" name="email" pattern="email" placeholder="Email *" required="">        <span class="form-error">Email is required</span>      </label>      <label><span class="sr-only">Password</span>        <input type="password" id="punchh_password" name="password" placeholder="Password *" required="">        <span class="form-error">Password is required</span>      </label>      <input type="hidden" id="basketGuid" name="basketGuid">      <button type="submit" class="button">Login</button>      <p class="text-center"><a id="forgotpassword"><strong>Forgot Password?</strong></a></p>  <div class="small-12 cell text-center">\n<button id="continue-as-guest" class="continue-guest full-width" data-close data-open="guest-signin-prompt">Continue As Guest</button>\n</div></form></div>';

            var signupRewardsPromptView =
              '<div class="wf-ordering-signup signup-form signup-wrap"> <button class="close-button" data-close aria-label="Close modal" type="button"> <span aria-hidden="true"> <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"> <path d="M24.6067 14.0003L14.0001 24.6069L16.1214 26.7283L26.728 16.1217L24.6067 14.0003Z" fill="#252933"/> <path d="M26.7277 24.6066L16.1211 14L13.9998 16.1213L24.6064 26.7279L26.7277 24.6066Z" fill="#252933"/> <path d="M20 39.5C30.7696 39.5 39.5 30.7696 39.5 20C39.5 9.23045 30.7696 0.5 20 0.5C9.23045 0.5 0.5 9.23045 0.5 20C0.5 30.7696 9.23045 39.5 20 39.5Z" stroke="#252933"/> </svg> </span> <span class="sr-only">Close Modal</span> </button> <h2 class="text-left uppercase modal-heading">WELCOME! CREATE YOUR ACCOUNT</h2> <p class="modal-subheading hide">to place your order</p><p> <strong>Already have an account? </strong> <a id="rewards-signin"> <strong>Sign in</strong> </a> </p><form id="punchh-signup-form" novalidate> <div data-abide-error role="alert" class="alert callout" style="display: none;"> <p> <strong>Please correct the errors highlighted in the form below.</strong> </p></div><label> <span class="sr-only">Email</span> <input type="text" id="punchh_email" name="email" pattern="email" placeholder="Email Address *" required/> <span class="form-error">Email is required</span> </label> <label> <span class="sr-only">First Name</span> <input type="text" id="punchh_first_name" name="first_name" placeholder="First Name *" required/> <span class="form-error">First Name is required</span> </label> <label> <span class="sr-only">Last Name</span> <input type="text" id="punchh_last_name" name="last_name" placeholder="Last Name *" required/> <span class="form-error">Last Name is required</span> </label> <label> <span class="sr-only">Mobile Phone Number</span> <input type="text" id="punchh_phone" name="phone" pattern="phoneNumber" placeholder="Mobile # *" required/> <span class="form-error">A valid phone number is required. Ex: (111) 222-3333</span> </label> <label> <span class="sr-only">Password</span> <input type="password" id="punchh_password" name="password" autocomplete="off" pattern="punchh_password" placeholder="Password *" required/> <span class="form-error">Password must be at least 8 characters, including uppercase, lowercase, and a number.</span> </label> <label> <span class="sr-only">Confirm Password</span> <input type="password" id="punchh_password_confirm" name="password_confirm" autocomplete=" off" placeholder="Confirm Password *" data-equalto="punchh_password" required/> <span class="form-error">Passwords must match</span> </label> <p style="margin-top: -10px;"> <strong>At least 8 characters, including uppercase, lowercase, and a number.</strong> </p><p style="font-size:1.1em;line-height:135%;"> <strong>Get $5 off $15+ when you join Charleys Rewards</strong> </p><fieldset class="agreement-section" style="margin-bottom:0"> <legend class="sr-only">Opt-in Agreement</legend> <label class="radio-container grey-bg"> <input type="checkbox" id="punchh_opt-in" name="punchh_opt-in" value="Y"/> <span>I agree to receive recurring automated & personalized marketing text messages (e.g. cart reminders) from Charleys at the cell number used when signing up. Consent not a condition of any purchase. Msg frequency varies. Msg & data rates may apply.</span> </label> </fieldset> <fieldset class="agreement-section"> <legend class="sr-only">Charleys Agreement</legend> <label class="radio-container grey-bg"> <input type="checkbox" id="charleys_opt-in" name="charleys_opt-in" value="Y" required/> <span>I agree to Charleys\' <a href="https://www.charleys.com/terms/" target="_blank">terms and conditions</a> and <a href="https://www.charleys.com/privacy/" target="_blank">privacy policy</a>.</span> </label> </fieldset> <input type="hidden" id="basketGuid" name="basketGuid"> <button type="submit" class="button">Create Your Account</button></form></div>';

            function displaySignInForm() {
              $("#login-rewards-prompt-view").html(loginRewardsPromptView);
              $("#login-rewards-prompt-view").foundation("open");
              activateSignIn($("#login-rewards-prompt-view form"));
              $("#rewards-signup").click(displaySignUpForm);
              $("#forgotpassword").click(function () {
                $("#login-rewards-prompt-view").foundation("close");
                displayForgotPasswordForm();
              });
            }

            function displaySignUpForm() {
              //show signup view
              $("#login-rewards-prompt-view").html(signupRewardsPromptView);
              activateSignUp($("#login-rewards-prompt-view form"));
              //recenter view
              $("#login-rewards-prompt-view").css(
                "top",
                $(window).height() / 2 -
                $("#login-rewards-prompt-view").height() / 2 +
                "px"
              );

              $("#rewards-signin").click(displaySignInForm);
            }

            function displayForgotPasswordForm() {
              $("#forgot-prompt-view").foundation("open");
              activateForgotPassword($("#forgot-prompt-view form"));
              $("#forgot-prompt-view .login-link").click(function () {
                $("#forgot-prompt-view").foundation("close");
                displaySignInForm();
              });
            }

            $(".cart-checkout").off("click");
            // Checkout button
            $(".cart-checkout").click(function () {
              var cartItems = [];
              $(
                "[data-cart-product-selections] .cart-product:not(.hide) .remove-item"
              ).each(function () {
                var productId = Number($(this).attr("data-product-id"));
                var productName = $(this).attr("data-product-name");
                var productPrice = $(this).attr("data-product-price");
                var productVariant = $(this).attr("data-product-variant");
                var productQuantity = Number($(this).attr("data-product-qty"));

                cartItems.push({
                  item_id: productId,
                  item_name: productName,
                  affiliation: localStorage.getItem(
                    "charleys_customer_store_location_name"
                  ), //$('[data-menu-selected-store]:first').text(),
                  price: productPrice,
                  item_variant: productVariant,
                  quantity: productQuantity,
                });
              });

              // GA4 open shopping cart
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ ecommerce: null });
              var ga4Data = {
                event: "begin_checkout",
                ecommerce: {
                  currency: "USD",
                  // 'value': Number($('[data-cart-grand-total]').attr('data-cart-grand-total')),
                  value: Number(
                    $("[data-cart-subtotal]").attr("data-cart-subtotal")
                  ),
                  items: cartItems,
                },
              };
              // console.log("GA4: ", ga4Data);
              window.dataLayer.push(ga4Data);

              // Close Cart
              $("#shopping-cart-view").foundation("close");
              if (localStorage.getItem("charleys_access_token")) {
                // Go to checkout
                change_view("checkout");
              } else {
                // Display login prompt
                displaySignInForm();
                //$('#login-rewards-prompt-view').foundation('open');
              }
            });

            $("#rewards-signup").click(displaySignUpForm);
          } else {
            $(".cart-checkout").off("click");

            if (window.location.hash == "#checkout") {
              change_view("menu");
            }
          } // if(result.products.length)

          setPaymentSplit();

          // Update Applied Reward List
          if (result.appliedrewards.length) {
            updateRewardsList(result.appliedrewards, [
              result.appliedrewards[0].reference,
            ]);
          } else {
            $.when(olo_get_qualifying_rewards()).done(function (
              qual_rewards_json
            ) {
              // console.log(qual_rewards_json);
              var qual_rewards = JSON.parse(qual_rewards_json);

              updateRewardsList(qual_rewards.rewards);
            });
          }

          // Clear displayed coupons
          $(
            "[data-coupon-apply-list] [data-coupon-apply-template]:not(.hide)"
          ).remove();
          $("[data-coupon-description]").addClass("hide");

          // testing coupon display
          // result.coupon = {
          //   "couponcode": "Take20",
          //   "description": "Take 20% off order"
          // };

          // Display Coupons
          if (result.coupon) {
            var $couponItem = $(
              "[data-coupon-apply-list] [data-coupon-apply-template].hide"
            ).clone();
            var $couponDescription = $("[data-coupon-description]");

            $couponItem.attr(
              "aria-label",
              "Click to Remove Coupon: " + result.coupon.couponcode
            );
            $couponItem.attr("data-remove-coupon", result.coupon.couponcode);
            $couponItem.html("<span>" + result.coupon.couponcode + "</span>");
            $couponDescription.text(result.coupon.description);
            $couponDescription.removeClass("hide");

            // $couponItem.text(
            //   "Coupon: " +
            //     result.coupon.couponcode +
            //     " - " +
            //     result.coupon.description
            // );

            $couponItem.removeClass("hide");

            $("[data-coupon-apply-list]").append($couponItem);
            $("[data-coupon-apply-list]").removeClass("hide");
            $("[data-coupon-code-entry]").addClass("hide");

            $couponItem.click(function () {
              // Remove Coupon
              charleys_show_loading();
              $.ajax({
                type: "POST",
                url: ajax_url,
                data: {
                  action: "olo_remove_coupon_from_basket",
                  basketGuid: localStorage.getItem(
                    "charleys_customer_basket_id"
                  ),
                },
                success: function (response) {
                  // console.log(response);
                },
                complete: function () {
                  charleys_hide_loading();
                  updateBasketDisplay();
                },
              });
            });
          } else {
            $("[data-coupon-apply-list]").addClass("hide");
            $("[data-coupon-code-entry]").removeClass("hide");
          }
        } else {
          $("[data-location-order-details]").addClass("hide");
          $("[data-add-another-menu-item]").addClass("hide");
          $("[data-start-a-new-order]").removeClass("hide");

          $("[data-delivery-mode]").text("");
          $("[data-timemode]").text("");
          $("[data-leadtimeestimateminutes]").text("");

          clearBasketSession();
        }
        // charleys_hide_loading();
      },
      complete: function () {
        if (openBasket) {
          $("#shopping-cart-view").foundation("open");
          $(".reveal-overlay").addClass('differnt-popup-overlay');
        } else {
          $(".reveal-overlay").removeClass('differnt-popup-overlay');

        }

        charleys_hide_loading();
      },
    });
  } else {
    // No cart
    $(".shopping-cart-icon [data-counter]").text(0);

    // reset basket
    $("[data-cart-empty]").removeClass("hide");
    $(
      "[data-cart-product-template]:not(.hide), [data-tax-row-template]:not(.hide)"
    ).each(function () {
      $(this).remove();
    });
    $("[data-cart-upsell-items]").addClass("hide");
    $("[data-cart-totals]").addClass("hide");
    $(".shopping-cart-icon [data-counter]").addClass("hide");

    charleys_hide_loading();
  }
} // updateBasketDisplay()

function updateRewardsList(rewards, applied_rewards = []) {
  var $ = jQuery;

  // console.log(rewards, applied_rewards);

  var $rewards_list = $("[data-reward-item-list]");
  var $rewards_list_cart = $("[data-reward-item-list-cart]");

  // Remove any listed rewards
  $rewards_list.find("[data-reward-item-template]:not(.hide)").remove();
  $rewards_list_cart.find("[data-reward-item-template]:not(.hide)").remove();

  if (typeof rewards === "undefined") {
    $("[data-rewards-container]").addClass("hide");
    $("[data-rewards-upsell]").removeClass("hide");
    $("[data-reward-messaging]").addClass("hide");
  } else {
    $("[data-rewards-container]").removeClass("hide");
    $("[data-rewards-upsell]").addClass("hide");
    $("[data-reward-messaging]").removeClass("hide");

  }

  // List rewards
  if (rewards && rewards.length) {
    // Display rewards
    $("[data-reward-not-found]").addClass("hide");
    $rewards_list.removeClass("hide");
    $rewards_list_cart.removeClass("hide");

    $.each(rewards, function (key, reward) {
      var $reward_template = $("[data-reward-item-template].hide").clone();

      $reward_template
        .find("input")
        .attr("id", reward.rewardid + "_" + reward.reference);
      $reward_template.find("input").attr("data-reference", reward.reference);
      $reward_template.find("input").attr("data-rewardid", reward.rewardid);
      $reward_template
        .find("label")
        .attr("for", reward.rewardid + "_" + reward.reference);

      var quanityAvailable = reward.quantityavailable + " ";
      if (quanityAvailable < 2) {
        quanityAvailable = "";
      }
      $reward_template
        .find("label .title")
        .text(quanityAvailable + reward.label);
      $reward_template.find("label .description").text(reward.fineprint);

      if (applied_rewards.includes(reward.reference)) {
        $reward_template.find("input").prop("checked", true);
      }

      $reward_template.removeClass("hide");
      $rewards_list.append($reward_template);

      // for Cart
      $reward_template_cart = $reward_template.clone();
      $reward_template_cart
        .find("input")
        .attr("id", reward.rewardid + "_" + reward.reference + "_cart");
      $reward_template_cart
        .find("label")
        .attr("for", reward.rewardid + "_" + reward.reference + "_cart");
      $rewards_list_cart.append($reward_template_cart);
    });

    // Select Reward
    $rewards_list.find('input[name="reward-selector"]').change(rewardChange);
    $rewards_list_cart
      .find('input[name="reward-selector"]')
      .change(rewardChange);

    function rewardChange() {
      charleys_show_loading();

      // var $selectedReward = $("[data-reward-item-list]").find('input[name="reward-selector"]:checked');
      // var $selectedRewardCart = $("[data-reward-item-list-cart]").find('input[name="reward-selector"]:checked');

      var $isSelected = $(this).prop("checked");

      // console.log($isSelected, $(this).attr("data-reference"));

      if ($isSelected) {
        // apply Reward
        $.when(olo_add_reward_to_basket($(this).attr("data-reference"))).done(
          function (reward_json) {
            // console.log(reward_json);
            var reward = JSON.parse(reward_json);
            if ("code" in reward) {
              // display Error
              // reset reward boxes
              $('input[name="reward-selector"]').each(function () {
                $(this).prop("checked", false);
              });
            } else {
              // Reward Applied.
            }
            // $.when(olo_validate_basket()).done(function (validate_json) {
            //   charleys_hide_loading();
            updateBasketDisplay();
            // });
          }
        );
      } else {
        // Remove Reward
        var applied_reward_ids = [$(this).attr("data-rewardid")];

        if (applied_reward_ids.length) {
          $.when(olo_remove_reward_to_basket(applied_reward_ids[0])).done(
            function (remove_reward_json) {
              // console.log(remove_reward_json);
              // $.when(olo_validate_basket()).done(function (validate_json) {
              //   charleys_hide_loading();
              updateBasketDisplay();
              // });
            }
          );
        }
      }
    }
  } else {
    // No rewards Available
    $("[data-reward-not-found]").removeClass("hide");
    $rewards_list.addClass("hide");
    $rewards_list_cart.addClass("hide");
  }
}

function olo_add_upsell_items(itemid, quantity) {
  var $ = jQuery;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  var itemPrice = Number(
    $(
      'button[data-add-upsell-to-cart][data-item-id="' +
      itemid +
      '"] .product-details [data-price]'
    )
      .first()
      .text()
      .replace("$ ", "")
      .replace("/ea.", "")
  );
  var addToCartData = {
    event: "add_to_cart",
    ecommerce: {
      currency: "USD",
      value: itemPrice,
      items: [
        {
          item_id: itemid,
          item_name: $(
            'button[data-add-upsell-to-cart][data-item-id="' +
            itemid +
            '"] .product-details [data-product-title]'
          )
            .first()
            .text(),
          affiliation: localStorage.getItem(
            "charleys_customer_store_location_name"
          ), //$('[data-menu-selected-store]:first').text(),
          price: itemPrice,
          item_variant: "Upsell",
          quantity: quantity,
        },
      ],
    },
  };
  // console.log("GA4:", addToCartData);
  window.dataLayer.push(addToCartData);

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_add_upsell_items",
      basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      itemid: itemid,
      quantity: quantity,
    },
    success: function (response) { },
    complete: function () { },
  });
}

function olo_create_basket(vendorid, supportsbaskettransfers, reset = false) {
  var $ = jQuery;

  var existingbasketguid = localStorage.getItem("charleys_customer_basket_id");
  var existingvendorid = localStorage.getItem(
    "charleys_customer_store_location_id"
  );

  // console.log("New: " + vendorid, "Existing: " + existingvendorid);

  // Freshen Store Info
  // localStorage.setItem('charleys_customer_location_name', $(this).attr('data-location-name'));
  // localStorage.setItem('charleys_customer_location_address', $(this).attr('data-location-address'));
  // localStorage.setItem('charleys_customer_location_city_zip', $(this).attr('data-location-city-zip'));

  if (
    existingbasketguid &&
    existingvendorid !== vendorid &&
    supportsbaskettransfers
  ) {
    // If basket exists but store has changed, transfer basket to new store.
    // console.log("Transfer Basket");

    localStorage.setItem("charleys_customer_store_location_id", vendorid);

    $.when(olo_get_restaurant(vendorid)).done(function (restaurant_json) {
      var restaurant = JSON.parse(restaurant_json);
      localStorage.setItem(
        "charleys_customer_store_location_name",
        restaurant.name
      );
      hideFakeMenuIfAddedLocation();

    });

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_transfer_basket",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
        vendorid: vendorid,
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        // var result = JSON.parse(response);
        //
        // if(result.id) {
        //   return result.id;
        // }
        var result = JSON.parse(response);
        // Pick up new Basket ID
        if (result.basket.id) {
          localStorage.setItem("charleys_customer_basket_id", result.basket.id);
          updateBasketDisplay();
          return result.basket.id;
        }
      },
      complete: function () { },
    });
  } else if (existingbasketguid && existingvendorid == vendorid && !reset) {
    // if basket and store match session values, return basket
    // console.log("Basket Exists and Matches Current Vendor, return existing");

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_get_basket",
        basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        // var result = JSON.parse(response);
        //
        // if(result.id) {
        //   return result.id;
        // }
      },
      complete: function () { },
    });
  } else {
    // Create fresh basket
    // console.log("Create a fresh basket");
    localStorage.setItem("charleys_customer_store_location_id", vendorid);

    $.when(olo_get_restaurant(vendorid)).done(function (restaurant_json) {
      var restaurant = JSON.parse(restaurant_json);
      localStorage.setItem(
        "charleys_customer_store_location_name",
        restaurant.name
      );
      hideFakeMenuIfAddedLocation();
    });

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "olo_create_basket",
        vendorid: vendorid,
      },
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        var result = JSON.parse(response);

        if (result.id) {
          localStorage.setItem("charleys_customer_basket_id", result.id);
          updateBasketDisplay();
          return result.id;
        }
      },
      complete: function () { },
    });
  }
}

function olo_check_delivery_coverage(restaurants, view_context) {
  var $ = jQuery;

  var delivery_details = {
    handoffmode: $(
      'input[name="' + view_context + '-order-type"]:checked'
    ).val(), //$('input[name="order-type"]:checked').val(),
    timewantedmode: $(
      'input[name="' + view_context + '-order-schedule"]:checked'
    ).val(),
    street: $(
      "#" + view_context + "-order-location-search-streetaddress"
    ).val(),
    city: $("#" + view_context + "-order-location-search-city").val(),
    zipcode: $("#" + view_context + "-order-location-search-zipcode").val(),
  };

  if (delivery_details.timewantedmode !== "asap") {
    delivery_details.timewantedutc =
      $("#" + view_context + "-time-wanted-day")
        .val()
        .replace(/-/g, "") +
      " " +
      $("#" + view_context + "-time-wanted-time-slot").val(); // yyyymmdd hh:mm
  }

  // console.log("delivery_details", delivery_details);

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_check_delivery_coverage",
      restaurants: restaurants,
      delivery_details: delivery_details,
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      // var result = JSON.parse(response);
    },
    complete: function () { },
  });
}

function olo_get_restaurant(vendorid, getCalendar = false) {
  var $ = jQuery;

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_restaurant",
      restaurant_id: vendorid,
      get_calendar: getCalendar,
    },
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      // var result = JSON.parse(response);
    },
    complete: function () { },
  });
}

function olo_set_basket_settings(
  view_context,
  earliestReadyTime = "",
  leadtimeminutes = 0
) {
  var $ = jQuery;

  var scheduleDate = "";
  var scheduleTime = "";

  if ($("#" + view_context + "-time-wanted-day").val()) {
    scheduleDate = $("#" + view_context + "-time-wanted-day")
      .val()
      .split("-");
  }
  if ($("#" + view_context + "-time-wanted-time-slot").val()) {
    scheduleTime = $("#" + view_context + "-time-wanted-time-slot")
      .val()
      .split(":");
  }

  // Set Handoff /baskets/{basketGuid}/deliverymode
  // Set Delivery Address /baskets/{basketGuid}/deliveryaddress
  // Set Time Wanted (schedule) /baskets/{basketGuid}/timewanted

  var deliverymode = $(
    'input[name="' + view_context + '-order-type"]:checked'
  ).val();

  var apiData = {
    action: "olo_set_basket_settings",
    basketGuid: localStorage.getItem("charleys_customer_basket_id"),
    // deliverymode: $('input[name="order-type"]:checked').val(),
    deliverymode: deliverymode,
    deliveryaddress: {
      streetaddress: $(
        "#" + view_context + "-order-location-search-streetaddress"
      ).val(),
      city: $("#" + view_context + "-order-location-search-city").val(),
      zipcode: $("#" + view_context + "-order-location-search-zipcode").val(),
      building: $("#" + view_context + "-order-location-search-building").val(),
    },
    schedule: $(
      'input[name="' + view_context + '-order-schedule"]:checked'
    ).val(),
  };

  if (apiData.schedule !== "asap") {
    apiData.timewanted = {
      ismanualfire: false,
      year: scheduleDate[0],
      month: scheduleDate[1],
      day: scheduleDate[2],
      hour: scheduleTime[0],
      minute: scheduleTime[1],
    };
  } else {
    apiData.timewanted = {};
    // Determine earliest available time
    var d = new Date(),
      currentTime =
        [
          d.getFullYear(),
          (d.getMonth() + 1).padLeft(),
          d.getDate().padLeft(),
        ].join("") +
        " " +
        [d.getHours().padLeft(), d.getMinutes().padLeft()].join(":");

    // console.log(
    //   currentTime,
    //   earliestReadyTime,
    //   leadtimeminutes,
    //   currentTime < earliestReadyTime
    // );

    /*if(currentTime < earliestReadyTime) {
      apiData.schedule = "advance";
      var pickupTime = new Date(earliestReadyTime.substr(0,4) + '-' +
                                earliestReadyTime.substr(4,2) + '-' +
                                earliestReadyTime.substr(6,2) + ' ' +
                                earliestReadyTime.substr(9,2) + ':' +
                                earliestReadyTime.substr(12,2))
                                .getTime() + (leadtimeminutes * 60000);

      pickupTime = new Date(pickupTime);

      apiData.timewanted = {
        ismanualfire: false,
        year: pickupTime.getFullYear(),
        month: (pickupTime.getMonth()+1).padLeft(),
        day: pickupTime.getDate().padLeft(),
        hour: pickupTime.getHours().padLeft(),
        minute: pickupTime.getMinutes().padLeft()
      };

      // Add lead time in minutes for dispatch
      if(apiData.deliverymode == 'dispatch') {
        var deliveryTime = new Date(apiData.timewanted.year + '-' +
                                    apiData.timewanted.month + '-' +
                                    apiData.timewanted.day + ' ' +
                                    apiData.timewanted.hour + ':' +
                                    apiData.timewanted.minute)
                                    .getTime() + (leadtimeminutes * 60000);

        var newDeliveryTime = new Date(deliveryTime);

        apiData.timewanted.year = newDeliveryTime.getFullYear();
        apiData.timewanted.month = (newDeliveryTime.getMonth()+1).padLeft();
        apiData.timewanted.day = newDeliveryTime.getDate().padLeft();
        apiData.timewanted.hour = newDeliveryTime.getHours().padLeft();
        apiData.timewanted.minute = newDeliveryTime.getMinutes().padLeft();
      }

      localStorage.setItem('charleys_customer_schedule', apiData.schedule);
      localStorage.setItem('charleys_customer_scheduled_day', apiData.timewanted.year + '-' + apiData.timewanted.month + '-' + apiData.timewanted.day);
      localStorage.setItem('charleys_customer_scheduled_time', apiData.timewanted.hour + ':' + apiData.timewanted.minute);
    }*/
  }

  // console.log(apiData);

  return $.ajax({
    type: "POST",
    url: ajax_url,
    data: apiData,
    success: function (response) {
      // console.log(response);
      // console.log(JSON.parse(response));
      // var result = JSON.parse(response);
    },
    complete: function () { },
  });
}

function olo_set_delivery_instructions() {
  var $ = jQuery;
  if (localStorage.getItem("charleys_customer_deliverymode") == "dispatch") {
    var apiData = {
      action: "olo_set_delivery_instructions",
      basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      deliveryaddress: {
        streetaddress: localStorage.getItem(
          "charleys_customer_address_streetaddress"
        ),
        city: localStorage.getItem("charleys_customer_address_city"),
        zipcode: localStorage.getItem("charleys_customer_address_zipcode"),
        building: localStorage.getItem("charleys_customer_address_building"),
        phonenumber: $("[data-customer-phone]").text().replace(/\D/g, ""),
        specialinstructions: $("#checkout-delivery-instructions").val(),
      },
    };

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: apiData,
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        // var result = JSON.parse(response);
      },
      complete: function () { },
    });
  } else {
    return false;
  }
}

function olo_set_custom_fields() {
  var $ = jQuery;
  if (
    $("[data-custom-fields-info]:not(.hide)").length &&
    $("[data-custom-field-template]:not(.hide)").length
  ) {
    var apiData = {
      action: "olo_set_custom_fields",
      basketGuid: localStorage.getItem("charleys_customer_basket_id"),
      customFields: [],
    };

    $("[data-custom-field-template]:not(.hide)").each(function () {
      apiData.customFields.push({
        id: $(this).find("input").attr("data-custom-field-id"),
        value: $(this).find("input").val(),
      });
    });

    return $.ajax({
      type: "POST",
      url: ajax_url,
      data: apiData,
      success: function (response) {
        // console.log(response);
        // console.log(JSON.parse(response));
        // var result = JSON.parse(response);
      },
      complete: function () { },
    });
  } else {
    return false;
  }
}

// function olo_create_basket(vendorid) {
//   var $ = jQuery;
//
//   charleys_show_loading();
//
//   var deliveryaddress = {};
//
//   if(deliverymode == 'delivery') {
//     deliveryaddress = {
//       building: '',
//       streetaddress: '',
//       city: '',
//       zipcode: ''
//     };
//   }
//
//   // Create Basket /baskets/create
//   $.ajax({
//     type: 'POST',
//     url: ajax_url,
//     data: {
//       action : 'olo_create_basket',
//       vendorid : vendorid,
//       authtoken: localStorage.getItem('charleys_auth_token'),
//       deliverymode: deliverymode,
//       deliveryaddress: deliveryaddress
//     },
//     success: function(response) {
//       console.log(response);
//       var result = JSON.parse(response);
//       if(result.status == "success") {
//
//       }
//     },
//     complete: function() {
//       charleys_hide_loading();
//     }
//   });
//
//   // Set Handoff /baskets/{basketGuid}/deliverymode
//
//   // Set Delivery Address /baskets/{basketGuid}/deliveryaddress
//
//   // Set Time Wanted (schedule) /baskets/{basketGuid}/timewanted
// }

function charleys_show_loading() {
  var $ = jQuery;
  $(".wf-ordering-loading:not(.overloader)").removeClass("hide");
  // console.log("show loader");
}

// A Loader to end all loaders - no function to hide it, so use it only if waiting on a page reload
function charleys_show_overloading() {
  var $ = jQuery;
  var $newloader = $(".wf-ordering-loading").clone();
  $newloader.addClass("overloader");
  $(".wf-ordering").append($newloader);
  $newloader.removeClass("hide");
}
function charleys_hide_overloading() {
  var $ = jQuery;
  var $newloader = $(".wf-ordering-loading");
  // Add the 'hide' class to all matching elements
  $newloader.each(function () {
    $(this).addClass("hide");
  });
}

function charleys_hide_loading() {
  var $ = jQuery;
  $(".wf-ordering-loading:not(.overloader)").addClass("hide");
  // console.log("hide loader");
}

function charleys_show_topnav() {
  var $ = jQuery;
  $(".wf-ordering .wf-ordering-topnav").removeClass("hide");
}

function charleys_hide_topnav() {
  var $ = jQuery;
  $(".wf-ordering .wf-ordering-topnav").addClass("hide");
}

function charleys_show_topnav_location() {
  var $ = jQuery;
  $(".wf-ordering .wf-ordering-topnav .fa-location-dot").removeClass("hide");
}

function charleys_hide_topnav_location() {
  var $ = jQuery;
  $(".wf-ordering .wf-ordering-topnav .fa-location-dot").addClass("hide");
}

function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
}

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

function getDates(startDate, stopDate) {
  var dateArray = new Array();
  var currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate));
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

function zeroPad(num, places) {
  var zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
}

function createQuarterHourIntervals() {
  var earliestToday = new Date();
  earliestToday.setHours(0, 0, 0, 0);
  var from = roundToNearest15(earliestToday);
  var until = from.addDays(1);

  var max = (Math.abs(until - from) / (60 * 60 * 1000)) * 4;
  var time = new Date(from);
  var intervals = []; // more clear name than hours

  // console.log(max);

  for (var i = 0; i < max; i++) {
    intervals.push(formatAMPM(time));
    time.setMinutes(time.getMinutes() + 15);
  }
  return intervals;
}

function roundToNearest15(date = new Date()) {
  const minutes = 15;
  const ms = 1000 * 60 * minutes;

  return new Date(Math.ceil(date.getTime() / ms) * ms);
}

function convert12to24Hour(time) {
  var hours = Number(time.match(/^(\d+)/)[1]);
  var minutes = Number(time.match(/:(\d+)/)[1]);
  var AMPM = time.match(/\s(.*)$/)[1];
  if (AMPM == "pm" && hours < 12) hours = hours + 12;
  if (AMPM == "am" && hours == 12) hours = hours - 12;
  var sHours = hours.toString();
  var sMinutes = minutes.toString();
  if (hours < 10) sHours = "0" + sHours;
  if (minutes < 10) sMinutes = "0" + sMinutes;
  return sHours + ":" + sMinutes;
}

function setQuantityElem($elem, min, max, step) {
  var $input = $elem.find("input.qtyinput");
  var $btnMinus = $elem.find(".qtyminus");
  var $btnPlus = $elem.find(".qtyplus");

  min = Number(min);
  max = Number(max);
  step = Number(step);

  if (min < 1) {
    min = 1;
  }

  if ($input.length && $btnMinus.length && $btnPlus.length) {
    $input.val(min);

    $input.attr("min", min);
    $input.attr("max", max);
    $input.attr("step", step);

    function qtyminus(e) {
      var current = Number($input.val());
      var newval = current - step;
      if (newval < min) {
        newval = min;
      } else if (newval > max) {
        newval = max;
      }
      $input.val(Number(newval));
      $input.trigger("change");
      e.preventDefault();
    }

    function qtyplus(e) {
      var current = Number($input.val());
      var newval = current + step;
      if (newval > max) newval = max;
      $input.val(Number(newval));
      $input.trigger("change");
      e.preventDefault();
    }

    $btnMinus.off("click");
    $btnPlus.off("click");

    $btnMinus.click(qtyminus);
    $btnPlus.click(qtyplus);
  }
}
